(function() {
      const root    = document.getElementById('dicelocke-roller');
      if (!root) return;

      const HERO_BTN      = document.getElementById('dl-hero-btn');
      const HERO_FACE     = document.getElementById('dl-hero-face');
      const HERO_WRAPPER  = document.getElementById('dl-hero-wrapper');
      const RULES_PANEL   = document.getElementById('dl-rules-panel');
      const PARTY_PANEL   = document.getElementById('dl-party-panel');
      const PARTY_ROW     = document.getElementById('dl-party-row');
      const HISTORY_PANEL = document.getElementById('dl-history-panel');

      const SWATCH_ROW   = document.getElementById('dl-swatch-row');

      const ROLLS_VALUE = document.getElementById('dl-rolls-value');
      const ROLLS_INC   = document.getElementById('dl-rolls-inc');
      const ROLLS_DEC   = document.getElementById('dl-rolls-dec');
      const ROLLS_HINT  = document.getElementById('dl-rolls-hint');

      const RESET_BTN           = document.getElementById('dl-reset-btn');

      const TOGGLE_RULES_BTN    = document.getElementById('dl-toggle-rules-btn');
      const MANAGE_BTN          = document.getElementById('dl-manage-btn');
      const TOGGLE_HISTORY_BTN  = document.getElementById('dl-toggle-history-btn');
      const UNLOCK_SLOTS_BTN    = document.getElementById('dl-unlock-slots-btn');

      const RESOURCES_BOX = document.getElementById('dl-resources-box');
      const BACKUP_BOX = document.getElementById('dl-backup-box');
      const EXPORT_BACKUP_BTN = document.getElementById('dl-export-backup-btn');
      const IMPORT_BACKUP_BTN = document.getElementById('dl-import-backup-btn');
      const IMPORT_BACKUP_INPUT = document.getElementById('dl-import-backup-input');
      const BACKUP_STATUS = document.getElementById('dl-backup-status');

      const CINEMATIC_MODE_BTN =
        document.getElementById('dl-cinematic-mode-btn');
      const CINEMATIC_EXIT_BTN =
        document.getElementById('dl-cinematic-exit-btn');

      const RESOURCES_HOME = document.getElementById('dl-resources-home');
      const RESOURCES_TOOLS = document.getElementById('dl-resources-tools');
      const RESOURCE_GAME_TITLE = document.getElementById('dl-resource-game-title');
      const RESOURCE_GAMES_BTN = document.getElementById('dl-resource-games-btn');
      const RESOURCE_GAME_BTNS = document.querySelectorAll('[data-resource-game]');

      const LEVEL_CAPS_BTN = document.getElementById('dl-level-caps-btn');
      const LEVEL_CAPS_VIEW = document.getElementById('dl-level-caps-view');
      const LEVEL_CAPS_TOOLS_BTN = document.getElementById('dl-level-caps-tools-btn');
      const LEVEL_CAPS_TITLE = document.getElementById('dl-level-caps-title');
      const LEVEL_CAPS_DESCRIPTION = document.getElementById('dl-level-caps-description');
      const LEVEL_CAPS_TABLE = document.getElementById('dl-level-caps-table');
      const LEVEL_CAPS_HEAD = document.getElementById('dl-level-caps-head');
      const LEVEL_CAPS_BODY = document.getElementById('dl-level-caps-body');

      const POKEMON_CENTERS_BTN = document.getElementById('dl-pokemon-centers-btn');
      const POKEMON_CENTERS_VIEW = document.getElementById('dl-pokemon-centers-view');
      const POKEMON_CENTERS_TOOLS_BTN = document.getElementById('dl-pokemon-centers-tools-btn');
      const POKEMON_CENTERS_TITLE = document.getElementById('dl-pokemon-centers-title');
      const POKEMON_CENTERS_DESCRIPTION = document.getElementById('dl-pokemon-centers-description');
      const POKEMON_CENTERS_PROGRESS = document.getElementById('dl-pokemon-centers-progress');
      const POKEMON_CENTERS_LIST = document.getElementById('dl-pokemon-centers-list');
      const POKEMON_CENTERS_RESET_BTN = document.getElementById('dl-pokemon-centers-reset-btn');

      const LAST_ROLL_SHOP_BTN = document.getElementById('dl-last-roll-shop-btn');
      const LAST_ROLL_SHOP_CONFIRM = document.getElementById('dl-last-roll-shop-confirm');
      const LAST_ROLL_SHOP_READY_TOOLS_BTN = document.getElementById('dl-last-roll-shop-ready-tools-btn');
      const LAST_ROLL_SHOP_READY_YES_BTN = document.getElementById('dl-last-roll-shop-ready-yes-btn');
      const LAST_ROLL_SHOP_READY_NO_BTN = document.getElementById('dl-last-roll-shop-ready-no-btn');
      const LAST_ROLL_SHOP_VIEW = document.getElementById('dl-last-roll-shop-view');
      const LAST_ROLL_SHOP_TOOLS_BTN = document.getElementById('dl-last-roll-shop-tools-btn');
      const LAST_ROLL_SHOP_STATUS = document.getElementById('dl-last-roll-shop-status');
      const LAST_ROLL_SHOP_CONTENT = document.getElementById('dl-last-roll-shop-content');

      const EFFECTS_BONUS = document.getElementById('dl-effects-bonus-list');
      const EFFECTS_MALUS = document.getElementById('dl-effects-malus-list');

      const HISTORY_LIST    = document.getElementById('dl-history-list');
      
      const SHIELDS_CONTAINER = document.getElementById('dl-shields');

      const TEAM_SLOTS_CONTAINER = document.getElementById('dl-team-slots');
      const BOXED_LIST_UI = document.getElementById('dl-boxed-list-ui');
      const SOUL_SUMMARY = document.getElementById('dl-soul-links-summary');

      const TEAM_PANEL      = document.getElementById('dl-team-panel');
      const BOX_PANEL       = document.getElementById('dl-box-panel');
      const VIEW_BOX_BTN    = document.getElementById('dl-view-box-btn');
      const VIEW_TEAM_BTN   = document.getElementById('dl-view-team-btn');

      const GRAVE_PANEL = document.getElementById('dl-grave-panel');
      const GRAVE_LIST_UI = document.getElementById('dl-graveyard-list-ui');

      const VIEW_GRAVE_BTN  = document.getElementById('dl-view-grave-btn');
      const VIEW_GRAVE_BTN2 = document.getElementById('dl-view-grave-btn-2');
      const GRAVE_VIEW_TEAM_BTN = document.getElementById('dl-grave-view-team-btn');
      const GRAVE_VIEW_BOX_BTN  = document.getElementById('dl-grave-view-box-btn');

      const ROLLS_BOX = document.getElementById('dl-rolls-box');
      const WHITEOUT_BOX = document.getElementById('dl-whiteout-box');
      const WHITEOUT_BTN = document.getElementById('dl-whiteout-btn');
      const WHITEOUT_STATUS = document.getElementById('dl-whiteout-status');
      const WHITEOUT_INTRO = document.getElementById('dl-whiteout-intro');
      const WHITEOUT_CLEAR_BTN = document.getElementById('dl-whiteout-clear-btn');

      const WHITEOUT_PANEL = document.getElementById('dl-whiteout-panel');
      const WHITEOUT_CHOICES = document.getElementById('dl-whiteout-choices');

      const ADD_POKEMON_BTN = document.getElementById('dl-add-pokemon-btn');
      const EDITOR = document.getElementById('dl-pokemon-editor');
      const EDITOR_TITLE = document.getElementById('dl-pokemon-editor-title');
      const FIELD_NAME = document.getElementById('dl-pokemon-name');
      const FIELD_SPECIES = document.getElementById('dl-pokemon-species');
      const FIELD_NATURE = document.getElementById('dl-pokemon-nature');
      const FIELD_GENDER = document.getElementById('dl-pokemon-gender');
      const FIELD_SLOT_WRAPPER = document.getElementById('dl-pokemon-slot-field');
      const FIELD_SLOT = document.getElementById('dl-pokemon-slot');
      const SAVE_POKEMON_BTN = document.getElementById('dl-pokemon-save');
      const CANCEL_POKEMON_BTN = document.getElementById('dl-pokemon-cancel');
      const LOCATION_RADIOS = document.querySelectorAll('input[name="dl-pokemon-location"]');

      const DIALOG_BACKGROUND = root.querySelector('.dl-wrap');
      const DIALOG_OVERLAY = document.getElementById('dl-dialog-overlay');
      const DIALOG_SURFACE = document.getElementById('dl-dialog');
      const DIALOG_TITLE = document.getElementById('dl-dialog-title');
      const DIALOG_MESSAGE = document.getElementById('dl-dialog-message');
      const DIALOG_CANCEL = document.getElementById('dl-dialog-cancel');
      const DIALOG_CONFIRM = document.getElementById('dl-dialog-confirm');


      let activeDialogCallbacks = null;
      let dialogPreviousFocus = null;
      let dialogPreviousBodyOverflow = '';

      function closeRollerDialog(confirmed) {
        if (!DIALOG_OVERLAY || DIALOG_OVERLAY.hidden) return;

        const callbacks = activeDialogCallbacks;
        activeDialogCallbacks = null;

        DIALOG_OVERLAY.hidden = true;
        DIALOG_OVERLAY.setAttribute('aria-hidden', 'true');

        if (DIALOG_BACKGROUND) {
          DIALOG_BACKGROUND.removeAttribute('inert');
        }

        document.body.style.overflow = dialogPreviousBodyOverflow;

        const focusTarget = dialogPreviousFocus;
        dialogPreviousFocus = null;

        requestAnimationFrame(() => {
          if (focusTarget && focusTarget.isConnected) {
            focusTarget.focus();
          }

          const callback = confirmed
            ? callbacks?.onConfirm
            : callbacks?.onCancel;

          if (typeof callback === 'function') {
            callback();
          }
        });
      }

      function showRollerDialog({
        title = 'Notice',
        message = '',
        confirmText = 'Got it',
        cancelText = '',
        tone = 'notice',
        onConfirm = null,
        onCancel = null
      } = {}) {
        if (
          !DIALOG_OVERLAY ||
          !DIALOG_SURFACE ||
          !DIALOG_TITLE ||
          !DIALOG_MESSAGE ||
          !DIALOG_CONFIRM ||
          !DIALOG_CANCEL
        ) {
          console.warn(title, message);
          return;
        }

        dialogPreviousFocus = document.activeElement;
        dialogPreviousBodyOverflow = document.body.style.overflow;
        activeDialogCallbacks = { onConfirm, onCancel };

        DIALOG_SURFACE.dataset.tone = tone;
        DIALOG_TITLE.textContent = title;
        DIALOG_MESSAGE.textContent = message;
        DIALOG_CONFIRM.textContent = confirmText;

        DIALOG_CANCEL.hidden = !cancelText;
        DIALOG_CANCEL.textContent = cancelText || 'Cancel';

        DIALOG_OVERLAY.hidden = false;
        DIALOG_OVERLAY.setAttribute('aria-hidden', 'false');

        if (DIALOG_BACKGROUND) {
          DIALOG_BACKGROUND.setAttribute('inert', '');
        }

        document.body.style.overflow = 'hidden';

        requestAnimationFrame(() => {
          DIALOG_CONFIRM.focus();
        });
      }

      function showRollerNotice(message, title = 'Unable to continue') {
        showRollerDialog({
          title,
          message,
          confirmText: 'Got it',
          tone: 'notice'
        });
      }

      DIALOG_CONFIRM?.addEventListener('click', () => {
        closeRollerDialog(true);
      });

      DIALOG_CANCEL?.addEventListener('click', () => {
        closeRollerDialog(false);
      });

      DIALOG_OVERLAY?.addEventListener('click', (event) => {
        if (event.target === DIALOG_OVERLAY) {
          event.preventDefault();
          DIALOG_CONFIRM?.focus();
        }
      });

      DIALOG_OVERLAY?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          DIALOG_CONFIRM?.focus();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = [DIALOG_CANCEL, DIALOG_CONFIRM].filter(
          button => button && !button.hidden && !button.disabled
        );

        if (!focusable.length) {
          event.preventDefault();
          DIALOG_SURFACE?.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      // --- Cinematic / distraction-free mode ---
      let cinematicModeActive = false;
      let cinematicPreviousScrollY = 0;
      let cinematicIsolationRecords = [];

      function getFullscreenElement() {
        return (
          document.fullscreenElement ||
          document.webkitFullscreenElement ||
          null
        );
      }

      function isolateRollerFromPage() {
        cinematicIsolationRecords = [];

        let current = root;

        while (current && current.parentElement) {
          const parent = current.parentElement;

          Array.from(parent.children).forEach(sibling => {
            if (sibling === current) return;

            cinematicIsolationRecords.push({
              element: sibling,
              hadInert: sibling.hasAttribute('inert'),
              ariaHidden: sibling.getAttribute('aria-hidden')
            });

            sibling.setAttribute('inert', '');
            sibling.setAttribute('aria-hidden', 'true');
          });

          if (parent === document.body) {
            break;
          }

          current = parent;
        }
      }

      function restorePageAfterCinematicMode() {
        cinematicIsolationRecords.forEach(record => {
          const element = record.element;

          if (!element || !element.isConnected) return;

          if (!record.hadInert) {
            element.removeAttribute('inert');
          }

          if (record.ariaHidden === null) {
            element.removeAttribute('aria-hidden');
          } else {
            element.setAttribute(
              'aria-hidden',
              record.ariaHidden
            );
          }
        });

        cinematicIsolationRecords = [];
      }

      function requestRollerFullscreen() {
        const requestFullscreen =
          root.requestFullscreen ||
          root.webkitRequestFullscreen;

        if (
          typeof requestFullscreen !== 'function' ||
          getFullscreenElement()
        ) {
          return;
        }

        try {
          const result = requestFullscreen.call(root);

          if (
            result &&
            typeof result.catch === 'function'
          ) {
            result.catch(() => {
              // The CSS focus mode remains active when native fullscreen
              // is unsupported, blocked, or declined by the browser.
            });
          }
        } catch (_) {
          // Focus mode still works without the browser Fullscreen API.
        }
      }

      function enterCinematicMode() {
        if (cinematicModeActive) return;

        cinematicModeActive = true;
        cinematicPreviousScrollY =
          window.scrollY || window.pageYOffset || 0;

        isolateRollerFromPage();

        document.documentElement.classList.add(
          'dl-cinematic-mode'
        );
        document.body.classList.add(
          'dl-cinematic-mode'
        );
        root.classList.add('dl-cinematic-active');

        if (CINEMATIC_MODE_BTN) {
          CINEMATIC_MODE_BTN.setAttribute(
            'aria-pressed',
            'true'
          );
        }

        if (CINEMATIC_EXIT_BTN) {
          CINEMATIC_EXIT_BTN.hidden = false;
        }

        // The launcher lives in Resources, so return users to the actual
        // roller when the distraction-free view opens.
        setTopMode('hero');
        root.scrollTop = 0;

        requestAnimationFrame(() => {
          root.scrollTop = 0;
          CINEMATIC_EXIT_BTN?.focus();
        });

        // Attempt true browser fullscreen. If the browser does not allow it,
        // the fixed full-window CSS mode remains fully functional.
        requestRollerFullscreen();
      }

      async function exitCinematicMode({
        skipFullscreenExit = false
      } = {}) {
        if (!cinematicModeActive) return;

        cinematicModeActive = false;

        try {
          const fullscreenElement =
            getFullscreenElement();
          const exitFullscreen =
            document.exitFullscreen ||
            document.webkitExitFullscreen;

          if (
            !skipFullscreenExit &&
            fullscreenElement === root &&
            typeof exitFullscreen === 'function'
          ) {
            const result = exitFullscreen.call(document);

            if (
              result &&
              typeof result.then === 'function'
            ) {
              await result.catch(() => {});
            }
          }
        } finally {
          document.documentElement.classList.remove(
            'dl-cinematic-mode'
          );
          document.body.classList.remove(
            'dl-cinematic-mode'
          );
          root.classList.remove('dl-cinematic-active');

          if (CINEMATIC_MODE_BTN) {
            CINEMATIC_MODE_BTN.setAttribute(
              'aria-pressed',
              'false'
            );
          }

          if (CINEMATIC_EXIT_BTN) {
            CINEMATIC_EXIT_BTN.hidden = true;
          }

          restorePageAfterCinematicMode();

          root.scrollTop = 0;
          window.scrollTo(0, cinematicPreviousScrollY);

          requestAnimationFrame(() => {
            const preferredFocus =
              HERO_BTN && !HERO_BTN.hidden
                ? HERO_BTN
                : TOGGLE_RULES_BTN;

            preferredFocus?.focus();
          });
        }
      }

      function handleCinematicFullscreenChange() {
        if (
          cinematicModeActive &&
          getFullscreenElement() !== root
        ) {
          exitCinematicMode({
            skipFullscreenExit: true
          });
        }
      }

      document.addEventListener(
        'fullscreenchange',
        handleCinematicFullscreenChange
      );
      document.addEventListener(
        'webkitfullscreenchange',
        handleCinematicFullscreenChange
      );

      document.addEventListener(
        'keydown',
        event => {
          if (
            event.key !== 'Escape' ||
            !cinematicModeActive ||
            getFullscreenElement() ||
            (DIALOG_OVERLAY && !DIALOG_OVERLAY.hidden)
          ) {
            return;
          }

          event.preventDefault();
          exitCinematicMode({
            skipFullscreenExit: true
          });
        },
        true
      );

      const CORE_TEAM_LABELS = [
        {
          key: 'chaos_gremlins',
          name: 'The Chaos Gremlins',
          blurb: 'Agents of pure chaos. Lets be real, they mostly cause problems.',
          natures: [
            'Impish','Hasty','Naive','Naughty','Quirky',
            'Rash','Sassy','Bold','Adamant','Jolly','Quiet'
          ]
        },
        {
          key: 'ironheads',
          name: 'The Ironheads',
          blurb: 'Big heads, big hearts, big dreams - no backing down from these boys.',
          requiredGender: 'male',
          natures: [
            'Adamant','Bold','Brave','Calm','Hardy',
            'Impish','Lax','Lonely','Hasty','Quiet',
            'Serious','Rash'
          ]
        },
        {
          key: 'jellybellies',
          name: 'The Jellybellies',
          blurb: 'Soft, wobbly, lovable. They just want hugs and your approval.',
          natures: [
            'Timid','Bashful','Gentle','Quirky','Docile',
            'Lax','Relaxed','Modest','Mild','Quiet',
            'Jolly','Naive','Calm'
          ]
        },
        {
          key: 'drama_club',
          name: 'The Drama Club',
          blurb: 'Ugh, why are you reading this? Can you just like, leave me alone...?',
          natures: [
            'Quirky','Sassy','Lonely','Impish','Lax',
            'Relaxed','Modest','Bashful','Quiet','Timid',
            'Brave','Calm'
          ]
        },
        {
          key: 'masterminds',
          name: 'The Masterminds',
          blurb: 'They have a plan, a backup plan, and a strongly worded critique of your plan.',
          natures: [
            'Calm','Careful','Modest','Quiet','Serious',
            'Timid','Bold','Mild','Gentle','Sassy'
          ]
        },
        {
          key: 'hype_squad',
          name: 'The Hype Squad',
          blurb: 'Maximum enthusiasm, questionable volume control, absolutely no indoor voices.',
          natures: [
            'Jolly','Naive','Hasty','Hardy','Docile',
            'Bashful','Quirky','Gentle','Mild','Impish'
          ]
        },
        {
          key: 'lone_wolves',
          name: 'The Lone Wolves',
          blurb: 'Independent, mysterious, loners... together.',
          natures: [
            'Lonely','Sassy','Quiet','Serious','Careful',
            'Timid','Brave','Adamant','Mild','Relaxed'
          ]
        },
        {
          key: 'mom_friends',
          name: 'The Moms',
          blurb: 'They packed snacks, potions, antidotes, and are disappointed you did not bring a jacket.',
          requiredGender: 'female',
          natures: [
            'Careful','Calm','Bold','Gentle','Relaxed',
            'Docile','Hardy','Serious','Modest','Impish'
          ]
        }
      ];

      const SOUL_TEAM_LABELS = [
        {
          key: 'love_is_complicated',
          name: 'Love is Complicated',
          blurb: 'Bound together, hopelessly attached, but somehow still arguing about absolutely everything.',
          natures: [
            'Adamant','Brave','Naughty','Rash','Hasty',
            'Sassy','Impish','Lonely','Quirky'
          ]
        },
        {
          key: 'love_is_bliss',
          name: 'Love is Bliss',
          blurb: 'Completely smitten and perfectly in sync, they make the battlefield look like a honeymoon phase.',
          natures: [
            'Calm','Careful','Gentle','Modest','Timid',
            'Jolly','Docile','Bashful','Relaxed','Mild','Serious'
          ]
        }
      ];

      const TEAM_LABELS = [
        ...CORE_TEAM_LABELS,
        ...SOUL_TEAM_LABELS
      ];

      const EARLY_PERSONALITY_TEAM_LABELS = {
        oneMonShow: {
          key: 'one_mon_show',
          name: 'The One-Mon Show',
          blurb: 'The team has exactly one personality, and somehow it is still causing arguments.'
        },
        dynamicDuo: {
          key: 'dynamic_duo',
          name: 'The Dynamic Duo',
          blurb: 'Two Pokémon, one shared brain cell, and absolutely no backup plan.'
        },
        inseparables: {
          key: 'inseparables',
          name: 'The Inseparables',
          blurb: 'Where one goes, the other follows. The restraining order did not help.'
        }
      };

      const PERSONALITY_LOCK_DEFAULT_TEXT =
        'Pick one team and use only those Pokémon until the next Gym is complete.';

      const POKEMON_NAME_MAX_LENGTH = 24;
      const POKEMON_SPECIES_MAX_LENGTH = 40;

      const THEME_KEY   = 'dl.theme.v1';
      const ROLLS_KEY   = 'dl.rolls.v1';
      const EFFECTS_KEY = 'dl.effects.v3';
      const TEAM_KEY    = 'dl.team.v1';      // legacy, cleared on reset
      const BOXED_KEY   = 'dl.boxed.v1';     // legacy, cleared on reset
      const LOCK_KEY    = 'dl.lockedSlots.v1';
      const SOUL_KEY    = 'dl.soulLinks.v1';
      const HISTORY_KEY = 'dl.history.v1';
      const POKEMON_KEY = 'dl.pokemons.v1';
      const SHIELDS_KEY = 'dl.shields.v1';
      const WHITEOUT_KEY = 'dl.whiteout.choice.v1';
      const WHITEOUT_SNAPSHOT_KEY = 'dl.whiteout.snapshot.v1';
      const PERMA_LOCK_KEY = 'dl.permaLockedSlots.v1';
      const PERMA_LOCK_NAMES_KEY = 'dl.permaLockedSlotNames.v1';
      const SACRED_REBIRTH_KEY = 'dl.sacredRebirth.active.v1';
      const POKEMON_CENTER_LOG_KEY = 'dl.pokemonCenters.used.v1';
      const RESOURCE_VIEW_STATE_KEY = 'dl.resources.viewState.v1';
      const LAST_ROLL_SHOP_KEY = 'dl.lastRollShop.v1';
      const BIRDGOD_CHAMPION_KEY = 'dl.birdgodChampion.v1';

      const MAX_SHIELDS = 2; // Initial and maximum shield count


      const LOCKED_SLOT_NAMES_KEY = 'dl_locked_slot_names';

      const DICELOCKE_BACKUP_FORMAT = 'shopycats-dicelocke-save';
      const DICELOCKE_BACKUP_VERSION = 1;
      const DICELOCKE_BACKUP_MAX_BYTES = 1024 * 1024;

      const DICELOCKE_STORAGE_KEYS = [
        THEME_KEY,
        ROLLS_KEY,
        EFFECTS_KEY,
        TEAM_KEY,
        BOXED_KEY,
        LOCK_KEY,
        SOUL_KEY,
        HISTORY_KEY,
        POKEMON_KEY,
        SHIELDS_KEY,
        WHITEOUT_KEY,
        WHITEOUT_SNAPSHOT_KEY,
        PERMA_LOCK_KEY,
        PERMA_LOCK_NAMES_KEY,
        SACRED_REBIRTH_KEY,
        POKEMON_CENTER_LOG_KEY,
        RESOURCE_VIEW_STATE_KEY,
        LAST_ROLL_SHOP_KEY,
        BIRDGOD_CHAMPION_KEY,
        LOCKED_SLOT_NAMES_KEY
      ];

      function isPlainBackupObject(value) {
        return (
          value !== null &&
          typeof value === 'object' &&
          !Array.isArray(value) &&
          Object.getPrototypeOf(value) === Object.prototype
        );
      }

      function requireBackupObject(value, label) {
        if (!isPlainBackupObject(value)) {
          throw new Error(`${label} is missing or invalid.`);
        }

        return value;
      }

      function sanitizeBackupString(
        value,
        label,
        maxLength = 1000,
        {
          allowEmpty = true
        } = {}
      ) {
        if (typeof value !== 'string') {
          throw new Error(`${label} must be text.`);
        }

        if (!allowEmpty && !value.trim()) {
          throw new Error(`${label} cannot be empty.`);
        }

        if (value.length > maxLength) {
          throw new Error(`${label} is too long.`);
        }

        return value;
      }

      function sanitizeBackupInteger(
        value,
        label,
        minimum,
        maximum
      ) {
        if (
          !Number.isInteger(value) ||
          value < minimum ||
          value > maximum
        ) {
          throw new Error(`${label} is outside the allowed range.`);
        }

        return value;
      }

      function sanitizeBackupBooleanArray(
        value,
        label
      ) {
        if (!Array.isArray(value) || value.length !== 6) {
          throw new Error(`${label} must contain six entries.`);
        }

        return value.map(Boolean);
      }

      function sanitizeBackupNameArray(
        value,
        label
      ) {
        if (!Array.isArray(value) || value.length !== 6) {
          throw new Error(`${label} must contain six entries.`);
        }

        return value.map((item, index) => {
          if (item === null || item === undefined) {
            return null;
          }

          return sanitizeBackupString(
            item,
            `${label} entry ${index + 1}`,
            120
          );
        });
      }

      function sanitizeJsonBackupValue(
        value,
        label,
        depth = 0
      ) {
        if (depth > 8) {
          throw new Error(`${label} is nested too deeply.`);
        }

        if (
          value === null ||
          typeof value === 'boolean' ||
          typeof value === 'string'
        ) {
          if (
            typeof value === 'string' &&
            value.length > 4000
          ) {
            throw new Error(`${label} contains text that is too long.`);
          }

          return value;
        }

        if (typeof value === 'number') {
          if (!Number.isFinite(value)) {
            throw new Error(`${label} contains an invalid number.`);
          }

          return value;
        }

        if (Array.isArray(value)) {
          if (value.length > 2000) {
            throw new Error(`${label} contains too many entries.`);
          }

          return value.map((item, index) =>
            sanitizeJsonBackupValue(
              item,
              `${label}[${index}]`,
              depth + 1
            )
          );
        }

        if (!isPlainBackupObject(value)) {
          throw new Error(`${label} contains an invalid object.`);
        }

        const entries = Object.entries(value);

        if (entries.length > 250) {
          throw new Error(`${label} contains too many properties.`);
        }

        const sanitized = {};

        entries.forEach(([key, item]) => {
          if (
            key === '__proto__' ||
            key === 'prototype' ||
            key === 'constructor'
          ) {
            return;
          }

          if (key.length > 120) {
            throw new Error(`${label} contains an invalid property name.`);
          }

          sanitized[key] = sanitizeJsonBackupValue(
            item,
            `${label}.${key}`,
            depth + 1
          );
        });

        return sanitized;
      }

      function sanitizePokemonBackup(value, index) {
        const pokemon = requireBackupObject(
          value,
          `Pokémon ${index + 1}`
        );

        const gender = sanitizeBackupString(
          pokemon.gender || '',
          `Pokémon ${index + 1} gender`,
          20
        ).toLowerCase();

        const location = sanitizeBackupString(
          pokemon.location || '',
          `Pokémon ${index + 1} location`,
          20
        ).toLowerCase();

        if (
          !['male', 'female', 'genderless'].includes(gender)
        ) {
          throw new Error(
            `Pokémon ${index + 1} has an invalid gender.`
          );
        }

        if (!['team', 'box', 'grave'].includes(location)) {
          throw new Error(
            `Pokémon ${index + 1} has an invalid location.`
          );
        }

        let slotIndex = null;

        if (
          pokemon.slotIndex !== null &&
          pokemon.slotIndex !== undefined
        ) {
          slotIndex = sanitizeBackupInteger(
            pokemon.slotIndex,
            `Pokémon ${index + 1} team slot`,
            0,
            5
          );
        }

        return {
          id: sanitizeBackupString(
            pokemon.id,
            `Pokémon ${index + 1} ID`,
            160,
            {
              allowEmpty: false
            }
          ),
          name: sanitizeBackupString(
            pokemon.name || '',
            `Pokémon ${index + 1} name`,
            120
          ),
          species: sanitizeBackupString(
            pokemon.species || '',
            `Pokémon ${index + 1} species`,
            120
          ),
          nature: sanitizeBackupString(
            pokemon.nature || '',
            `Pokémon ${index + 1} nature`,
            40
          ),
          gender,
          location,
          slotIndex:
            location === 'team'
              ? slotIndex
              : null
        };
      }

      function sanitizePokemonList(value) {
        if (!Array.isArray(value) || value.length > 500) {
          throw new Error(
            'The Pokémon roster is missing or contains too many entries.'
          );
        }

        const sanitized = value.map(sanitizePokemonBackup);
        const ids = new Set();
        const occupiedTeamSlots = new Map();

        sanitized.forEach((pokemon, index) => {
          if (ids.has(pokemon.id)) {
            throw new Error(
              'The backup contains duplicate Pokémon IDs.'
            );
          }

          ids.add(pokemon.id);

          if (pokemon.location !== 'team') {
            pokemon.slotIndex = null;
            return;
          }

          if (!Number.isInteger(pokemon.slotIndex)) {
            throw new Error(
              `Pokémon ${index + 1} is on the active team but does not have a valid team slot.`
            );
          }

          const existingPokemon =
            occupiedTeamSlots.get(pokemon.slotIndex);

          if (existingPokemon) {
            throw new Error(
              `Team slot ${pokemon.slotIndex + 1} is assigned to both ` +
              `${existingPokemon} and ${pokemon.name || pokemon.species || `Pokémon ${index + 1}`}.`
            );
          }

          occupiedTeamSlots.set(
            pokemon.slotIndex,
            pokemon.name ||
              pokemon.species ||
              `Pokémon ${index + 1}`
          );
        });

        return sanitized;
      }

      function sanitizeSoulLinks(value) {
        if (!Array.isArray(value) || value.length > 500) {
          throw new Error(
            'The Soul Link list is missing or contains too many entries.'
          );
        }

        return value.map((item, index) => {
          const link = requireBackupObject(
            item,
            `Soul Link ${index + 1}`
          );
          const type =
            link.type === 'triple'
              ? 'triple'
              : 'pair';
          const expectedSize =
            type === 'triple'
              ? 3
              : 2;

          if (
            !Array.isArray(link.memberIds) ||
            link.memberIds.length !== expectedSize
          ) {
            throw new Error(
              `Soul Link ${index + 1} has the wrong number of members.`
            );
          }

          const memberIds = link.memberIds.map(
            (memberId, memberIndex) =>
              sanitizeBackupString(
                memberId,
                `Soul Link ${index + 1} member ${memberIndex + 1}`,
                160,
                {
                  allowEmpty: false
                }
              )
          );

          if (new Set(memberIds).size !== memberIds.length) {
            throw new Error(
              `Soul Link ${index + 1} contains duplicate members.`
            );
          }

          return {
            type,
            memberIds
          };
        });
      }

      function sanitizeEffects(value) {
        if (!Array.isArray(value) || value.length > 250) {
          throw new Error(
            'The active effects list is missing or contains too many entries.'
          );
        }

        const allowedApplyKinds = new Set([
          null,
          'boxRandom',
          'teamShuffle',
          'soulLink',
          'centerRefresh',
          'teamChoice',
          'chooseBonus'
        ]);

        return value.map((item, index) => {
          const effect = requireBackupObject(
            item,
            `Effect ${index + 1}`
          );
          const sanitized = sanitizeJsonBackupValue(
            effect,
            `Effect ${index + 1}`
          );

          if (!['bonus', 'malus'].includes(sanitized.kind)) {
            throw new Error(
              `Effect ${index + 1} has an invalid type.`
            );
          }

          const applyKind =
            sanitized.applyKind === undefined
              ? null
              : sanitized.applyKind;

          if (!allowedApplyKinds.has(applyKind)) {
            throw new Error(
              `Effect ${index + 1} has an invalid action.`
            );
          }

          sanitized.applyKind = applyKind;
          return sanitized;
        });
      }

      function sanitizeHistory(value) {
        if (!Array.isArray(value) || value.length > 2000) {
          throw new Error(
            'The history list is missing or contains too many entries.'
          );
        }

        return value.map((item, index) => {
          const entry = requireBackupObject(
            item,
            `History entry ${index + 1}`
          );

          return sanitizeJsonBackupValue(
            entry,
            `History entry ${index + 1}`
          );
        });
      }

      function sanitizeHealingLog(value) {
        const source = requireBackupObject(
          value,
          'Healing log'
        );
        const sanitized = {};

        ['frlg', 'rse'].forEach(gameKey => {
          const gameLog = source[gameKey];

          if (gameLog === undefined) {
            return;
          }

          const validGameLog = requireBackupObject(
            gameLog,
            `${gameKey.toUpperCase()} healing log`
          );
          const entries = Object.entries(validGameLog);

          if (entries.length > 250) {
            throw new Error(
              `${gameKey.toUpperCase()} healing log contains too many entries.`
            );
          }

          sanitized[gameKey] = {};

          entries.forEach(([locationId, isUsed]) => {
            const safeLocationId = sanitizeBackupString(
              locationId,
              'Healing location ID',
              160,
              {
                allowEmpty: false
              }
            );

            sanitized[gameKey][safeLocationId] =
              isUsed === true;
          });
        });

        return sanitized;
      }

      function sanitizeResourceView(value) {
        const source = requireBackupObject(
          value,
          'Resources view'
        );
        const gameKey =
          source.gameKey === 'frlg' ||
          source.gameKey === 'rse'
            ? source.gameKey
            : null;
        const stage =
          ['home', 'tools', 'caps', 'centers'].includes(
            source.stage
          )
            ? source.stage
            : 'home';

        return {
          gameKey,
          stage:
            gameKey || stage === 'home'
              ? stage
              : 'home'
        };
      }

      function sanitizeLastRollShop(value) {
        if (value === null || value === undefined) {
          return {
            mode: null,
            purchases: []
          };
        }

        const source = requireBackupObject(
          value,
          'Last Roll Shop'
        );

        const mode = normalizeLastRollShopMode(
          source.mode
        );

        const purchases = Array.isArray(source.purchases)
          ? source.purchases.slice(0, 25).map((item, index) => {
              const purchase = requireBackupObject(
                item,
                `Last Roll Shop purchase ${index + 1}`
              );

              return {
                id: sanitizeBackupString(
                  purchase.id || '',
                  `Last Roll Shop purchase ${index + 1} ID`,
                  80
                ),
                name: sanitizeBackupString(
                  purchase.name || '',
                  `Last Roll Shop purchase ${index + 1} name`,
                  120
                ),
                category: sanitizeBackupString(
                  purchase.category || '',
                  `Last Roll Shop purchase ${index + 1} category`,
                  40
                ),
                cost:
                  typeof purchase.cost === 'number' &&
                  Number.isFinite(purchase.cost)
                    ? purchase.cost
                    : null,
                spent:
                  typeof purchase.spent === 'number' &&
                  Number.isFinite(purchase.spent)
                    ? purchase.spent
                    : null,
                detail: sanitizeBackupString(
                  purchase.detail || '',
                  `Last Roll Shop purchase ${index + 1} detail`,
                  1000
                ),
                purchasedAt:
                  typeof purchase.purchasedAt === 'string'
                    ? sanitizeBackupString(
                        purchase.purchasedAt,
                        `Last Roll Shop purchase ${index + 1} time`,
                        80
                      )
                    : null
              };
            })
          : [];

        return {
          mode,
          purchases
        };
      }


      function sanitizeBirdGodChampion(value) {
        if (value === null || value === undefined) {
          return null;
        }

        const source = requireBackupObject(
          value,
          "BirdGOD\'s Champion"
        );

        return {
          pokemonId: sanitizeBackupString(
            source.pokemonId || '',
            "BirdGOD\'s Champion Pokémon ID",
            160,
            {
              allowEmpty: false
            }
          ),
          pokemonName: sanitizeBackupString(
            source.pokemonName || '',
            "BirdGOD\'s Champion Pokémon name",
            160
          ),
          chosenAt:
            typeof source.chosenAt === 'string'
              ? sanitizeBackupString(
                  source.chosenAt,
                  "BirdGOD\'s Champion chosen time",
                  80
                )
              : null
        };
      }

      function sanitizeWhiteoutChoice(value) {
        if (value === null || value === undefined) {
          return null;
        }

        const choice = requireBackupObject(
          value,
          'Whiteout choice'
        );
        const sanitized = sanitizeJsonBackupValue(
          choice,
          'Whiteout choice'
        );
        const allowedIds = new Set([
          'alternate_timeline',
          'inversion_world',
          'final_wish',
          'sacred_rebirth',
          'nightmare_bargain',
          'judgment',
          'birdgod_champion',
          'tide_carries_on'
        ]);

        if (!allowedIds.has(sanitized.id)) {
          throw new Error(
            'The Whiteout choice is not recognized.'
          );
        }

        return sanitized;
      }

      function parseDicelockeBackup(fileText) {
        let parsed;

        try {
          parsed = JSON.parse(fileText);
        } catch (_) {
          throw new Error(
            'The selected file is not valid JSON.'
          );
        }

        const backup = requireBackupObject(
          parsed,
          'Backup file'
        );

        if (
          backup.format !== DICELOCKE_BACKUP_FORMAT ||
          backup.version !== DICELOCKE_BACKUP_VERSION
        ) {
          throw new Error(
            'This file is not a compatible Dicelocke save.'
          );
        }

        const state = requireBackupObject(
          backup.state,
          'Backup state'
        );
        const theme =
          typeof state.theme === 'string' &&
          THEMES.includes(state.theme)
            ? state.theme
            : 'urge';

        return {
          format: DICELOCKE_BACKUP_FORMAT,
          version: DICELOCKE_BACKUP_VERSION,
          exportedAt:
            typeof backup.exportedAt === 'string'
              ? backup.exportedAt
              : null,
          state: {
            theme,
            rolls: sanitizeBackupInteger(
              state.rolls,
              'Dice rolls',
              0,
              999999
            ),
            shields: sanitizeBackupInteger(
              state.shields,
              'Shields',
              0,
              MAX_SHIELDS
            ),
            pokemons: sanitizePokemonList(
              state.pokemons
            ),
            effects: sanitizeEffects(
              state.effects
            ),
            history: sanitizeHistory(
              state.history
            ),
            soulLinks: sanitizeSoulLinks(
              state.soulLinks
            ),
            lockedSlots: sanitizeBackupBooleanArray(
              state.lockedSlots,
              'Locked slots'
            ),
            lockedSlotNames: sanitizeBackupNameArray(
              state.lockedSlotNames,
              'Locked-slot names'
            ),
            permaLockedSlots: sanitizeBackupBooleanArray(
              state.permaLockedSlots,
              'Permanent locked slots'
            ),
            permaLockedSlotNames: sanitizeBackupNameArray(
              state.permaLockedSlotNames,
              'Permanent locked-slot names'
            ),
            whiteoutChoice: sanitizeWhiteoutChoice(
              state.whiteoutChoice
            ),
            whiteoutSnapshot:
              state.whiteoutSnapshot === null ||
              state.whiteoutSnapshot === undefined
                ? null
                : sanitizeJsonBackupValue(
                    requireBackupObject(
                      state.whiteoutSnapshot,
                      'Whiteout snapshot'
                    ),
                    'Whiteout snapshot'
                  ),
            sacredRebirthActive:
              state.sacredRebirthActive === true,
            birdGodChampion: sanitizeBirdGodChampion(
              state.birdGodChampion
            ),
            healingLog: sanitizeHealingLog(
              state.healingLog
            ),
            resourceView: sanitizeResourceView(
              state.resourceView
            ),
            lastRollShop: sanitizeLastRollShop(
              state.lastRollShop
            )
          }
        };
      }

      function createDicelockeBackup() {
        return {
          format: DICELOCKE_BACKUP_FORMAT,
          version: DICELOCKE_BACKUP_VERSION,
          exportedAt: new Date().toISOString(),
          state: {
            theme:
              THEMES.includes(root.dataset.theme)
                ? root.dataset.theme
                : 'urge',
            rolls: diceRolls,
            shields: shieldCount,
            pokemons: pokemons,
            effects: getEffects(),
            history: getHistory(),
            soulLinks,
            lockedSlots,
            lockedSlotNames,
            permaLockedSlots,
            permaLockedSlotNames,
            whiteoutChoice: loadWhiteoutChoice(),
            whiteoutSnapshot: loadJSON(
              WHITEOUT_SNAPSHOT_KEY,
              null
            ),
            sacredRebirthActive,
            birdGodChampion: getBirdGodChampionState(),
            healingLog: getPokemonCenterLog(),
            resourceView: loadResourceViewState(),
            lastRollShop: getLastRollShopState()
          }
        };
      }

      function getBackupFilename() {
        const now = new Date();
        const datePart = now.toISOString().slice(0, 10);
        const timePart = now
          .toTimeString()
          .slice(0, 5)
          .replace(':', '-');

        return `dicelocke-save-${datePart}-${timePart}.json`;
      }

      function exportDicelockeBackup() {
        try {
          const backup = createDicelockeBackup();
          const json = JSON.stringify(backup, null, 2);
          const blob = new Blob(
            [json],
            {
              type: 'application/json'
            }
          );
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');

          link.href = url;
          link.download = getBackupFilename();
          link.style.display = 'none';

          document.body.appendChild(link);
          link.click();
          link.remove();

          window.setTimeout(() => {
            URL.revokeObjectURL(url);
          }, 0);

          if (BACKUP_STATUS) {
            BACKUP_STATUS.textContent =
              'Backup downloaded. Keep the JSON file somewhere safe.';
          }
        } catch (error) {
          console.error(
            'Dicelocke backup export failed:',
            error
          );
          showRollerNotice(
            'The backup could not be created. Check that browser downloads are allowed and try again.',
            'Export failed'
          );
        }
      }

      function captureDicelockeStorageSnapshot() {
        const snapshot = Object.create(null);

        DICELOCKE_STORAGE_KEYS.forEach(key => {
          snapshot[key] = localStorage.getItem(key);
        });

        return snapshot;
      }

      function buildDicelockeStoragePayload(state) {
        return new Map([
          [THEME_KEY, state.theme],
          [ROLLS_KEY, String(state.rolls)],
          [SHIELDS_KEY, String(state.shields)],
          [POKEMON_KEY, JSON.stringify(state.pokemons)],
          [EFFECTS_KEY, JSON.stringify(state.effects)],
          [HISTORY_KEY, JSON.stringify(state.history)],
          [SOUL_KEY, JSON.stringify(state.soulLinks)],
          [LOCK_KEY, JSON.stringify(state.lockedSlots)],
          [
            LOCKED_SLOT_NAMES_KEY,
            JSON.stringify(state.lockedSlotNames)
          ],
          [
            PERMA_LOCK_KEY,
            JSON.stringify(state.permaLockedSlots)
          ],
          [
            PERMA_LOCK_NAMES_KEY,
            JSON.stringify(state.permaLockedSlotNames)
          ],
          [
            SACRED_REBIRTH_KEY,
            JSON.stringify(state.sacredRebirthActive)
          ],
          [
            BIRDGOD_CHAMPION_KEY,
            state.birdGodChampion
              ? JSON.stringify(state.birdGodChampion)
              : null
          ],
          [
            POKEMON_CENTER_LOG_KEY,
            JSON.stringify(state.healingLog)
          ],
          [
            RESOURCE_VIEW_STATE_KEY,
            JSON.stringify(state.resourceView)
          ],
          [
            LAST_ROLL_SHOP_KEY,
            JSON.stringify(state.lastRollShop)
          ],
          [
            WHITEOUT_KEY,
            state.whiteoutChoice
              ? JSON.stringify(state.whiteoutChoice)
              : null
          ],
          [
            WHITEOUT_SNAPSHOT_KEY,
            state.whiteoutSnapshot
              ? JSON.stringify(state.whiteoutSnapshot)
              : null
          ]
        ]);
      }

      function clearDicelockeStorageForImport() {
        DICELOCKE_STORAGE_KEYS.forEach(key => {
          localStorage.removeItem(key);
        });
      }

      function writeDicelockeStoragePayload(payload) {
        clearDicelockeStorageForImport();

        payload.forEach((value, key) => {
          if (value !== null) {
            localStorage.setItem(key, value);
          }
        });
      }

      function restoreDicelockeStorageSnapshot(snapshot) {
        clearDicelockeStorageForImport();

        DICELOCKE_STORAGE_KEYS.forEach(key => {
          const previousValue = snapshot[key];

          if (previousValue !== null) {
            localStorage.setItem(key, previousValue);
          }
        });
      }

      function restoreDicelockeBackup(backup) {
        const state = backup.state;
        let previousState = null;

        try {
          /*
            Serialize the entire import before touching the current run.
            This catches serialization errors without risking existing data.
          */
          const payload =
            buildDicelockeStoragePayload(state);

          /*
            Preserve every Dicelocke key before clearing anything. If a
            browser storage write fails halfway through, the previous run
            can be restored.
          */
          previousState =
            captureDicelockeStorageSnapshot();

          writeDicelockeStoragePayload(payload);
        } catch (error) {
          console.error(
            'Dicelocke backup import failed:',
            error
          );

          let rollbackSucceeded = false;

          if (previousState) {
            try {
              restoreDicelockeStorageSnapshot(
                previousState
              );
              rollbackSucceeded = true;
            } catch (rollbackError) {
              console.error(
                'Dicelocke backup rollback failed:',
                rollbackError
              );
            }
          }

          showRollerNotice(
            rollbackSucceeded
              ? 'The backup could not be saved, so your previous Dicelocke run was restored. Check that browser site storage is enabled and has enough free space before trying again.'
              : 'The backup could not be saved. Browser site storage may be disabled or unavailable. Reload the page and verify your current run before trying again.',
            'Import failed'
          );
          return;
        }

        window.location.reload();
      }

      function getDicelockeBackupSummary(backup) {
        const state = backup.state;
        const blessings = state.effects.filter(
          effect => effect.kind === 'bonus'
        ).length;
        const curses = state.effects.filter(
          effect => effect.kind === 'malus'
        ).length;

        return [
          `Pokémon: ${state.pokemons.length}`,
          `Dice rolls: ${state.rolls}`,
          `Shields: ${state.shields}`,
          `Blessings: ${blessings}`,
          `Curses: ${curses}`,
          `History entries: ${state.history.length}`
        ].join('\n');
      }

      EXPORT_BACKUP_BTN?.addEventListener(
        'click',
        exportDicelockeBackup
      );

      IMPORT_BACKUP_BTN?.addEventListener('click', () => {
        if (IMPORT_BACKUP_INPUT) {
          IMPORT_BACKUP_INPUT.value = '';
          IMPORT_BACKUP_INPUT.click();
        }
      });

      IMPORT_BACKUP_INPUT?.addEventListener(
        'change',
        async () => {
          const file = IMPORT_BACKUP_INPUT.files?.[0];

          if (!file) {
            return;
          }

          IMPORT_BACKUP_INPUT.value = '';

          if (file.size > DICELOCKE_BACKUP_MAX_BYTES) {
            showRollerNotice(
              'The selected file is larger than 1 MB and was not imported.',
              'Backup file is too large'
            );
            return;
          }

          try {
            const fileText = await file.text();
            const backup = parseDicelockeBackup(fileText);
            const summary = getDicelockeBackupSummary(backup);

            showRollerDialog({
              title: 'Import this Dicelocke save?',
              message:
                `${summary}\n\n` +
                'Importing will replace the current Dicelocke run stored in this browser.',
              confirmText: 'Replace current run',
              cancelText: 'Cancel',
              tone: 'warning',
              onConfirm: () => {
                restoreDicelockeBackup(backup);
              }
            });
          } catch (error) {
            console.error(
              'Dicelocke backup validation failed:',
              error
            );
            showRollerNotice(
              error?.message ||
                'The selected file is not a valid Dicelocke save.',
              'Backup could not be imported'
            );
          }
        }
      );

      const RESOURCE_GAME_META = {
        frlg: {
          title: 'FireRed / LeafGreen'
        },
        rse: {
          title: 'Ruby / Sapphire / Emerald'
        }
      };

      const POKEMON_CENTER_DATA = {
        frlg: {
          title: 'FireRed / LeafGreen Healing Locations',
          description:
            'Mark each location after receiving its one allowed full-party heal.',
          sections: [
            {
              title: 'Kanto Pokémon Centers',
              centers: [
                { id: 'viridian-city', name: 'Viridian City' },
                { id: 'pewter-city', name: 'Pewter City' },
                { id: 'route-4-mt-moon', name: 'Route 4 - Mt. Moon entrance' },
                { id: 'cerulean-city', name: 'Cerulean City' },
                { id: 'vermilion-city', name: 'Vermilion City' },
                { id: 'lavender-town', name: 'Lavender Town' },
                { id: 'route-10-rock-tunnel', name: 'Route 10 - Rock Tunnel entrance' },
                { id: 'celadon-city', name: 'Celadon City' },
                { id: 'fuchsia-city', name: 'Fuchsia City' },
                { id: 'saffron-city', name: 'Saffron City' },
                { id: 'cinnabar-island', name: 'Cinnabar Island' },
                { id: 'indigo-plateau', name: 'Indigo Plateau - Pokémon League' }
              ]
            },
            {
              title: 'Sevii Island Pokémon Centers',
              centers: [
                { id: 'one-island-network-center', name: 'One Island - Pokémon Network Center' },
                { id: 'two-island', name: 'Two Island' },
                { id: 'three-island', name: 'Three Island' },
                { id: 'four-island', name: 'Four Island' },
                { id: 'five-island', name: 'Five Island' },
                { id: 'six-island', name: 'Six Island' },
                { id: 'seven-island', name: 'Seven Island' },
                {
                  id: 'trainer-tower-pokemon-center',
                  name: 'Trainer Tower - lobby Pokémon Center',
                  badge: 'Postgame'
                }
              ]
            },
            {
              title: 'Other Healing Locations',
              centers: [
                {
                  id: 'pallet-town-mom',
                  name: 'Pallet Town - Mommy',
                  badge: 'NPC'
                },
                {
                  id: 'ss-anne-healer',
                  name: 'S.S. Anne - 1F cabin healer',
                  badge: 'NPC'
                },
                {
                  id: 'pokemon-tower-purified-zone',
                  name: 'Pokémon Tower - 5F purified zone',
                  badge: 'Healing zone'
                },
                {
                  id: 'silph-co-nurse',
                  name: 'Silph Co. - 9F resting-area nurse',
                  badge: 'NPC'
                },
                {
                  id: 'kindle-road-ember-spa',
                  name: 'Kindle Road - Ember Spa',
                  badge: 'Hot spring'
                }
              ]
            }
          ]
        },
        rse: {
          title: 'Ruby / Sapphire / Emerald Healing Locations',
          description:
            'Mark each location after receiving its one allowed full-party heal.',
          sections: [
            {
              title: 'Hoenn Pokémon Centers',
              centers: [
                { id: 'oldale-town', name: 'Oldale Town' },
                { id: 'petalburg-city', name: 'Petalburg City' },
                { id: 'rustboro-city', name: 'Rustboro City' },
                { id: 'dewford-town', name: 'Dewford Town' },
                { id: 'slateport-city', name: 'Slateport City' },
                { id: 'mauville-city', name: 'Mauville City' },
                { id: 'verdanturf-town', name: 'Verdanturf Town' },
                { id: 'fallarbor-town', name: 'Fallarbor Town' },
                { id: 'lavaridge-town', name: 'Lavaridge Town' },
                { id: 'fortree-city', name: 'Fortree City' },
                { id: 'lilycove-city', name: 'Lilycove City' },
                { id: 'mossdeep-city', name: 'Mossdeep City' },
                { id: 'sootopolis-city', name: 'Sootopolis City' },
                { id: 'pacifidlog-town', name: 'Pacifidlog Town' },
                { id: 'ever-grande-south', name: 'Ever Grande City - South of Victory Road' },
                { id: 'hoenn-pokemon-league', name: 'Pokémon League - North of Victory Road' }
              ]
            },
            {
              title: 'Other Healing Locations',
              centers: [
                {
                  id: 'littleroot-town-mom',
                  name: 'Littleroot Town - Mommy',
                  badge: 'NPC'
                },
                {
                  id: 'route-111-rest-stop',
                  name: "Route 111 - Old Lady's Rest Stop",
                  badge: 'NPC'
                },
                {
                  id: 'weather-institute-bed',
                  name: 'Weather Institute - resting bed',
                  badge: 'Bed'
                },
              ]
            }
          ]
        }
      };

      const LEVEL_CAP_DATA = {
        frlg: {
          title: 'FireRed / LeafGreen',
          description:
            'Main-story Gym Leaders, Elite Four, and Champion.',
          columns: ['Battle', 'Trainer', 'Cap'],
          rows: [
            { phase: 'Gym Leaders' },
            ['Gym 1', 'Brock', 14],
            ['Gym 2', 'Misty', 21],
            ['Gym 3', 'Lt. Surge', 24],
            ['Gym 4', 'Erika', 29],
            ['Gym 5', 'Koga', 43],
            ['Gym 6', 'Sabrina', 43],
            ['Gym 7', 'Blaine', 47],
            ['Gym 8', 'Giovanni', 50],
            { phase: 'Pokémon League' },
            ['Elite Four + Champion', 'Blue maximum', 63]
          ]
        },
        rse: {
          title: 'Ruby / Sapphire / Emerald',
          description:
            'Ruby and Sapphire share one column; Emerald differences appear beside them.',
          columns: ['Battle', 'Trainer', 'R/S', 'Emerald'],
          comparison: true,
          rows: [
            { phase: 'Gym Leaders' },
            ['Gym 1', 'Roxanne', 15, 15],
            ['Gym 2', 'Brawly', 18, 19],
            ['Gym 3', 'Wattson', 23, 24],
            ['Gym 4', 'Flannery', 28, 29],
            ['Gym 5', 'Norman', 31, 31],
            ['Gym 6', 'Winona', 33, 33],
            ['Gym 7', 'Tate & Liza', 42, 42],
            ['Gym 8', 'Wallace / Juan', 43, 46],
            { phase: 'Pokémon League' },
            ['Elite Four + Champion', 'Steven / Wallace maximum', 58, 58]
          ]
        }
      };


      // --- Simple JSON helpers for localStorage ---
      function saveJSON(key, value) {
        try {
          localStorage.setItem(key, JSON.stringify(value));
        } catch (_) {}
      }

      function loadJSON(key, fallback) {
        try {
          const raw = localStorage.getItem(key);
          if (!raw) return fallback;
          const parsed = JSON.parse(raw);
          return (parsed === undefined || parsed === null) ? fallback : parsed;
        } catch (_) {
          return fallback;
        }
      }


      function getBirdGodChampionState() {
        const value = loadJSON(BIRDGOD_CHAMPION_KEY, null);

        if (!value || typeof value !== 'object') {
          return null;
        }

        if (typeof value.pokemonId !== 'string' || !value.pokemonId) {
          return null;
        }

        return {
          pokemonId: value.pokemonId,
          pokemonName:
            typeof value.pokemonName === 'string'
              ? value.pokemonName
              : '',
          chosenAt:
            typeof value.chosenAt === 'string'
              ? value.chosenAt
              : null
        };
      }

      function saveBirdGodChampionState(state) {
        try {
          if (!state || !state.pokemonId) {
            localStorage.removeItem(BIRDGOD_CHAMPION_KEY);
            return;
          }

          localStorage.setItem(
            BIRDGOD_CHAMPION_KEY,
            JSON.stringify({
              pokemonId: state.pokemonId,
              pokemonName: state.pokemonName || '',
              chosenAt: state.chosenAt || new Date().toISOString()
            })
          );
        } catch (_) {}
      }

      function isBirdGodChampion(pokemonId) {
        const champion = getBirdGodChampionState();
        return Boolean(
          champion &&
          champion.pokemonId === pokemonId
        );
      }

      function getBirdGodChampionName(champion = getBirdGodChampionState()) {
        if (!champion) return '';

        const pokemon = getPokemonById(champion.pokemonId);
        return pokemon
          ? getPokemonDisplayName(pokemon)
          : champion.pokemonName || "BirdGOD's chosen Pokémon";
      }

      function protectBirdGodChampionFromGrave(
        pokemon,
        { showNotice = true } = {}
      ) {
        if (!pokemon) return false;

        const champion = getBirdGodChampionState();
        if (!champion || champion.pokemonId !== pokemon.id) {
          return false;
        }

        pokemon.location = 'box';
        pokemon.slotIndex = null;

        champion.pokemonName = getPokemonDisplayName(pokemon);
        saveBirdGodChampionState(champion);
        savePokemons();

        const detail =
          `${getPokemonDisplayName(pokemon)} would have gone to the Graveyard, but BirdGOD refused to let his Champion die. They were sent to the box instead. Box them until the next Pokemon Center is used.`;

        recordHistory({
          kind: 'event',
          title: 'BirdGOD intervened',
          detail
        });

        if (showNotice) {
          showRollerNotice(
            detail,
            'BirdGOD intervened'
          );
        }

        return true;
      }

      let sacredRebirthActive = loadJSON(SACRED_REBIRTH_KEY, false) === true;

      function updateSacredRebirthUI() {
        root.classList.toggle(
          'dl-sacred-rebirth-active',
          sacredRebirthActive
        );
        updateWhiteoutInterventionTheme();

        if (ROLLS_HINT) {
          ROLLS_HINT.textContent = sacredRebirthActive
            ? 'Sacred Rebirth is active: gain +1 Dice Roll automatically whenever you send a Pokémon to the graveyard. You may not catch any new Pokémon, unless a Blessing allows it.'
            : 'Add 1 every time you catch a new Pokémon. Rolling the die automatically spends 1.';
        }

        if (ADD_POKEMON_BTN) {
          ADD_POKEMON_BTN.disabled = false;
          ADD_POKEMON_BTN.textContent = 'Add Pokémon';
          ADD_POKEMON_BTN.title = '';
        }
      }

      function setSacredRebirthActive(active) {
        sacredRebirthActive = Boolean(active);
        saveJSON(SACRED_REBIRTH_KEY, sacredRebirthActive);
        updateSacredRebirthUI();
        renderPartyUI();
      }

      const prefersRM   = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches || false;

      // --- RNG: 1–20 with crypto if available ---
      function randD20() {
        const max = 20;
        if (window.crypto && crypto.getRandomValues) {
          const range  = max;
          const maxUint = 0xFFFFFFFF;
          const limit   = Math.floor(maxUint / range) * range;
          const x = new Uint32Array(1);
          do { crypto.getRandomValues(x); } while (x[0] >= limit);
          return (x[0] % range) + 1;
        }
        return Math.floor(Math.random() * max) + 1;
      }

      // --- Parse image map from JSON ---
      let IMG_MAP = {};
      try {
        const el = document.getElementById('dl-img-map');
        if (el) IMG_MAP = JSON.parse(el.textContent || '{}');
      } catch(_) { IMG_MAP = {}; }

      // --- Theme helpers ---
      const THEMES = ['urge','galaxy','cozy','emerald','svg'];

      function applyTheme(theme) {
        if (!THEMES.includes(theme)) theme = 'urge';
        root.setAttribute('data-theme', theme);
        try { localStorage.setItem(THEME_KEY, theme); } catch(_) {}
      }

      function usePhotoDice() {
        const theme = root.dataset.theme || 'urge';
        if (theme === 'svg') return false;
        const set = IMG_MAP?.[theme];
        return !!(set && set['20']);
      }

      function getThemeVars() {
        const cs = getComputedStyle(root);
        return {
          number: (cs.getPropertyValue('--dl-number') || '').trim()
        };
      }

      // --- Dice rolls state (localStorage) ---
      let diceRolls = 0;

      function getStoredRolls() {
        try {
          const raw = localStorage.getItem(ROLLS_KEY);
          const n = parseInt(raw, 10);
          return Number.isFinite(n) && n > 0 ? n : 0;
        } catch(_) {
          return 0;
        }
      }

      function setStoredRolls(n) {
        diceRolls = Math.max(0, n | 0);
        try {
          localStorage.setItem(ROLLS_KEY, String(diceRolls));
        } catch(_) {}
        if (ROLLS_VALUE) ROLLS_VALUE.textContent = String(diceRolls);
        if (HERO_BTN) {
          HERO_BTN.disabled = diceRolls <= 0;
          HERO_BTN.classList.toggle('dl-disabled', diceRolls <= 0);
        }

        if (typeof renderLastRollShop === 'function') {
          renderLastRollShop();
        }
      }

            // --- Shield state (localStorage) ---
      let shieldCount = MAX_SHIELDS;

      function getStoredShields() {
        try {
          const raw = localStorage.getItem(SHIELDS_KEY);
          if (!raw && raw !== '0') return MAX_SHIELDS; // Default to two shields on first load
          const n = parseInt(raw, 10);
          if (!Number.isFinite(n) || n < 0) return 0;
          return Math.min(MAX_SHIELDS, n);
        } catch (_) {
          return MAX_SHIELDS;
        }
      }

      function setStoredShields(n) {
        shieldCount = Math.min(
          MAX_SHIELDS,
          Math.max(0, n | 0)
        );
        try {
          localStorage.setItem(SHIELDS_KEY, String(shieldCount));
        } catch (_) {}
        renderShields();
      }

      function renderShields() {
        if (!SHIELDS_CONTAINER) return;

        SHIELDS_CONTAINER.innerHTML = '';

        const row = document.createElement('div');
        row.className = 'dl-shields-row';

        const max = MAX_SHIELDS;
        for (let i = 0; i < max; i++) {
          const wrap = document.createElement('div');
          wrap.className = 'dl-shield-icon-wrapper';

          const icon = document.createElement('span');
          icon.className = 'dl-shield-icon';
          if (i >= shieldCount) {
            icon.classList.add('is-used');
          }

          const tip = document.createElement('div');
          tip.className = 'dl-shield-tooltip';
          tip.textContent = (i < shieldCount)
            ? 'Blocks the next curse when you roll'
            : 'Used shield (no protection)';

          wrap.appendChild(icon);
          wrap.appendChild(tip);
          row.appendChild(wrap);
        }

        SHIELDS_CONTAINER.appendChild(row);
      }

      function savePermaLocked() {
        saveJSON(PERMA_LOCK_KEY, permaLockedSlots);
        saveJSON(PERMA_LOCK_NAMES_KEY, permaLockedSlotNames);
      }

      // --- Locked slots & soul links state ---
      let lockedSlots = [false, false, false, false, false, false];
      let lockedSlotNames = loadJSON('dl_locked_slot_names', [null, null, null, null, null, null]);
      let soulLinks   = [];
      let pokemons    = [];
      let editingPokemonId = null;
      let editingPokemonOriginalLocation = null;
      let permaLockedSlots = loadJSON(PERMA_LOCK_KEY, [false, false, false, false, false, false]).map(Boolean);
      let permaLockedSlotNames = loadJSON(PERMA_LOCK_NAMES_KEY, [null, null, null, null, null, null]);

      function saveLockedSlotNames() {
        saveJSON('dl_locked_slot_names', lockedSlotNames);
      }

      function loadLockedSlots() {
        try {
          const raw = localStorage.getItem(LOCK_KEY);
          if (raw) {
            const arr = JSON.parse(raw);
            if (Array.isArray(arr) && arr.length === 6) {
              lockedSlots = arr.map(Boolean);
            }
          }
        } catch(_) {}
        // Ensure perma lock arrays are valid
        if (!Array.isArray(permaLockedSlots) || permaLockedSlots.length !== 6) {
          permaLockedSlots = [false, false, false, false, false, false];
        }
        if (!Array.isArray(permaLockedSlotNames) || permaLockedSlotNames.length !== 6) {
          permaLockedSlotNames = [null, null, null, null, null, null];
        }
        savePermaLocked();
        applyLockedSlotStyles();
        updateUnlockButtonState();
      }

      function setLockedSlots(arr) {
        const base = Array.isArray(arr) && arr.length === 6 ? arr.map(Boolean) : [false,false,false,false,false,false];
        // Permanent locks override ordinary locks
        lockedSlots = base.map((v, i) => v || !!permaLockedSlots[i]);

        try { localStorage.setItem(LOCK_KEY, JSON.stringify(lockedSlots)); } catch(_) {}
        applyLockedSlotStyles();
        updateUnlockButtonState();
      }

      function applyLockedSlotStyles() {
        // Visual lock is handled in renderPartyUI via .dl-team-slot--locked
        renderPartyUI();
      }

      function getPokemonDisplayName(pokemon) {
        if (!pokemon) return '(Missing Pokémon)';
        return (
          (pokemon.name || '').trim() ||
          (pokemon.species || '').trim() ||
          '(Unnamed Pokémon)'
        );
      }

      function getPokemonById(id) {
        return pokemons.find(p => p.id === id) || null;
      }

      function getSoulLinkMemberIds(link) {
        if (!link || !Array.isArray(link.memberIds)) return [];

        return Array.from(
          new Set(
            link.memberIds.filter(id =>
              typeof id === 'string' &&
              id &&
              Boolean(getPokemonById(id))
            )
          )
        );
      }

      function findLegacyPokemonId(name, preferredLocation, reservedIds) {
        const normalized = String(name || '').trim().toLowerCase();
        if (!normalized) return null;

        const available = pokemons.filter(p => {
          if (reservedIds?.has(p.id)) return false;
          return String(p.name || '').trim().toLowerCase() === normalized;
        });

        const preferred = available.find(
          p => !preferredLocation || p.location === preferredLocation
        );

        return (preferred || available[0] || null)?.id || null;
      }

      function normalizeSoulLink(link) {
        if (!link) return null;

        const expectedSize = link.type === 'triple' ? 3 : 2;
        let memberIds = [];

        if (Array.isArray(link.memberIds)) {
          memberIds = getSoulLinkMemberIds(link);
        } else {
          const reserved = new Set();

          if ((link.type === 'pair' || !link.type) && link.team && link.box) {
            const teamId = findLegacyPokemonId(
              link.team,
              'team',
              reserved
            );
            if (teamId) reserved.add(teamId);

            const boxId = findLegacyPokemonId(
              link.box,
              'box',
              reserved
            );
            if (boxId) reserved.add(boxId);

            memberIds = [teamId, boxId].filter(Boolean);
          } else if (
            link.type === 'triple' &&
            Array.isArray(link.members)
          ) {
            memberIds = link.members.map(name => {
              const id = findLegacyPokemonId(name, null, reserved);
              if (id) reserved.add(id);
              return id;
            }).filter(Boolean);
          }
        }

        memberIds = Array.from(new Set(memberIds));

        if (memberIds.length !== expectedSize) {
          return null;
        }

        return {
          type: expectedSize === 3 ? 'triple' : 'pair',
          memberIds
        };
      }

      function loadSoulLinks() {
        try {
          const raw = localStorage.getItem(SOUL_KEY);
          const arr = raw ? JSON.parse(raw) : [];

          soulLinks = Array.isArray(arr)
            ? arr.map(normalizeSoulLink).filter(Boolean)
            : [];

          // Always save the normalized format so old name-based links are
          // migrated to stable Pokémon IDs after the first page load.
          saveJSON(SOUL_KEY, soulLinks);
        } catch(_) {
          soulLinks = [];
        }

        renderSoulLinksSummary();
        renderPartyUI();
      }

      function setSoulLinks(arr) {
        soulLinks = Array.isArray(arr)
          ? arr.map(normalizeSoulLink).filter(Boolean)
          : [];

        saveJSON(SOUL_KEY, soulLinks);
        renderSoulLinksSummary();
        renderPartyUI();
      }

      function getLinkedMemberIdSet() {
        const ids = new Set();

        (soulLinks || []).forEach(link => {
          getSoulLinkMemberIds(link).forEach(id => ids.add(id));
        });

        return ids;
      }

      function getSoulLinkGroupIdsForPokemon(id) {
        const link = (soulLinks || []).find(candidate =>
          getSoulLinkMemberIds(candidate).includes(id)
        );

        return link ? getSoulLinkMemberIds(link) : [id];
      }

      function getSoulLinkPartnersForPokemon(id) {
        return getSoulLinkGroupIdsForPokemon(id)
          .filter(memberId => memberId !== id)
          .map(memberId => getPokemonById(memberId))
          .filter(Boolean);
      }

      function getSoulLinkPartnerNamesForPokemon(id) {
        return getSoulLinkPartnersForPokemon(id).map(
          pokemon => getPokemonDisplayName(pokemon)
        );
      }

      function appendSoulLinkBadge(container, pokemon) {
        if (!container || !pokemon) return;

        const partnerNames =
          getSoulLinkPartnerNamesForPokemon(pokemon.id);
        if (!partnerNames.length) return;

        const linkedText =
          `Linked to ${partnerNames.join(' & ')}`;

        const badge = document.createElement('div');
        badge.className = 'dl-pokemon-soul-link';
        badge.title =
          `Soul Linked to ${partnerNames.join(', ')}`;
        badge.setAttribute(
          'aria-label',
          badge.title
        );

        const icon = document.createElement('span');
        icon.className = 'dl-pokemon-soul-link-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '💞';

        const text = document.createElement('span');
        text.className = 'dl-pokemon-soul-link-text';
        text.textContent = linkedText;

        badge.appendChild(icon);
        badge.appendChild(text);
        container.appendChild(badge);
      }


      function appendBirdGodBadge(container, pokemon) {
        if (!container || !pokemon || !isBirdGodChampion(pokemon.id)) {
          return;
        }

        const badge = document.createElement('div');
        badge.className = 'dl-pokemon-birdgod';
        badge.title = "BirdGOD's champion cannot permanently die.";
        badge.setAttribute('aria-label', badge.title);

        const text = document.createElement('span');
        text.className = 'dl-pokemon-birdgod-text';
        text.textContent = "BirdGOD's Champion";

        badge.appendChild(text);
        container.appendChild(badge);
      }

      function showSoulLinkMoveReminder(
        pokemon,
        actionDescription
      ) {
        if (!pokemon) return false;

        const partnerNames =
          getSoulLinkPartnerNamesForPokemon(pokemon.id);
        if (!partnerNames.length) return false;

        const pokemonName =
          getPokemonDisplayName(pokemon);

        showRollerNotice(
          `${pokemonName} is Soul Linked to ` +
          `${partnerNames.join(' and ')}. ` +
          actionDescription,
          'Soul Link reminder'
        );

        return true;
      }

      function getCompleteSoulLinkGroupsForLocations(locations) {
        const allowed = new Set(locations || []);

        return (soulLinks || [])
          .map(link => getSoulLinkMemberIds(link))
          .filter(ids =>
            ids.length >= 2 &&
            ids.every(id => {
              const pokemon = getPokemonById(id);
              return (
                pokemon &&
                (!allowed.size || allowed.has(pokemon.location))
              );
            })
          );
      }

      function buildIndivisiblePokemonGroups(candidates) {
        const candidateIds = new Set(
          (candidates || []).map(p => p.id)
        );
        const groupedIds = new Set();
        const groups = [];

        (soulLinks || []).forEach(link => {
          const relevantIds = getSoulLinkMemberIds(link).filter(
            id => candidateIds.has(id)
          );

          if (!relevantIds.length) return;

          groups.push(relevantIds);
          relevantIds.forEach(id => groupedIds.add(id));
        });

        (candidates || []).forEach(pokemon => {
          if (!groupedIds.has(pokemon.id)) {
            groups.push([pokemon.id]);
          }
        });

        return groups;
      }

      function chooseRandomGroupsUpToLimit(groups, limit) {
        const shuffledGroups = shuffleArray(
          (groups || [])
            .map(group => Array.from(new Set(group)))
            .filter(group => group.length > 0 && group.length <= limit)
        );

        const best = Array(limit + 1).fill(null);
        best[0] = [];

        shuffledGroups.forEach(group => {
          const size = group.length;

          for (let total = limit - size; total >= 0; total--) {
            if (!best[total]) continue;

            const nextTotal = total + size;
            const candidate = [...best[total], group];

            if (!best[nextTotal] || Math.random() < 0.5) {
              best[nextTotal] = candidate;
            }
          }
        });

        for (let total = limit; total >= 0; total--) {
          if (best[total]) return best[total];
        }

        return [];
      }

      function removeSoulLink(index) {
        const newLinks = (soulLinks || []).filter((_, i) => i !== index);
        setSoulLinks(newLinks);
      }

      function renderSoulLinksSummary() {
        if (!SOUL_SUMMARY) return;
        SOUL_SUMMARY.innerHTML = '';
        if (!soulLinks.length) return;

        const label = document.createElement('span');
        label.className = 'dl-soul-links-summary-title';
        label.textContent = 'Soul Links:';
        SOUL_SUMMARY.appendChild(label);

        soulLinks.forEach((link, index) => {
          const tag = document.createElement('span');
          tag.className = 'dl-soul-link-tag';

          const textSpan = document.createElement('span');
          const names = getSoulLinkMemberIds(link).map(id =>
            getPokemonDisplayName(getPokemonById(id))
          );

          textSpan.textContent = names.length
            ? names.join(' ⇔ ')
            : '(Invalid Soul Link)';

          const closeBtn = document.createElement('button');
          closeBtn.type = 'button';
          closeBtn.className = 'dl-soul-link-close';
          closeBtn.setAttribute('aria-label', 'Remove soul link');
          closeBtn.textContent = '✕';
          closeBtn.addEventListener('click', () => removeSoulLink(index));

          tag.appendChild(textSpan);
          tag.appendChild(closeBtn);

          SOUL_SUMMARY.appendChild(tag);
        });
      }

      function updateUnlockButtonState() {
        if (!UNLOCK_SLOTS_BTN) return;

        const hasUnlockableLock = lockedSlots.some(
          (isLocked, index) =>
            isLocked && !permaLockedSlots[index]
        );

        UNLOCK_SLOTS_BTN.disabled = !hasUnlockableLock;
        UNLOCK_SLOTS_BTN.classList.toggle(
          'dl-disabled',
          !hasUnlockableLock
        );
      }

      // --- Pokémon data model ---
      function normalizePokemonGender(value) {
        const normalized = String(value || '').trim().toLowerCase();
        return (
          normalized === 'male' ||
          normalized === 'female' ||
          normalized === 'genderless'
        ) ? normalized : '';
      }

      function getPokemonGenderLabel(value) {
        const gender = normalizePokemonGender(value);
        if (gender === 'male') return 'Male';
        if (gender === 'female') return 'Female';
        if (gender === 'genderless') return 'Genderless';
        return '';
      }

      function loadPokemons() {
        try {
          const raw = localStorage.getItem(POKEMON_KEY);
          if (raw) {
            const arr = JSON.parse(raw);
            if (Array.isArray(arr)) {
              pokemons = arr.map(p => ({
                id: p.id || `${Date.now()}-${Math.random().toString(16).slice(2)}`,
                name: p.name || '',
                species: p.species || '',
                nature: p.nature || '',
                gender: normalizePokemonGender(p.gender),
                location: (p.location === 'team' || p.location === 'box' || p.location === 'grave') ? p.location : 'box',
                slotIndex: Number.isInteger(p.slotIndex) ? p.slotIndex : null
              }));
            } else {
              pokemons = [];
            }
          } else {
            pokemons = [];
          }
        } catch(_) {
          pokemons = [];
        }
        renderPartyUI();
      }

      function savePokemons() {
        try { localStorage.setItem(POKEMON_KEY, JSON.stringify(pokemons)); } catch(_) {}
        renderPartyUI();
        renderSoulLinksSummary();
      }

      function findAvailableSlot(preferred, editingId) {
        if (
          typeof preferred === 'number' &&
          preferred >= 0 &&
          preferred < 6 &&
          !lockedSlots[preferred] && !permaLockedSlots[preferred]
        ) {
          const occupant = pokemons.find(
            p => p.location === 'team' && p.slotIndex === preferred
          );
          if (!occupant || (editingId && occupant.id === editingId)) {
            return preferred;
          }
        }

        for (let i = 0; i < 6; i++) {
          if (lockedSlots[i] || permaLockedSlots[i]) continue;
          const occ = pokemons.find(p => p.location === 'team' && p.slotIndex === i);
          if (!occ || (editingId && occ.id === editingId)) {
            return i;
          }
        }
        return null;
      }

      function movePokemonToBox(id) {
        const mon = pokemons.find(p => p.id === id);
        if (!mon) return;
        mon.location = 'box';
        mon.slotIndex = null;
        savePokemons();
      }

      function movePokemonToTeam(id, preferredSlotIndex) {
        const mon = pokemons.find(p => p.id === id);
        if (!mon) return;

        const pref = typeof preferredSlotIndex === 'number' ? preferredSlotIndex : null;
        const slot = findAvailableSlot(pref, mon.id);
        if (slot == null) {
          showRollerNotice(
            'All six team slots are currently filled or locked.',
            'No team slot available'
          );
          return;
        }
        const existing = pokemons.find(p => p.location === 'team' && p.slotIndex === slot);
        if (existing && existing.id !== mon.id) {
          existing.location = 'box';
          existing.slotIndex = null;
        }
        mon.location = 'team';
        mon.slotIndex = slot;
        savePokemons();
      }

      function deletePokemonById(id) {
        const mon = pokemons.find(p => p.id === id);
        if (!mon) return;

        const pokemonName = mon.name || mon.species || 'this Pokémon';

        showRollerDialog({
          title: 'Remove Pokémon permanently?',
          message:
            `${pokemonName} will be completely removed from this Dicelocke roster. ` +
            'This cannot be undone.',
          confirmText: 'Remove permanently',
          cancelText: 'Keep Pokémon',
          tone: 'danger',
          onConfirm: () => {
            const currentIndex = pokemons.findIndex(p => p.id === id);
            if (currentIndex === -1) return;

            pokemons.splice(currentIndex, 1);
            setSoulLinks(
              (soulLinks || []).filter(link =>
                !getSoulLinkMemberIds(link).includes(id)
              )
            );
            savePokemons();
          }
        });
      }

      function formatPokemonNameList(names) {
        const cleanNames = (names || []).filter(Boolean);

        if (!cleanNames.length) return '';
        if (cleanNames.length === 1) return cleanNames[0];
        if (cleanNames.length === 2) {
          return `${cleanNames[0]} and ${cleanNames[1]}`;
        }

        return (
          `${cleanNames.slice(0, -1).join(', ')}, and ` +
          cleanNames[cleanNames.length - 1]
        );
      }

      function movePokemonGroupToGrave(
        memberIds,
        faintedPokemon
      ) {
        const uniqueIds = Array.from(
          new Set(memberIds || [])
        );
        const newlyGraved = [];

        uniqueIds.forEach(memberId => {
          const pokemon = getPokemonById(memberId);

          if (!pokemon || pokemon.location === 'grave') {
            return;
          }

          if (isBirdGodChampion(pokemon.id)) {
            protectBirdGodChampionFromGrave(pokemon, {
              showNotice: false
            });
            return;
          }

          pokemon.location = 'grave';
          pokemon.slotIndex = null;
          newlyGraved.push(pokemon);
        });

        if (!newlyGraved.length) return;

        savePokemons();

        const faintedName =
          getPokemonDisplayName(faintedPokemon);
        const linkedDeaths = newlyGraved.filter(
          pokemon => pokemon.id !== faintedPokemon.id
        );
        const linkedNames = linkedDeaths.map(
          pokemon => getPokemonDisplayName(pokemon)
        );

        if (sacredRebirthActive) {
          setStoredRolls(
            diceRolls + newlyGraved.length
          );
        }

        if (linkedNames.length) {
          let detail =
            `${faintedName} fainted. Its Soul Link pulled ` +
            `${formatPokemonNameList(linkedNames)} into the ` +
            'graveyard as well.';

          if (sacredRebirthActive) {
            detail +=
              ` Ho-Oh granted +${newlyGraved.length} ` +
              `${newlyGraved.length === 1 ? 'Dice Roll' : 'Dice Rolls'}.`;
          }

          recordHistory({
            kind: 'event',
            title: 'Soul Link deaths',
            detail
          });
        } else if (sacredRebirthActive) {
          recordHistory({
            kind: 'event',
            title: 'Sacred Rebirth roll gained',
            detail:
              `${faintedName} fainted. Ho-Oh granted +1 Dice Roll.`
          });
        }
      }

      function sendToGraveById(id) {
        const mon = getPokemonById(id);
        if (!mon || mon.location === 'grave') return;

        if (isBirdGodChampion(mon.id)) {
          protectBirdGodChampionFromGrave(mon);
          return;
        }

        const linkedGroupIds =
          getSoulLinkGroupIdsForPokemon(id);
        const livingLinkedPartners =
          linkedGroupIds
            .filter(memberId => memberId !== id)
            .map(memberId => getPokemonById(memberId))
            .filter(
              pokemon =>
                pokemon &&
                pokemon.location !== 'grave'
            );

        if (!livingLinkedPartners.length) {
          movePokemonGroupToGrave([id], mon);
          return;
        }

        const faintedName =
          getPokemonDisplayName(mon);
        const partnerNames =
          livingLinkedPartners.map(
            pokemon => getPokemonDisplayName(pokemon)
          );
        const totalDeaths =
          livingLinkedPartners.length + 1;

        let message =
          `${faintedName} is Soul Linked to ` +
          `${formatPokemonNameList(partnerNames)}. ` +
          `If ${faintedName} dies, ` +
          `${formatPokemonNameList(partnerNames)} ` +
          `${livingLinkedPartners.length === 1 ? 'dies' : 'die'} ` +
          'as well.';

        if (sacredRebirthActive) {
          message +=
            ` Sacred Rebirth will grant +${totalDeaths} ` +
            `${totalDeaths === 1 ? 'Dice Roll' : 'Dice Rolls'} ` +
            'for the Pokémon newly moved to the graveyard.';
        }

        showRollerDialog({
          title: 'Soul Link death',
          message,
          confirmText:
            totalDeaths === 2
              ? 'Send both to graveyard'
              : 'Send linked group to graveyard',
          cancelText: 'Cancel',
          tone: 'danger',
          onConfirm: () => {
            movePokemonGroupToGrave(
              linkedGroupIds,
              mon
            );
          }
        });
      }

      function updatePartyNavigationCounts() {
        const boxedCount = pokemons.filter(
          pokemon => pokemon.location === 'box'
        ).length;
        const graveCount = pokemons.filter(
          pokemon => pokemon.location === 'grave'
        ).length;

        const boxLabel = `View box (${boxedCount})`;
        const graveLabel = `View graveyard (${graveCount})`;

        [VIEW_BOX_BTN, GRAVE_VIEW_BOX_BTN].forEach(button => {
          if (!button) return;
          button.textContent = boxLabel;
          button.setAttribute('aria-label', boxLabel);
        });

        [VIEW_GRAVE_BTN, VIEW_GRAVE_BTN2].forEach(button => {
          if (!button) return;
          button.textContent = graveLabel;
          button.setAttribute('aria-label', graveLabel);
        });
      }

      function renderPartyUI() {
        // Team slots
        if (TEAM_SLOTS_CONTAINER) {
          const slots = TEAM_SLOTS_CONTAINER.querySelectorAll('.dl-team-slot');
          slots.forEach(slotEl => {
            const idx = parseInt(slotEl.getAttribute('data-slot-index'), 10);
            const body = slotEl.querySelector('.dl-team-slot-body');
            if (!body) return;
            body.innerHTML = '';

            const mon = pokemons.find(p => p.location === 'team' && p.slotIndex === idx);
            const isLocked = !!lockedSlots[idx];

            slotEl.classList.toggle('dl-team-slot--locked', isLocked);

            if (mon) {
              const card = document.createElement('div');
              card.className = 'dl-pokemon-card dl-pokemon-card--team';

              // Header: name + delete "x"
              const header = document.createElement('div');
              header.className = 'dl-pokemon-header';

              const nameEl = document.createElement('div');
              nameEl.className = 'dl-pokemon-name';
              const pokemonDisplayName =
                mon.name || '(Unnamed Pokémon)';
              nameEl.textContent = pokemonDisplayName;
              nameEl.title = pokemonDisplayName;

              const removeBtn = document.createElement('button');
              removeBtn.type = 'button';
              removeBtn.className = 'dl-pokemon-remove';
              removeBtn.textContent = '✕';
              removeBtn.setAttribute('aria-label', 'Move to Graveyard');
              removeBtn.title = 'Move to Graveyard';
              removeBtn.addEventListener('click', () => sendToGraveById(mon.id));

              header.appendChild(nameEl);
              header.appendChild(removeBtn);
              card.appendChild(header);

              // Meta line
              const metaParts = [];
              if (mon.species) metaParts.push(mon.species);
              if (mon.nature)  metaParts.push(mon.nature);
              const genderLabel = getPokemonGenderLabel(mon.gender);
              if (genderLabel) metaParts.push(genderLabel);
              if (metaParts.length) {
                const metaEl = document.createElement('div');
                metaEl.className = 'dl-pokemon-meta';
                const pokemonMetaText = metaParts.join(' • ');
                metaEl.textContent = pokemonMetaText;
                metaEl.title = pokemonMetaText;
                card.appendChild(metaEl);
              }

              appendSoulLinkBadge(card, mon);
              appendBirdGodBadge(card, mon);

              const actions = document.createElement('div');
              actions.className = 'dl-pokemon-actions';

              const editBtn = document.createElement('button');
              editBtn.type = 'button';
              editBtn.className = 'dl-pokemon-btn';
              editBtn.textContent = 'Edit';
              editBtn.addEventListener('click', () => openPokemonEditor(mon.id));

              const moveBtn = document.createElement('button');
              moveBtn.type = 'button';
              moveBtn.className = 'dl-pokemon-btn';
              moveBtn.textContent = 'Move to box';
              moveBtn.addEventListener('click', () => movePokemonToBox(mon.id));

              actions.appendChild(editBtn);
              actions.appendChild(moveBtn);

              card.appendChild(actions);
              body.appendChild(card);

            } else if (isLocked) {
              const info = document.createElement('div');
              info.className = 'dl-team-slot-locked-label';

              const isPerma = !!permaLockedSlots[idx];
              const emphasizedName =
                document.createElement('strong');

              if (isPerma) {
                const label =
                  permaLockedSlotNames[idx] || 'Darkrai';

                info.append(
                  document.createTextNode(
                    'Locked permanently ('
                  )
                );
                emphasizedName.textContent = label;
                info.appendChild(emphasizedName);
                info.append(
                  document.createTextNode(
                    ') - cannot be unlocked.'
                  )
                );
              } else {
                const boxedName =
                  lockedSlotNames[idx] || 'Pokémon';

                info.append(
                  document.createTextNode('Locked (')
                );
                emphasizedName.textContent = boxedName;
                info.appendChild(emphasizedName);
                info.append(
                  document.createTextNode(
                    ' boxed until next Gym complete)'
                  )
                );
              }

              body.appendChild(info);
            } else {
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'dl-pokemon-btn dl-pokemon-btn--ghost';
              btn.textContent = 'Add a Pokémon';
              btn.addEventListener('click', () => {
                openPokemonEditor(null, { location: 'team', slotIndex: idx });
              });
              body.appendChild(btn);
            }
          });
        }

        // Box list
        if (BOXED_LIST_UI) {
          BOXED_LIST_UI.innerHTML = '';
          const boxedMons = pokemons.filter(p => p.location === 'box');
          if (!boxedMons.length) {
            const empty = document.createElement('div');
            empty.className = 'dl-effects-empty';
            empty.textContent = 'No boxed Pokémon yet.';
            BOXED_LIST_UI.appendChild(empty);
          } else {
            boxedMons.forEach(mon => {
              const row = document.createElement('div');
              row.className = 'dl-pokemon-card dl-pokemon-card--box';

              // Header: name + delete "x"
              const header = document.createElement('div');
              header.className = 'dl-pokemon-header';

              const nameEl = document.createElement('div');
              nameEl.className = 'dl-pokemon-name';
              const pokemonDisplayName =
                mon.name || '(Unnamed Pokémon)';
              nameEl.textContent = pokemonDisplayName;
              nameEl.title = pokemonDisplayName;

              const removeBtn = document.createElement('button');
              removeBtn.type = 'button';
              removeBtn.className = 'dl-pokemon-remove';
              removeBtn.textContent = '✕';
              removeBtn.setAttribute('aria-label', 'Move to Graveyard');
              removeBtn.title = 'Move to Graveyard';
              removeBtn.addEventListener('click', () => sendToGraveById(mon.id));

              header.appendChild(nameEl);
              header.appendChild(removeBtn);
              row.appendChild(header);

              const metaParts = [];
              if (mon.species) metaParts.push(mon.species);
              if (mon.nature)  metaParts.push(mon.nature);
              const genderLabel = getPokemonGenderLabel(mon.gender);
              if (genderLabel) metaParts.push(genderLabel);
              if (metaParts.length) {
                const metaEl = document.createElement('div');
                metaEl.className = 'dl-pokemon-meta';
                const pokemonMetaText = metaParts.join(' • ');
                metaEl.textContent = pokemonMetaText;
                metaEl.title = pokemonMetaText;
                row.appendChild(metaEl);
              }

              appendSoulLinkBadge(row, mon);
              appendBirdGodBadge(row, mon);

              const actions = document.createElement('div');
              actions.className = 'dl-pokemon-actions';

              const toTeamBtn = document.createElement('button');
              toTeamBtn.type = 'button';
              toTeamBtn.className = 'dl-pokemon-btn';
              toTeamBtn.textContent = 'Move to team';
              toTeamBtn.addEventListener('click', () => movePokemonToTeam(mon.id));

              const editBtn = document.createElement('button');
              editBtn.type = 'button';
              editBtn.className = 'dl-pokemon-btn';
              editBtn.textContent = 'Edit';
              editBtn.addEventListener('click', () => openPokemonEditor(mon.id));

              actions.appendChild(toTeamBtn);
              actions.appendChild(editBtn);

              row.appendChild(actions);
              BOXED_LIST_UI.appendChild(row);
            });
          }
        }

        // Graveyard list
        if (GRAVE_LIST_UI) {
          GRAVE_LIST_UI.innerHTML = '';
          const graveMons = pokemons.filter(p => p.location === 'grave');

          if (!graveMons.length) {
            const empty = document.createElement('div');
            empty.className = 'dl-effects-empty';
            empty.textContent = 'No Pokémon in the graveyard.';
            GRAVE_LIST_UI.appendChild(empty);
          } else {
            graveMons.forEach(mon => {
              const row = document.createElement('div');
              row.className = 'dl-pokemon-card dl-pokemon-card--box';

              // Header: name + PERMANENT delete "x"
              const header = document.createElement('div');
              header.className = 'dl-pokemon-header';

              const nameEl = document.createElement('div');
              nameEl.className = 'dl-pokemon-name';
              const pokemonDisplayName =
                mon.name || '(Unnamed Pokémon)';
              nameEl.textContent = pokemonDisplayName;
              nameEl.title = pokemonDisplayName;

              const removeBtn = document.createElement('button');
              removeBtn.type = 'button';
              removeBtn.className = 'dl-pokemon-remove';
              removeBtn.textContent = '✕';
              removeBtn.setAttribute('aria-label', 'Remove Pokémon permanently');
              removeBtn.title = 'Remove Pokémon permanently';
              removeBtn.addEventListener('click', () => deletePokemonById(mon.id));

              header.appendChild(nameEl);
              header.appendChild(removeBtn);
              row.appendChild(header);

              const metaParts = [];
              if (mon.species) metaParts.push(mon.species);
              if (mon.nature)  metaParts.push(mon.nature);
              const genderLabel = getPokemonGenderLabel(mon.gender);
              if (genderLabel) metaParts.push(genderLabel);
              if (metaParts.length) {
                const metaEl = document.createElement('div');
                metaEl.className = 'dl-pokemon-meta';
                const pokemonMetaText = metaParts.join(' • ');
                metaEl.textContent = pokemonMetaText;
                metaEl.title = pokemonMetaText;
                row.appendChild(metaEl);
              }

              appendSoulLinkBadge(row, mon);
              appendBirdGodBadge(row, mon);

              const actions = document.createElement('div');
              actions.className = 'dl-pokemon-actions';

              // Allow manual revival, such as after a Nat 20 blessing
              const toTeamBtn = document.createElement('button');
              toTeamBtn.type = 'button';
              toTeamBtn.className = 'dl-pokemon-btn';
              toTeamBtn.textContent = 'Move to team';
              toTeamBtn.addEventListener('click', () => movePokemonToTeam(mon.id));

              const toBoxBtn = document.createElement('button');
              toBoxBtn.type = 'button';
              toBoxBtn.className = 'dl-pokemon-btn';
              toBoxBtn.textContent = 'Move to box';
              toBoxBtn.addEventListener('click', () => movePokemonToBox(mon.id));

              const editBtn = document.createElement('button');
              editBtn.type = 'button';
              editBtn.className = 'dl-pokemon-btn';
              editBtn.textContent = 'Edit';
              editBtn.addEventListener('click', () => openPokemonEditor(mon.id));

              actions.appendChild(toTeamBtn);
              actions.appendChild(toBoxBtn);
              actions.appendChild(editBtn);

              row.appendChild(actions);
              GRAVE_LIST_UI.appendChild(row);
            });
          }
        }

        updatePartyNavigationCounts();
        updateUnlockButtonState();
      }

      // --- Compatibility helpers for legacy name-based logic ---
      function getTeamArray() {
        return pokemons
          .filter(p => p.location === 'team')
          .sort((a, b) => (a.slotIndex ?? 999) - (b.slotIndex ?? 999))
          .map(p => (p.name || '').trim());
      }

      function getBoxedArray() {
        return pokemons
          .filter(p => p.location === 'box')
          .map(p => (p.name || '').trim());
      }

      // --- Pokémon editor ---
      function setEditorVisible(show) {
        if (!EDITOR || !PARTY_ROW) return;

        if (show) {
          // Show only the editor
          PARTY_ROW.style.display = 'none';
          EDITOR.style.display = 'block';
        } else {
          // Restore the current party subview
          PARTY_ROW.style.display = '';
          EDITOR.style.display = 'none';
          applyPartyViewMode();
        }
      }

      function getEditorLocation() {
        let value = null;

        LOCATION_RADIOS.forEach(r => {
          if (r.checked) value = r.value;
        });

        if (value === 'team' || value === 'box') {
          return value;
        }

        if (
          editingPokemonId &&
          editingPokemonOriginalLocation === 'grave'
        ) {
          return 'grave';
        }

        return 'box';
      }

      function openPokemonEditor(id, defaults) {
        if (!EDITOR) return;

        const isNew = !id;

        // Open the party panel before editing or adding
        setTopMode('party');

        editingPokemonId = id || null;
        editingPokemonOriginalLocation = null;
        const target = defaults || {};

        if (EDITOR_TITLE) {
          EDITOR_TITLE.textContent = isNew ? 'Add Pokémon' : 'Edit Pokémon';
        }

        if (isNew) {
          if (FIELD_NAME) FIELD_NAME.value = '';
          if (FIELD_SPECIES) FIELD_SPECIES.value = '';
          if (FIELD_NATURE) FIELD_NATURE.value = '';
          if (FIELD_GENDER) FIELD_GENDER.value = '';

          const loc = target.location || 'team';
          LOCATION_RADIOS.forEach(r => {
            r.checked = (r.value === loc);
          });

          if (FIELD_SLOT_WRAPPER) FIELD_SLOT_WRAPPER.hidden = (loc !== 'team');
          if (FIELD_SLOT && loc === 'team') {
            if (typeof target.slotIndex === 'number') {
              FIELD_SLOT.value = String(target.slotIndex);
            } else {
              FIELD_SLOT.value = 'auto';
            }
          }
        } else {
          const mon = pokemons.find(p => p.id === id);
          if (!mon) return;

          editingPokemonOriginalLocation = mon.location || 'box';

          if (FIELD_NAME) FIELD_NAME.value = mon.name || '';
          if (FIELD_SPECIES) FIELD_SPECIES.value = mon.species || '';
          if (FIELD_NATURE) FIELD_NATURE.value = mon.nature || '';
          if (FIELD_GENDER) {
            FIELD_GENDER.value = normalizePokemonGender(mon.gender);
          }

          const loc = mon.location || 'box';
          LOCATION_RADIOS.forEach(r => {
            r.checked = (r.value === loc);
          });

          if (FIELD_SLOT_WRAPPER) FIELD_SLOT_WRAPPER.hidden = (loc !== 'team');
          if (FIELD_SLOT && loc === 'team') {
            if (Number.isInteger(mon.slotIndex)) {
              FIELD_SLOT.value = String(mon.slotIndex);
            } else {
              FIELD_SLOT.value = 'auto';
            }
          }
        }

        setEditorVisible(true);
      }

      function closePokemonEditor() {
        editingPokemonId = null;
        editingPokemonOriginalLocation = null;
        setEditorVisible(false);
      }

    const WHITEOUT_EVENTS = [
      {
        id: 'alternate_timeline',
        title: 'The Alternate Timeline',
        legend: 'Dialga',
        flavor: `Time fractures at the moment of defeat. Dialga anchors only those who stood with you at the end, then reaches into another timeline and pulls back one hero who still has a role to play.`,
        effect: `Effect: All Pokémon in your active party at the moment of whiteout are revived. All other Pokémon are immediately moved to the Graveyard. You also gain The Comeback Kid blessing as Dialga pulls a hero from another timeline. NOTE: Cheat in your previous-Dicelocke mon exactly as it was.`
      },
      {
        id: 'inversion_world',
        title: 'The Inversion World',
        legend: 'Giratina',
        flavor: `The world turns inside out. The fallen rise. The living are cast into shadow.`,
        effect: `Effect: All Pokémon in the Graveyard are revived and moved to the box. All Pokémon currently in your box and active party at the time of whiteout are moved to the Graveyard. Then, all active Blessings become random Curses, and all active Curses become random Blessings.`
      },
      {
        id: 'final_wish',
        title: 'The Final Wish',
        legend: 'Jirachi',
        flavor: `Jirachi grants your wish.`,
        effect: `Effect: All blessings and curses are removed and you lose all of your dice rolls in addition to one of the following effects.`,
        choices: [
          { id: 'revive_3', label: 'Revive 3 Pokémon' },
          { id: 'revive_6_random', label: 'Revive 6 random Pokémon' },
          { id: 'gain_30_rolls_2_shields', label: 'Gain 30 Dice Rolls + 2 Shields' }
        ]
      },
      {
        id: 'sacred_rebirth',
        title: 'Sacred Rebirth',
        legend: 'Ho-Oh',
        flavor: `From ash and flame, Ho-Oh restores all souls. Hold these friends close, for they are all you have.`,
        effect: `Effect: All of your Pokemon are revived. You gain +1 Dice Roll every time a Pokemon faints. You may not catch Pokemon for the rest of the playthrough, unless a Blessing allows it.`
      },
      {
        id: 'nightmare_bargain',
        title: 'Nightmare Bargain',
        legend: 'Darkrai',
        flavor: `You wake up. Everything is the same... except you. The nightmare has only just begun...`,
        effect: `Effect: All Pokemon return as they were before your whiteout. All of your active blessings are converted to "Refresh a Pokemon Center". All of your active curses are converted to "Team Shuffle". You are afflicted with 2 empowered, permanent curses.`
      },

      {
        id: 'birdgod_champion',
        title: 'Champion of the Flock',
        legend: 'BirdGOD',
        flavor: `The flock gathers over the battlefield. BirdGOD points one wing at a fallen hero and refuses to let their story end there.`,
        effect: `Effect: Select one fallen Pokémon from the Graveyard that contributed something special to the team or died heroically. That Pokémon is revived and becomes BirdGOD's champion. BirdGOD's champion cannot die - if it faints, you must box it until the next Pokemon Center is used. BirdGOD also clears all Team Shuffle and Lock & Box curses. Praise BirdGOD.`
      },
      {
        id: 'tide_carries_on',
        title: 'The Tide Carries On',
        legend: 'Manaphy',
        flavor: `As it all falls silent, Manaphy drifts in with the tide, carrying three Eggs. They were found hidden far from the battlefield, watched over by the sea. It seems that while some of your friends have been lost, something of them still remains. Manaphy discovered these Eggs before the whiteout, sheltered them in the tide, and now returns them as a final parting gift.`,
        effect: `Effect: Breed 3 Eggs of your choice. Each Egg must include at least one parent from the Graveyard. The other parent may be alive or also from your Graveyard. This is a manual effect. Create the Eggs using the closest legal or practical method available for your game.`
      },
      {
        id: 'judgment',
        title: 'Judgment',
        legend: 'Arceus',
        flavor: `Step forward and be judged. There is no other authority here.`,
        effect: `Effect: Arceus chooses Pokémon across your team, box and graveyard that it deems worthy. They are revived, but all others are completely erased and can no longer be interacted with. All curses are cleared. You also gain 1 of each basic Dice Roll blessing.`
      }
    ];

    function updateWhiteoutInterventionTheme() {
      const chosen = loadWhiteoutChoice();
      const interventionId =
        chosen?.id ||
        (sacredRebirthActive ? 'sacred_rebirth' : '');

      if (interventionId) {
        root.setAttribute(
          'data-whiteout-intervention',
          interventionId
        );
      } else {
        root.removeAttribute('data-whiteout-intervention');
      }
    }

    function saveWhiteoutChoice(obj) {
      saveJSON(WHITEOUT_KEY, obj);
      updateWhiteoutInterventionTheme();
    }

    function loadWhiteoutChoice() {
      return loadJSON(WHITEOUT_KEY, null);
    }

    function getFinalWishChoiceLabel(subchoiceId) {
      const labels = {
        revive_3: 'Revive 3 Pokémon',
        revive_6_random: 'Revive 6 random Pokémon',
        gain_30_rolls_2_shields: 'Gain 30 Dice Rolls + 2 Shields'
      };

      return labels[subchoiceId] || '';
    }

      if (ADD_POKEMON_BTN) {
        ADD_POKEMON_BTN.addEventListener('click', () => {
          // Open the party view before launching the editor
          setTopMode('party');
          openPokemonEditor(null, { location: 'box' });
        });
      }

      if (VIEW_GRAVE_BTN) {
        VIEW_GRAVE_BTN.addEventListener('click', () => {
          partyViewMode = 'grave';
          applyPartyViewMode();
        });
      }

      if (VIEW_GRAVE_BTN2) {
        VIEW_GRAVE_BTN2.addEventListener('click', () => {
          partyViewMode = 'grave';
          applyPartyViewMode();
        });
      }

      if (GRAVE_VIEW_TEAM_BTN) {
        GRAVE_VIEW_TEAM_BTN.addEventListener('click', () => {
          partyViewMode = 'team';
          applyPartyViewMode();
        });
      }

      if (GRAVE_VIEW_BOX_BTN) {
        GRAVE_VIEW_BOX_BTN.addEventListener('click', () => {
          partyViewMode = 'box';
          applyPartyViewMode();
        });
      }

      if (LOCATION_RADIOS && LOCATION_RADIOS.length) {
        LOCATION_RADIOS.forEach(r => {
          r.addEventListener('change', () => {
            const loc = getEditorLocation();
            if (FIELD_SLOT_WRAPPER) FIELD_SLOT_WRAPPER.hidden = (loc !== 'team');
          });
        });
      }

      if (CANCEL_POKEMON_BTN) {
        CANCEL_POKEMON_BTN.addEventListener('click', () => {
          closePokemonEditor();
        });
      }

      if (SAVE_POKEMON_BTN) {
        SAVE_POKEMON_BTN.addEventListener('click', () => {
          const name = FIELD_NAME ? FIELD_NAME.value.trim() : '';
          if (!name) {
            showRollerNotice(
              'Enter a name before saving this Pokémon.',
              'Pokémon name required'
            );
            return;
          }

          if (name.length > POKEMON_NAME_MAX_LENGTH) {
            showRollerNotice(
              `Pokémon names can be up to ${POKEMON_NAME_MAX_LENGTH} characters long.`,
              'Pokémon name is too long'
            );
            FIELD_NAME?.focus();
            return;
          }

          const species = FIELD_SPECIES ? FIELD_SPECIES.value.trim() : '';

          if (species.length > POKEMON_SPECIES_MAX_LENGTH) {
            showRollerNotice(
              `Pokémon species can be up to ${POKEMON_SPECIES_MAX_LENGTH} characters long.`,
              'Pokémon species is too long'
            );
            FIELD_SPECIES?.focus();
            return;
          }

          const nature = FIELD_NATURE ? FIELD_NATURE.value : '';
          const gender = normalizePokemonGender(
            FIELD_GENDER ? FIELD_GENDER.value : ''
          );

          if (!nature) {
            showRollerNotice(
              'Select a Nature before saving this Pokémon.',
              'Pokémon Nature required'
            );
            FIELD_NATURE?.focus();
            return;
          }

          if (!gender) {
            showRollerNotice(
              'Select Male, Female, or Genderless before saving this Pokémon.',
              'Pokémon gender required'
            );
            FIELD_GENDER?.focus();
            return;
          }

          const location = getEditorLocation();
          let slotChoice = null;

          // Read desired team slot (if shown and not "auto")
          if (
            location === 'team' &&
            FIELD_SLOT &&
            (!FIELD_SLOT_WRAPPER || !FIELD_SLOT_WRAPPER.hidden)
          ) {
            const raw = FIELD_SLOT.value;
            if (raw !== 'auto') {
              const idx = parseInt(raw, 10);
              if (Number.isInteger(idx)) slotChoice = idx;
            }
          }

          // Find an alternate empty, unlocked slot for a newly added Pokémon.
          function findEmptyUnlockedSlotExcluding(excludeIndex) {
            for (let i = 0; i < 6; i++) {
              if (i === excludeIndex) continue;
              if (lockedSlots[i] || permaLockedSlots[i]) continue;
              const occupied = pokemons.some(
                p => p.location === 'team' && p.slotIndex === i
              );
              if (!occupied) return i;
            }
            return null;
          }

          // --- EDITING EXISTING POKÉMON ---
          if (editingPokemonId) {
            const mon = pokemons.find(p => p.id === editingPokemonId);
            if (!mon) {
              closePokemonEditor();
              return;
            }

            mon.name = name;
            mon.species = species;
            mon.nature = nature;
            mon.gender = gender;

            const currentSlot =
              Number.isInteger(mon.slotIndex) ? mon.slotIndex : null;

            if (location === 'team') {
              let targetSlot = null;

              if (slotChoice == null) {
                // "Auto" – keep current slot if valid, otherwise first free unlocked
                targetSlot = findAvailableSlot(currentSlot, editingPokemonId);
              } else {
                // Specific slot selected; allow swapping with an occupant
                if (lockedSlots[slotChoice]) {
                  showRollerNotice(
                    'That team slot is locked until the next Gym is complete.',
                    'Team slot locked'
                  );
                  return;
                }
                targetSlot = slotChoice;
              }

              if (targetSlot == null) {
                showRollerNotice(
            'All six team slots are currently filled or locked.',
            'No team slot available'
          );
                return;
              }

              const existing = pokemons.find(
                p =>
                  p.location === 'team' &&
                  p.slotIndex === targetSlot &&
                  p.id !== mon.id
              );

              if (existing) {
                // Occupied-slot swap:
                // Return the occupant to this Pokémon's former unlocked slot.
                // Otherwise, move the occupant to the box.
                if (currentSlot != null && !lockedSlots[currentSlot]) {
                  existing.location = 'team';
                  existing.slotIndex = currentSlot;
                } else {
                  existing.location = 'box';
                  existing.slotIndex = null;
                }
              }

              mon.location = 'team';
              mon.slotIndex = targetSlot;
            } else if (location === 'grave') {
              // Editing a graveyard Pokémon should not revive it.
              mon.location = 'grave';
              mon.slotIndex = null;
            } else {
              // Move the Pokémon to the box
              mon.location = 'box';
              mon.slotIndex = null;
            }

          } else {
            // --- CREATING A BRAND NEW POKÉMON ---
            const mon = {
              id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
              name,
              species,
              nature,
              gender,
              location: 'box',
              slotIndex: null
            };

            if (location === 'team') {
              let targetSlot = null;

              if (slotChoice == null) {
                // Auto: first free unlocked slot
                targetSlot = findAvailableSlot(null, mon.id);
                if (targetSlot == null) {
                  showRollerNotice(
            'All six team slots are currently filled or locked.',
            'No team slot available'
          );
                  return;
                }
              } else {
                // Specific slot selected
                if (lockedSlots[slotChoice]) {
                  showRollerNotice(
                    'That team slot is locked until the next Gym is complete.',
                    'Team slot locked'
                  );
                  return;
                }

                targetSlot = slotChoice;

                // Specific-slot insertion:
                // Move the current occupant to another open slot or the box.
                const existing = pokemons.find(
                  p => p.location === 'team' && p.slotIndex === targetSlot
                );
                if (existing) {
                  const altSlot = findEmptyUnlockedSlotExcluding(targetSlot);
                  if (altSlot != null) {
                    existing.location = 'team';
                    existing.slotIndex = altSlot;
                  } else {
                    existing.location = 'box';
                    existing.slotIndex = null;
                  }
                }
              }

              mon.location = 'team';
              mon.slotIndex = targetSlot;
            } else {
              // Keep the new Pokémon in the box
              mon.location = 'box';
              mon.slotIndex = null;
            }

            pokemons.push(mon);
          }

          savePokemons();
          closePokemonEditor();
        });
      }

      // --- Nature-based team generation for roll 14 ---
      function shuffleArray(arr) {
        const a = arr.slice();
        for (let i = a.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
      }

      function buildPersonalityPokemonGroups(
        allMons,
        completeLinkedGroups
      ) {
        const livingIds = new Set(
          (allMons || []).map(pokemon => pokemon.id)
        );
        const groupedIds = new Set();
        const groups = [];

        (completeLinkedGroups || []).forEach(group => {
          const validIds = Array.from(new Set(group)).filter(
            id => livingIds.has(id) && !groupedIds.has(id)
          );

          if (validIds.length < 2) return;

          groups.push(validIds);
          validIds.forEach(id => groupedIds.add(id));
        });

        (allMons || []).forEach(pokemon => {
          if (!groupedIds.has(pokemon.id)) {
            groups.push([pokemon.id]);
          }
        });

        return groups;
      }

      function getPersonalityExtendedNatureSet(label) {
        const primarySet = new Set(label.natures || []);
        const extendedSet = new Set(primarySet);

        CORE_TEAM_LABELS.forEach(other => {
          if (other.key === label.key) return;

          const overlaps = (other.natures || []).some(
            nature => primarySet.has(nature)
          );

          if (overlaps) {
            (other.natures || []).forEach(
              nature => extendedSet.add(nature)
            );
          }
        });

        return extendedSet;
      }

      function isPersonalityGroupGenderEligible(group, label) {
        if (!label.requiredGender) return true;

        return (group || []).every(id => {
          const pokemon = getPokemonById(id);
          const gender = normalizePokemonGender(
            pokemon?.gender
          );

          return (
            gender === label.requiredGender ||
            gender === 'genderless'
          );
        });
      }

      function choosePersonalityGroups(
        groups,
        label,
        targetSize,
        {
          excludedIds = new Set(),
          useAdjacentNatures = true
        } = {}
      ) {
        const limit = Math.min(6, Math.max(0, targetSize | 0));
        if (!limit) return [];

        const primarySet = new Set(label.natures || []);
        const extendedSet = useAdjacentNatures
          ? getPersonalityExtendedNatureSet(label)
          : new Set(primarySet);

        const scoredGroups = shuffleArray(
          (groups || []).filter(group =>
            group.length > 0 &&
            group.length <= 6 &&
            !group.some(id => excludedIds.has(id)) &&
            isPersonalityGroupGenderEligible(group, label)
          )
        ).map(group => {
          let primaryMatches = 0;
          let adjacentMatches = 0;

          group.forEach(id => {
            const pokemon = getPokemonById(id);
            const nature = pokemon?.nature || '';

            if (primarySet.has(nature)) {
              primaryMatches += 1;
            } else if (extendedSet.has(nature)) {
              adjacentMatches += 1;
            }
          });

          return {
            group,
            size: group.length,
            score:
              (primaryMatches * 100) +
              (adjacentMatches * 10) +
              group.length
          };
        });

        if (!scoredGroups.length) return [];

        // Dynamic programming keeps linked groups intact while finding the
        // strongest Nature match that can fit within the target team size.
        const bestBySize = Array(limit + 1).fill(null);
        bestBySize[0] = {
          groups: [],
          score: 0
        };

        scoredGroups.forEach(item => {
          for (
            let currentSize = limit - item.size;
            currentSize >= 0;
            currentSize--
          ) {
            const current = bestBySize[currentSize];
            if (!current) continue;

            const nextSize = currentSize + item.size;
            const candidate = {
              groups: [...current.groups, item.group],
              score: current.score + item.score
            };
            const existing = bestBySize[nextSize];

            if (
              !existing ||
              candidate.score > existing.score ||
              (
                candidate.score === existing.score &&
                Math.random() < 0.5
              )
            ) {
              bestBySize[nextSize] = candidate;
            }
          }
        });

        let best = null;
        let bestSize = 0;

        for (let size = 1; size <= limit; size++) {
          const candidate = bestBySize[size];
          if (!candidate) continue;

          if (
            !best ||
            candidate.score > best.score ||
            (
              candidate.score === best.score &&
              size > bestSize
            ) ||
            (
              candidate.score === best.score &&
              size === bestSize &&
              Math.random() < 0.5
            )
          ) {
            best = candidate;
            bestSize = size;
          }
        }

        if (best) {
          return best.groups.flat();
        }

        // A complete linked group can be larger than the normal early-game
        // target, such as a Darkrai trio. Preserve the group rather than
        // splitting it or returning an empty team.
        const oversizedFallback = scoredGroups
          .slice()
          .sort((a, b) =>
            b.score - a.score ||
            a.size - b.size
          )[0];

        return oversizedFallback
          ? oversizedFallback.group.slice()
          : [];
      }

      function getPersonalityTeamSignature(team) {
        return Array.from(new Set(team || []))
          .sort()
          .join('|');
      }

      function addUniquePersonalityOptions(
        destination,
        candidates,
        seenSignatures,
        limit
      ) {
        for (const option of candidates) {
          if (destination.length >= limit) break;
          if (!Array.isArray(option.team) || !option.team.length) {
            continue;
          }

          const signature =
            getPersonalityTeamSignature(option.team);
          if (!signature || seenSignatures.has(signature)) {
            continue;
          }

          seenSignatures.add(signature);
          destination.push(option);
        }
      }

      function generateTeamChoiceTeams() {
        const allMons = pokemons.filter(p =>
          (p.location === 'team' || p.location === 'box') &&
          (p.name || '').trim()
        );

        const total = allMons.length;

        if (!total) {
          return {
            teams: [],
            teamLabels: [],
            chosenTeamIndex: null,
            pending: true
          };
        }

        const completeLinkedGroups =
          getCompleteSoulLinkGroupsForLocations(['team', 'box'])
            .filter(group =>
              group.length >= 2 &&
              group.length <= 6
            );

        if (total === 1) {
          return {
            teams: [[allMons[0].id]],
            teamLabels: [
              EARLY_PERSONALITY_TEAM_LABELS.oneMonShow
            ],
            chosenTeamIndex: 0,
            pending: false
          };
        }

        if (total === 2) {
          const livingIds = new Set(
            allMons.map(pokemon => pokemon.id)
          );
          const isCompleteLinkedPair =
            completeLinkedGroups.some(group =>
              group.length === 2 &&
              group.every(id => livingIds.has(id))
            );

          return {
            teams: [allMons.map(pokemon => pokemon.id)],
            teamLabels: [
              isCompleteLinkedPair
                ? EARLY_PERSONALITY_TEAM_LABELS.inseparables
                : EARLY_PERSONALITY_TEAM_LABELS.dynamicDuo
            ],
            chosenTeamIndex: 0,
            pending: false
          };
        }

        const pokemonGroups =
          buildPersonalityPokemonGroups(
            allMons,
            completeLinkedGroups
          );

        const coreTeamSize = total <= 6
          ? Math.max(2, total - 1)
          : 6;

        const coreOptions = CORE_TEAM_LABELS.map(label => ({
          team: choosePersonalityGroups(
            pokemonGroups,
            label,
            coreTeamSize
          ),
          label: {
            key: label.key,
            name: label.name,
            blurb: label.blurb
          },
          isSoulLinkTeam: false
        })).filter(option => option.team.length > 0);

        const soulOptions = [];

        if (completeLinkedGroups.length) {
          const shuffledLinks =
            shuffleArray(completeLinkedGroups);

          SOUL_TEAM_LABELS.forEach((label, index) => {
            const seedGroup =
              shuffledLinks[index % shuffledLinks.length];
            const targetSize = Math.min(6, total);
            const excludedIds = new Set(seedGroup);
            const remainingCapacity =
              Math.max(0, targetSize - seedGroup.length);

            const fillerIds = choosePersonalityGroups(
              pokemonGroups,
              label,
              remainingCapacity,
              {
                excludedIds,
                useAdjacentNatures: false
              }
            );

            soulOptions.push({
              team: [...seedGroup, ...fillerIds],
              label: {
                key: label.key,
                name: label.name,
                blurb: label.blurb
              },
              isSoulLinkTeam: true
            });
          });
        }

        const offeredOptions = [];
        const seenSignatures = new Set();

        if (soulOptions.length) {
          // A complete living Soul Link always contributes at least one
          // relationship-themed option.
          addUniquePersonalityOptions(
            offeredOptions,
            shuffleArray(soulOptions),
            seenSignatures,
            1
          );

          addUniquePersonalityOptions(
            offeredOptions,
            shuffleArray([
              ...soulOptions,
              ...coreOptions
            ]),
            seenSignatures,
            4
          );
        } else {
          addUniquePersonalityOptions(
            offeredOptions,
            shuffleArray(coreOptions),
            seenSignatures,
            4
          );
        }

        const shuffledOfferedOptions =
          shuffleArray(offeredOptions);

        return {
          teams: shuffledOfferedOptions.map(
            option => option.team
          ),
          teamLabels: shuffledOfferedOptions.map(
            option => option.label
          ),
          chosenTeamIndex: null,
          pending: false
        };
      }

      function getTeamChoiceLabels(effect, teamCount) {
        if (
          Array.isArray(effect.teamLabels) &&
          effect.teamLabels.length
        ) {
          return effect.teamLabels;
        }

        return TEAM_LABELS.slice(0, teamCount);
      }

      function getTeamChoiceMemberNames(team) {
        return (team || []).map(member => {
          const pokemon = getPokemonById(member);
          return pokemon
            ? getPokemonDisplayName(pokemon)
            : String(member || '(Missing Pokémon)');
        });
      }

      // --- Effects helpers (localStorage) ---
      function getEffects() {
        try {
          const raw = localStorage.getItem(EFFECTS_KEY);
          return raw ? JSON.parse(raw) : [];
        } catch(_) { return []; }
      }

      function setEffects(list) {
        try { localStorage.setItem(EFFECTS_KEY, JSON.stringify(list)); } catch(_) {}
      }

      function addEffects(effects) {
        if (!effects || !effects.length) return;
        const list = getEffects().concat(effects);
        setEffects(list);
        renderEffects();
      }

      function removeEffect(id, shouldRecord = true) {
        const list = getEffects();
        const eff = list.find(e => e.id === id);  // grab effect before removal
        const newList = list.filter(e => e.id !== id);
        setEffects(newList);
        renderEffects();

        if (eff && shouldRecord) {
          const detailPrefix = eff.kind === 'bonus' ? 'Blessing used' : 'Effect cleared';
          recordHistory({
            kind: 'effectUsed',
            roll: eff.roll,
            title: eff.title || 'Effect used',
            detail: `${detailPrefix}: ${eff.text || ''}`
          });
        }
      }

      function updateEffectById(effectId, updater) {
        const list = getEffects();
        const idx = list.findIndex(e => e.id === effectId);
        if (idx === -1) return null;
        const updated = updater({ ...list[idx] });
        if (!updated) return null;
        list[idx] = updated;
        setEffects(list);
        return updated;
      }

      function applyGeneratedTeamChoicesToEffect(
        effect,
        generated
      ) {
        const teams = Array.isArray(generated?.teams)
          ? generated.teams
          : [];
        const teamLabels =
          Array.isArray(generated?.teamLabels)
            ? generated.teamLabels
            : [];
        const chosenTeamIndex =
          Number.isInteger(generated?.chosenTeamIndex)
            ? generated.chosenTeamIndex
            : null;

        effect.teams = teams;
        effect.teamLabels = teamLabels;
        effect.chosenTeamIndex = chosenTeamIndex;
        effect.teamChoicePending =
          generated?.pending === true;

        if (effect.teamChoicePending) {
          effect.text =
            'No living Pokémon are available yet. Add a Pokémon to your active team or box, then generate your Personality Lock team.';
        } else if (
          chosenTeamIndex !== null &&
          teamLabels[chosenTeamIndex]
        ) {
          effect.text =
            `Locked team for the next Gym: ${teamLabels[chosenTeamIndex].name}.`;
        } else {
          effect.text = PERSONALITY_LOCK_DEFAULT_TEXT;
        }

        return effect;
      }

      function regenerateTeamChoicesForEffect(effectId) {
        const generated = generateTeamChoiceTeams();

        const updated = updateEffectById(
          effectId,
          effect => applyGeneratedTeamChoicesToEffect(
            effect,
            generated
          )
        );

        if (!updated) return;

        if (updated.teamChoicePending) {
          showRollerNotice(
            'Add at least one living Pokémon to your active team or box, then try generating the team again.',
            'No Pokémon available'
          );
        } else if (
          Number.isInteger(updated.chosenTeamIndex)
        ) {
          const labels = getTeamChoiceLabels(
            updated,
            updated.teams?.length || 0
          );
          const labelObj =
            labels[updated.chosenTeamIndex] ||
            TEAM_LABELS[0];

          recordHistory({
            kind: 'malusApplied',
            roll: updated.roll,
            title: `Team chosen: ${labelObj.name}`,
            detail:
              `${labelObj.name} was automatically selected because only one legal early-game team could be formed.`
          });
        }

        renderEffects();
      }

      function chooseTeamForEffect(effectId, teamIndex) {
        const currentEffect = getEffects().find(
          effect => effect.id === effectId
        );
        const requestedTeam =
          currentEffect?.teams?.[teamIndex];

        if (
          !Array.isArray(requestedTeam) ||
          !requestedTeam.length
        ) {
          showRollerNotice(
            'This Personality Lock option does not contain any available Pokémon.',
            'Team unavailable'
          );
          return;
        }

        const updated = updateEffectById(effectId, eff => {
          if (!Array.isArray(eff.teams) || !eff.teams.length) return eff;

          const idx = Math.max(
            0,
            Math.min(teamIndex, eff.teams.length - 1)
          );
          const labels = getTeamChoiceLabels(
            eff,
            eff.teams.length
          );
          const labelObj =
            labels[idx] ||
            TEAM_LABELS[idx] ||
            TEAM_LABELS[0];

          eff.chosenTeamIndex = idx;
          eff.text = `Locked team for the next Gym: ${labelObj.name}.`;
          return eff;
        });
        if (!updated) return;

        const idx = (
          updated.chosenTeamIndex != null
            ? updated.chosenTeamIndex
            : teamIndex
        ) || 0;
        const labels = getTeamChoiceLabels(
          updated,
          updated.teams?.length || 0
        );
        const labelObj =
          labels[idx] ||
          TEAM_LABELS[idx] ||
          TEAM_LABELS[0];

        recordHistory({
          kind: 'malusApplied',
          roll: updated.roll,
          title: `Team chosen: ${labelObj.name}`,
          detail: `You locked in ${labelObj.name} for the next Gym.`
        });
        renderEffects();
      }

      function chooseBonusForEffect(effectId, choice) {
        const updated = updateEffectById(effectId, eff => {
          if (choice === 'center') {
            eff.title = 'Center Refresh';
            eff.text  = 'Refresh a Pokémon Center.';
          } else if (choice === 'item') {
            eff.title = 'Consumable Item';
            eff.text  = 'You may use one consumable item.';
          } else if (choice === 'shield') {
            eff.title = 'Shield Restored';
            eff.text  = 'Restore 2 shield charges.';
            // Increase shields by 2, capped at MAX_SHIELDS.
            const newAmount = Math.min(MAX_SHIELDS, shieldCount + 2);
            setStoredShields(newAmount);
          } else if (choice === 'rolls') {
            eff.title = 'Dice Roll Refill';
            eff.text  = 'Gain +5 Dice Rolls.';
            setStoredRolls(diceRolls + 5);
          }
          eff.applyKind = null;
          return eff;
        });
        if (!updated) return;

        if (choice === 'item') {
          addEffects([
            {
              id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
              kind: 'bonus',
              roll: updated.roll,
              title: 'Consumable Item',
              text: 'You may use one consumable item.',
              timeLabel: updated.timeLabel || '',
              applyKind: null
            }
          ]);
        }

        let chosenLabel = '';
        if (choice === 'center') chosenLabel = 'Center Refresh';
        if (choice === 'item')   chosenLabel = '2 Consumable Blessings';
        if (choice === 'shield') chosenLabel = 'Restore 2 Shields';
        if (choice === 'rolls')  chosenLabel = 'Gain 5 Dice Rolls';

        recordHistory({
          kind: 'effectUsed',
          roll: updated.roll,
          title: 'Blessing chosen',
          detail: `You chose: ${chosenLabel}.`
        });
        renderEffects();
      }

      function mapRollToEffects(value) {
        if (value === 1) {
          return {
            extraRolls: 2,
            blessing: [
              {
                title: 'Blessing Rolls',
                text: 'Gain +2 Dicelocke rolls. This updates automatically, you can close me :).'
              }
            ],
            curse: [
              {
                title: 'Release a Pokémon',
                text: 'Release a Pokémon of your choice.'
              }
            ]
          };
        }

        if (value >= 2 && value <= 7) {
          return {
            extraRolls: 0,
            blessing: [
              {
                title: 'Center Refresh',
                text: 'Refresh a Pokémon Center.'
              }
            ],
            curse: [
              {
                title: 'Lock & Box',
                text: 'Box a random Pokémon until the next gym is complete. That Pokémon and team slot is unusable until cleared.',
                applyKind: 'boxRandom'
              }
            ]
          };
        }

        if (value >= 8 && value <= 13) {
          return {
            extraRolls: 0,
            blessing: [
              {
                title: 'Consumable Item',
                text: 'You may use one consumable item.'
              }
            ],
            curse: [
              {
                title: 'Team Shuffle',
                text: 'Randomize your team until the next Gym is complete. If you have multiple of this curse, only use one and apply the rest to subsequent Gyms.',
                applyKind: 'teamShuffle'
              }
            ]
          };
        }

        if (value === 14) {
          return {
            extraRolls: 0,
            blessing: [
              {
                title: 'Choose Your Blessing',
                text: 'Pick one: refresh a Pokémon Center, gain 2 consumable blessings, restore 2 shield charges, or gain 5 Dice Rolls.',
                applyKind: 'chooseBonus'
              }
            ],
            curse: [
              {
                title: 'Personality Lock',
                text: PERSONALITY_LOCK_DEFAULT_TEXT,
                applyKind: 'teamChoice'
              }
            ]
          };
        }

        if (value >= 15 && value <= 17) {
          return {
            extraRolls: 0,
            blessing: [
              {
                title: 'Route Scout',
                text: 'On one route of your choice, you may skip the first encounter and must catch the second instead (still only one encounter total).'
              }
            ],
            curse: [
              {
                title: 'Slim Gym',
                text: 'For the next Gym (or Elite 4 battle), you may bring only as many Pokémon as the Gym Leader/Champion uses.'
              }
            ]
          };
        }

        if (value >= 18 && value <= 19) {
          return {
            extraRolls: 0,
            blessing: [
              {
                title: 'Extra Catch',
                text: 'Catch an extra Pokémon on any previous route.'
              }
            ],
            curse: [
              {
                title: 'Soul Link',
                text: 'Two of your Pokémon are now Soul Linked and inseparable. When one dies the other dies as well.',
                applyKind: 'soulLink'
              }
            ]
          };
        }

        if (value === 20) {
          return {
            extraRolls: 0,
            blessing: [
              {
                title: 'The Comeback Kid',
                text: 'Bring back a Pokémon of your choice - from the grave or a previous Dicelocke. They match the level and evolution stage of your team. NOTE: Cheat in your previous-Dicelocke mon exactly as it was.'
              }
            ],
            curse: []
          };
        }

        return { extraRolls: 0, blessing: [], curse: [] };
      }

      // Build a pool of all possible Blessings and Curses.
      // Giratina uses these pools to invert active effects.
      let __cachedBlessingPool = null;
      let __cachedCursePool = null;

      function getRollEffectPools() {
        if (__cachedBlessingPool && __cachedCursePool) {
          return { blessingPool: __cachedBlessingPool, cursePool: __cachedCursePool };
        }

        const blessingPool = [];
        const cursePool = [];
        const seenB = new Set();
        const seenC = new Set();

        for (let v = 1; v <= 20; v++) {
          const m = mapRollToEffects(v);
          if (!m) continue;

          (m.blessing || []).forEach(b => {
            const key = `${b.title}||${b.text}||${b.applyKind || ''}`;
            if (seenB.has(key)) return;
            seenB.add(key);
            blessingPool.push({ title: b.title, text: b.text, applyKind: b.applyKind || null });
          });

          (m.curse || []).forEach(c => {
            const key = `${c.title}||${c.text}||${c.applyKind || ''}`;
            if (seenC.has(key)) return;
            seenC.add(key);
            cursePool.push({ title: c.title, text: c.text, applyKind: c.applyKind || null });
          });
        }

        __cachedBlessingPool = blessingPool;
        __cachedCursePool = cursePool;
        return { blessingPool, cursePool };
      }

      function pickRandomFromPool(pool) {
        if (!pool || pool.length === 0) return null;
        return pool[Math.floor(Math.random() * pool.length)];
      }


      // --- History helpers ---
      function getHistory() {
        try {
          const raw = localStorage.getItem(HISTORY_KEY);
          const arr = raw ? JSON.parse(raw) : [];
          return Array.isArray(arr) ? arr : [];
        } catch(_) {
          return [];
        }
      }

      function setHistory(list) {
        try { localStorage.setItem(HISTORY_KEY, JSON.stringify(list || [])); } catch(_) {}
      }

      function recordHistory(entry) {
        const now = new Date();
        const item = {
          ts: now.toISOString(),
          tsLabel: now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
          kind: entry.kind || 'event',
          roll: entry.roll || null,
          title: entry.title || '',
          detail: entry.detail || ''
        };
        const list = getHistory();
        list.push(item);
        setHistory(list);
        renderHistory();
      }

      function renderHistory() {
        if (!HISTORY_LIST) return;
        const list = getHistory();
        HISTORY_LIST.innerHTML = '';
        if (!list.length) {
          const empty = document.createElement('div');
          empty.className = 'dl-effects-empty';
          empty.textContent = 'No history yet.';
          HISTORY_LIST.appendChild(empty);
          return;
        }

        list.slice().reverse().forEach(entry => {
          const row = document.createElement('div');
          row.className = 'dl-history-entry';

          const header = document.createElement('div');
          header.className = 'dl-history-header';

          const title = document.createElement('span');
          title.className = 'dl-history-title';
          title.textContent = entry.title || 'Event';

          const meta = document.createElement('span');
          meta.className = 'dl-history-meta';

          const parts = [];
          if (entry.roll) parts.push('Roll ' + entry.roll);
          if (entry.kind === 'roll') parts.push('Rolled');
          if (entry.kind === 'malusApplied') parts.push('Curse applied');
          if (entry.tsLabel) parts.push(entry.tsLabel);

          meta.textContent = parts.join(' • ');

          header.appendChild(title);
          header.appendChild(meta);

          const detail = document.createElement('div');
          detail.className = 'dl-history-detail';
          detail.textContent = entry.detail || '';

          row.appendChild(header);
          row.appendChild(detail);
          HISTORY_LIST.appendChild(row);
        });
      }

      function renderTeamChoiceContent(effect, container) {
        const wrapper = document.createElement('div');
        wrapper.className = 'dl-team-choice-wrapper';

        const teams = Array.isArray(effect.teams)
          ? effect.teams.filter(
              team => Array.isArray(team) && team.length
            )
          : [];

        const teamLabels = getTeamChoiceLabels(
          effect,
          teams.length
        );

        const chosenIndex = (
          typeof effect.chosenTeamIndex === 'number' &&
          effect.chosenTeamIndex >= 0 &&
          effect.chosenTeamIndex < teams.length
        )
          ? effect.chosenTeamIndex
          : null;

        if (!teams.length) {
          const pendingHelp = document.createElement('div');
          pendingHelp.className = 'dl-team-choice-help';
          pendingHelp.textContent =
            'No living Pokémon were available when this curse was created. Add a Pokémon, then generate the available team.';

          const generateBtn = document.createElement('button');
          generateBtn.type = 'button';
          generateBtn.className = 'dl-team-choice-btn';
          generateBtn.textContent = 'Generate team';
          generateBtn.addEventListener('click', () => {
            regenerateTeamChoicesForEffect(effect.id);
          });

          wrapper.appendChild(pendingHelp);
          wrapper.appendChild(generateBtn);
          container.appendChild(wrapper);
          return;
        }

        // If a team has already been chosen, show a short summary.
        if (chosenIndex !== null) {
          const chosenTeam = getTeamChoiceMemberNames(
            teams[chosenIndex] || []
          );
          const labelObj =
            teamLabels[chosenIndex] ||
            TEAM_LABELS[chosenIndex] ||
            TEAM_LABELS[0];

          const summary = document.createElement('div');
          summary.className = 'dl-team-choice-help';
          summary.textContent = `Locked team for the next Gym: ${labelObj.name}`;
          wrapper.appendChild(summary);

          const card = document.createElement('div');
          card.className = 'dl-team-choice-card';

          const nameEl = document.createElement('div');
          nameEl.className = 'dl-team-choice-name';
          nameEl.textContent = labelObj.name;

          const membersEl = document.createElement('div');
          membersEl.className = 'dl-team-choice-members';
          membersEl.textContent = chosenTeam.length
            ? chosenTeam.join(', ')
            : 'No Pokémon available';

          const blurbEl = document.createElement('div');
          blurbEl.className = 'dl-team-choice-blurb';
          blurbEl.textContent = labelObj.blurb;

          card.appendChild(nameEl);
          card.appendChild(membersEl);
          card.appendChild(blurbEl);

          wrapper.appendChild(card);
          container.appendChild(wrapper);
          return;
        }

        const help = document.createElement('div');
        help.className = 'dl-team-choice-help';
        help.textContent = 'Click one team to lock in for the next Gym.';
        wrapper.appendChild(help);

        const grid = document.createElement('div');
        grid.className = 'dl-team-choice-grid';

        teams.forEach((team, idx) => {
          const card = document.createElement('div');
          card.className = 'dl-team-choice-card';

          const labelObj =
            teamLabels[idx] ||
            TEAM_LABELS[idx] ||
            TEAM_LABELS[0];
          const memberNames = getTeamChoiceMemberNames(team);

          const nameEl = document.createElement('div');
          nameEl.className = 'dl-team-choice-name';
          nameEl.textContent = labelObj.name;

          const membersEl = document.createElement('div');
          membersEl.className = 'dl-team-choice-members';
          membersEl.textContent = memberNames.length
            ? memberNames.join(', ')
            : 'No Pokémon available';

          const blurbEl = document.createElement('div');
          blurbEl.className = 'dl-team-choice-blurb';
          blurbEl.textContent = labelObj.blurb;

          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'dl-team-choice-btn';
          btn.textContent = 'Use this team';
          btn.addEventListener('click', () => {
            chooseTeamForEffect(effect.id, idx);
          });

          card.appendChild(nameEl);
          card.appendChild(membersEl);
          card.appendChild(blurbEl);
          card.appendChild(btn);

          grid.appendChild(card);
        });

        wrapper.appendChild(grid);
        container.appendChild(wrapper);
      }

      function renderBonusChoiceContent(effect, container) {
        const wrapper = document.createElement('div');
        wrapper.className = 'dl-bonus-choice-wrapper';

        const row = document.createElement('div');
        row.className = 'dl-bonus-choice-row';

        const centerBtn = document.createElement('button');
        centerBtn.type = 'button';
        centerBtn.className = 'dl-bonus-choice-btn';
        centerBtn.textContent = 'Refresh a Center';
        centerBtn.addEventListener('click', () => {
          chooseBonusForEffect(effect.id, 'center');
        });

        const itemBtn = document.createElement('button');
        itemBtn.type = 'button';
        itemBtn.className = 'dl-bonus-choice-btn';
        itemBtn.textContent = 'Gain 2 Consumables';
        itemBtn.addEventListener('click', () => {
          chooseBonusForEffect(effect.id, 'item');
        });

        const shieldBtn = document.createElement('button');
        shieldBtn.type = 'button';
        shieldBtn.className = 'dl-bonus-choice-btn';
        shieldBtn.textContent = 'Restore 2 Shields';
        shieldBtn.addEventListener('click', () => {
          chooseBonusForEffect(effect.id, 'shield');
        });

        const rollsBtn = document.createElement('button');
        rollsBtn.type = 'button';
        rollsBtn.className = 'dl-bonus-choice-btn';
        rollsBtn.textContent = 'Gain 5 Dice Rolls';
        rollsBtn.addEventListener('click', () => {
          chooseBonusForEffect(effect.id, 'rolls');
        });

        // Append the blessing choice buttons
        row.appendChild(centerBtn);
        row.appendChild(itemBtn);
        row.appendChild(shieldBtn);
        row.appendChild(rollsBtn);

        wrapper.appendChild(row);
        container.appendChild(wrapper);
      }

      function renderEffects() {
        if (!EFFECTS_BONUS || !EFFECTS_MALUS) return;
        const list = getEffects();

        const blessing = list.filter(e => e.kind === 'bonus');
        const curse = list.filter(e => e.kind === 'malus');

        EFFECTS_BONUS.innerHTML = '';
        EFFECTS_MALUS.innerHTML = '';

        function renderCategory(container, items, emptyText, kindClass, isMalus) {
          if (!items.length) {
            const p = document.createElement('div');
            p.className = 'dl-effects-empty';
            p.textContent = emptyText;
            container.appendChild(p);
            return;
          }

          items.slice().reverse().forEach(effect => {
            const item = document.createElement('div');
            item.className = 'dl-effect-item ' + kindClass;
            item.setAttribute('role', 'listitem');

            const main = document.createElement('div');
            main.className = 'dl-effect-main';

            const title = document.createElement('div');
            title.className = 'dl-effect-title';
            title.textContent = effect.roll
              ? `${effect.title} (Roll ${effect.roll})`
              : effect.title;

            const text = document.createElement('div');
            text.className = 'dl-effect-text';
            text.textContent = effect.text;

            const meta = document.createElement('div');
            meta.className = 'dl-effect-meta';
            meta.textContent = effect.timeLabel || '';

            main.appendChild(title);
            main.appendChild(text);
            if (effect.timeLabel) main.appendChild(meta);

            const isTeamChoice  = isMalus && effect.applyKind === 'teamChoice';
            const isChooseBonus = !isMalus && effect.applyKind === 'chooseBonus';

            if (isTeamChoice) {
              renderTeamChoiceContent(effect, main);
            } else if (isChooseBonus) {
              renderBonusChoiceContent(effect, main);
            }

            const actions = document.createElement('div');
            actions.className = 'dl-effect-actions';

            if (isMalus && effect.applyKind && effect.applyKind !== 'teamChoice') {
              const applyBtn = document.createElement('button');
              applyBtn.type = 'button';
              applyBtn.className = 'dl-effect-apply';
              applyBtn.textContent = 'Apply';
              applyBtn.addEventListener('click', () => handleApplyEffect(effect.id));
              actions.appendChild(applyBtn);
            }

            if (!effect.applyKind || isTeamChoice) {
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'dl-effect-remove';
              btn.textContent = '✕';
              btn.setAttribute('aria-label', 'Remove effect');
              btn.title = 'Mark used / remove';
              btn.addEventListener('click', () => removeEffect(effect.id));
              actions.appendChild(btn);
            }

            item.appendChild(main);
            item.appendChild(actions);

            container.appendChild(item);
          });
        }

        renderCategory(
          EFFECTS_BONUS,
          blessing,
          'No active blessings.',
          'dl-effect-item--bonus',
          false
        );
        renderCategory(
          EFFECTS_MALUS,
          curse,
          'No active curses.',
          'dl-effect-item--malus',
          true
        );
      }

      // --- Curse apply handlers for auto-apply types ---
      function handleApplyEffect(effectId) {
        if (topMode === 'whiteout') return;
        const list = getEffects();
        const idx = list.findIndex(e => e.id === effectId);
        if (idx === -1) return;

        const eff = list[idx];
        if (!eff || !eff.applyKind) return;

        let ok = false;

        if (eff.applyKind === 'boxRandom') {
          ok = applyBoxRandom(eff);
        } else if (eff.applyKind === 'teamShuffle') {
          ok = applyTeamShuffle(eff);
        } else if (eff.applyKind === 'soulLink') {
          ok = applySoulLink(eff);
        } else if (eff.applyKind === 'centerRefresh') {
          ok = applyCenterRefresh(eff);
        }

        if (!ok) return;

        recordHistory({
          kind: 'malusApplied',
          roll: eff.roll,
          title: eff.title,
          detail: eff.text
        });

        const newList = list.filter(e => e.id !== eff.id);
        setEffects(newList);
        renderEffects();

        // Open the relevant party view after applying the effect
        if (eff.applyKind === 'soulLink') {
          // Show the location that contains relevant living Pokémon.
          setTopMode('party');
          partyViewMode = pokemons.some(p => p.location === 'box')
            ? 'box'
            : 'team';
          applyPartyViewMode();
        } else {
          // Open the team view for other curses
          setTopMode('party');
        }
      }

      function applyBoxRandom(effect) {
        const teamMons = pokemons.filter(
          p => p.location === 'team' && Number.isInteger(p.slotIndex)
        );
        const candidates = teamMons.filter(p => !lockedSlots[p.slotIndex]);

        if (!candidates.length) {
          showRollerNotice(
            'There are no eligible Pokémon in your active team for Lock & Box.',
            'Lock & Box cannot be applied'
          );
          return false;
        }

        // Pick a random Pokémon from the unlocked team slots
        const chosen = candidates[Math.floor(Math.random() * candidates.length)];
        const fromSlot = chosen.slotIndex; // 0–5

        // Find the right-most slot that is currently *not* locked
        let lockIndex = -1;
        for (let i = 5; i >= 0; i--) {
          if (!lockedSlots[i]) {
            lockIndex = i;
            break;
          }
        }

        if (lockIndex === -1) {
          showRollerNotice(
            'Every team slot is already locked, so another slot cannot be locked.',
            'All team slots are locked'
          );
          return false;
        }

        // Move chosen mon to the box
        chosen.location = 'box';
        chosen.slotIndex = null;

        // If the chosen mon wasn’t already in the slot we’re locking,
        // move the Pokémon from that right-most slot into the vacated slot.
        if (typeof fromSlot === 'number' && fromSlot !== lockIndex) {
          const monAtLock = pokemons.find(
            p => p.location === 'team' && p.slotIndex === lockIndex
          );
          if (monAtLock) {
            monAtLock.slotIndex = fromSlot;
          }
        }

        // Lock the right-most available slot
        const boxedName = chosen.name || '(Unnamed Pokémon)';
        const newLocked = lockedSlots.slice();
        newLocked[lockIndex] = true;
        setLockedSlots(newLocked);
        lockedSlotNames[lockIndex] = boxedName;
        saveLockedSlotNames();

        const fromLabel = typeof fromSlot === 'number' ? fromSlot + 1 : '?';
        const lockLabel = lockIndex + 1;

        const linkedPartnerNames =
          getSoulLinkPartnerNamesForPokemon(chosen.id);

        effect.text =
          `${effect.text} Boxed: ${boxedName} from slot ${fromLabel}. ` +
          `Slot ${lockLabel} stays locked (locks always fill from the right).`;

        if (linkedPartnerNames.length) {
          effect.text +=
            ` Soul Link reminder: ${boxedName} is linked to ` +
            `${linkedPartnerNames.join(' and ')}; manually box any ` +
            'linked partners that are still on the active team.';
        }

        savePokemons();

        if (linkedPartnerNames.length) {
          showSoulLinkMoveReminder(
            chosen,
            'Manually box any linked partners that are still on the active team so the Soul Link stays together.'
          );
        }

        return true;
      }

      function applyTeamShuffle(effect) {
        const allMons = pokemons.filter(
          p =>
            (
              p.location === 'team' &&
              Number.isInteger(p.slotIndex) &&
              !lockedSlots[p.slotIndex]
            ) ||
            p.location === 'box'
        );

        if (!allMons.length) {
          showRollerNotice(
            'Add at least one active or boxed Pokémon before applying Team Shuffle.',
            'No Pokémon to shuffle'
          );
          return false;
        }

        const unlockedIdx = [];
        for (let i = 0; i < 6; i++) {
          if (!lockedSlots[i]) unlockedIdx.push(i);
        }

        if (!unlockedIdx.length) {
          showRollerNotice(
            'All team slots are locked, so Team Shuffle cannot place a new active team.',
            'Team Shuffle unavailable'
          );
          return false;
        }

        const indivisibleGroups =
          buildIndivisiblePokemonGroups(allMons);
        const selectedGroups =
          chooseRandomGroupsUpToLimit(
            indivisibleGroups,
            unlockedIdx.length
          );

        if (!selectedGroups.length) {
          showRollerNotice(
            'No complete Soul Link group can fit into the currently unlocked team slots. Unlock more slots before applying Team Shuffle.',
            'Team Shuffle unavailable'
          );
          return false;
        }

        // Shuffle groups and the members inside each group for variety, but
        // keep every complete linked pair/triple on the same side.
        const shuffledTeamIds = shuffleArray(
          selectedGroups
        ).flatMap(group => shuffleArray(group));

        allMons.forEach(pokemon => {
          pokemon.location = 'box';
          pokemon.slotIndex = null;
        });

        unlockedIdx.forEach((slotIndex, index) => {
          const pokemonId = shuffledTeamIds[index];
          if (!pokemonId) return;

          const pokemon = getPokemonById(pokemonId);
          if (!pokemon) return;

          pokemon.location = 'team';
          pokemon.slotIndex = slotIndex;
        });

        const unusedSlotCount = Math.max(
          0,
          unlockedIdx.length - shuffledTeamIds.length
        );

        effect.text =
          `${effect.text} Your team was shuffled using complete ` +
          'Soul Link groups, so no pair or trio was split.';

        if (unusedSlotCount > 0) {
          effect.text +=
            ` ${unusedSlotCount} unlocked team ` +
            `${unusedSlotCount === 1 ? 'slot remains' : 'slots remain'} ` +
            'empty because no additional complete group could fit.';
        }

        savePokemons();
        return true;
      }

      function applyCenterRefresh(effect) {
        // Return true so Apply removes the effect card.
        return true;
      }

      function applySoulLink(effect) {
        const usedIds = getLinkedMemberIdSet();

        const teamCandidates = pokemons.filter(p =>
          p.location === 'team' &&
          Number.isInteger(p.slotIndex) &&
          !usedIds.has(p.id)
        );

        const boxCandidates = pokemons.filter(p =>
          p.location === 'box' &&
          !usedIds.has(p.id)
        );

        const livingCandidates = [
          ...teamCandidates,
          ...boxCandidates
        ];

        if (livingCandidates.length < 2) {
          showRollerNotice(
            'Soul Link needs at least two unlinked living Pokémon in your active team or box.',
            'Soul Link unavailable'
          );
          return false;
        }

        let firstPokemon;
        let secondPokemon;

        if (teamCandidates.length && boxCandidates.length) {
          // Preserve the original team-to-box pairing when both pools exist.
          firstPokemon =
            teamCandidates[
              Math.floor(Math.random() * teamCandidates.length)
            ];
          secondPokemon =
            boxCandidates[
              Math.floor(Math.random() * boxCandidates.length)
            ];
        } else {
          // When every eligible Pokémon is in the same location, such as a
          // team-only roster, randomly link two distinct Pokémon there.
          const shuffledCandidates = shuffleArray(livingCandidates);
          [firstPokemon, secondPokemon] =
            shuffledCandidates.slice(0, 2);
        }

        const newLinks = (soulLinks || []).slice();
        newLinks.push({
          type: 'pair',
          memberIds: [firstPokemon.id, secondPokemon.id]
        });
        setSoulLinks(newLinks);

        effect.text =
          `${effect.text} Linked: ` +
          `${getPokemonDisplayName(firstPokemon)} ⇔ ` +
          `${getPokemonDisplayName(secondPokemon)}.`;
        return true;
      }

      // --- Reset ---
      function resetAll() {
        setStoredRolls(0);
        setStoredShields(MAX_SHIELDS);
        setEffects([]);
        setHistory([]);
        renderEffects();
        renderHistory();
        setTopMode('hero');
        renderHeroFace(20);

        // Clear party data
        pokemons = [];
        try { localStorage.removeItem(POKEMON_KEY); } catch(_) {}
        renderPartyUI();

        try {
          localStorage.removeItem(TEAM_KEY);
          localStorage.removeItem(BOXED_KEY);
          localStorage.removeItem(LOCK_KEY);
          localStorage.removeItem(PERMA_LOCK_KEY);
          localStorage.removeItem(PERMA_LOCK_NAMES_KEY);
          localStorage.removeItem(SOUL_KEY);
          localStorage.removeItem(HISTORY_KEY);
          localStorage.removeItem(WHITEOUT_KEY);
          localStorage.removeItem(WHITEOUT_SNAPSHOT_KEY);
          localStorage.removeItem(SACRED_REBIRTH_KEY);
          localStorage.removeItem(POKEMON_CENTER_LOG_KEY);
          localStorage.removeItem(RESOURCE_VIEW_STATE_KEY);
          localStorage.removeItem(LAST_ROLL_SHOP_KEY);
          localStorage.removeItem(BIRDGOD_CHAMPION_KEY);
        } catch(_) {}

        setSacredRebirthActive(false);
        setLockedSlots([false, false, false, false, false, false]);
        lockedSlotNames = [null, null, null, null, null, null];
        saveLockedSlotNames();
        permaLockedSlots = [false, false, false, false, false, false];
        permaLockedSlotNames = [null, null, null, null, null, null];
        savePermaLocked();
        setLockedSlots([false, false, false, false, false, false]);
        soulLinks   = [];
        renderSoulLinksSummary();
        updateUnlockButtonState();

        lastRollShopChatChoices = [];
        lastRollShopChatSelectedIds = [];

        // Reset resource navigation
        selectedResourceGame = null;
        currentResourceStage = 'home';
        showResourceStage(
          'home',
          {
            persist: false
          }
        );

        // Reset whiteout UI
        renderWhiteoutStatus();
        updateRightColumnForGraveView();
      }

      // --- Die visuals (SVG or photo) ---
      function makeDieSVG(value) {
        const ns = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('viewBox', '0 0 100 100');
        svg.setAttribute('role', 'img');
        svg.setAttribute('aria-label', `d20 shows ${value}`);
        svg.classList.add('dl-svg');

        const g = document.createElementNS(ns, 'g');

        const bg = document.createElementNS(ns, 'path');
        bg.setAttribute('fill', '#ffffff');
        bg.setAttribute('stroke', 'var(--dl-accent)');
        bg.setAttribute('stroke-width', '2');
        bg.setAttribute('d', 'M50,2 L92,20 L98,62 L70,98 L30,98 L2,62 L8,20 Z');
        g.appendChild(bg);

        const num = document.createElementNS(ns, 'text');
        num.setAttribute('x','50');
        num.setAttribute('y','57');
        num.setAttribute('text-anchor','middle');
        num.setAttribute('font-size','32');
        num.setAttribute('font-family','ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial');
        num.setAttribute('font-weight','700');
        num.setAttribute('fill','var(--dl-number)');
        num.textContent = value;

        const shadow = document.createElementNS(ns, 'text');
        shadow.setAttribute('x','51');
        shadow.setAttribute('y','58');
        shadow.setAttribute('text-anchor','middle');
        shadow.setAttribute('font-size','32');
        shadow.setAttribute('font-family','ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial');
        shadow.setAttribute('font-weight','700');
        shadow.setAttribute('fill','rgba(0,0,0,.08)');
        shadow.textContent = value;

        g.appendChild(shadow);
        g.appendChild(num);
        svg.appendChild(g);
        return svg;
      }

      function makeDiePhoto(value) {
        const theme = root.dataset.theme || 'urge';
        const url = IMG_MAP?.[theme]?.['20'];

        if (!url) return makeDieSVG(value);

        const wrap = document.createElement('div');
        wrap.className = 'dl-img';
        wrap.setAttribute('role', 'img');
        wrap.setAttribute('aria-label', `Photo d20 (${theme}) shows ${value}`);

        if (value === 20) {
          wrap.classList.add('dl-nat20');
        }

        const img = document.createElement('img');
        img.src = url;
        img.alt = '';
        img.className = 'dl-img-base';

        const num = document.createElement('div');
        num.className = 'dl-img-num';
        num.textContent = value;

        wrap.appendChild(img);
        wrap.appendChild(num);

        return wrap;
      }

      function renderHeroFace(value) {
        if (!HERO_FACE) return;
        HERO_FACE.innerHTML = '';
        const themeVars = getThemeVars();
        const usePhoto = usePhotoDice();
        const node = usePhoto ? makeDiePhoto(value) : makeDieSVG(value);

        if (value === 20) {
          node.classList.add('dl-nat20');
        } else if (value === 1) {
          node.classList.add('dl-nat1');
        }

        if (themeVars.number) {
          node.style.setProperty(
            '--dl-number',
            themeVars.number
          );
        }

        HERO_FACE.appendChild(node);
      }

      // --- Swatches ---
      function initSwatches() {
        if (!SWATCH_ROW) return;
        const swatches = Array.from(SWATCH_ROW.querySelectorAll('.dl-swatch'));
        if (!swatches.length) return;

        const saved = localStorage.getItem(THEME_KEY) || 'urge';
        applyTheme(saved);

        function setSelected(el) {
          swatches.forEach(btn => {
            const sel = (btn === el);
            btn.classList.toggle('is-selected', sel);
            btn.setAttribute('aria-checked', sel ? 'true' : 'false');
            btn.tabIndex = sel ? 0 : -1;
          });
        }

        const current = swatches.find(b => b.dataset.theme === saved) || swatches[0];
        if (current) setSelected(current);
        renderHeroFace(20);

        function hydrateSwatch(theme, asset) {
          const url = asset;
          const btn = SWATCH_ROW.querySelector('.dl-swatch[data-theme="' + theme + '"]');
          if (!btn || !url) return;
          const img = new Image();
          img.onload = () => {
            btn.classList.add('dl-swatch--photo');
            btn.style.backgroundImage = 'url(' + url + ')';
          };
          img.onerror = () => {
            const inner = document.createElement('span');
            inner.className = 'dl-swatch-photo-inner';
            inner.style.backgroundImage = 'url(' + url + ')';
            btn.classList.add('dl-swatch--photo');
            btn.appendChild(inner);
          };
          img.src = url;
        }

        hydrateSwatch('galaxy', IMG_MAP?.galaxy?.swatch || '');
        hydrateSwatch('urge', IMG_MAP?.urge?.swatch || '');
        hydrateSwatch('cozy', IMG_MAP?.cozy?.swatch || '');
        hydrateSwatch('emerald', IMG_MAP?.emerald?.swatch || '');

        swatches.forEach((btn, idx) => {
          btn.addEventListener('click', () => {
            applyTheme(btn.dataset.theme);
            setSelected(btn);
            renderHeroFace(20);
          });
          btn.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
              e.preventDefault();
              const next = swatches[(idx + 1) % swatches.length];
              next.focus(); next.click();
            } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
              e.preventDefault();
              const prev = swatches[(idx - 1 + swatches.length) % swatches.length];
              prev.focus(); prev.click();
            } else if (e.key === ' ' || e.key === 'Enter') {
              e.preventDefault();
              btn.click();
            }
          });
        });
      }

      // --- Rules-only Resources panel ---
      const VALID_RESOURCE_STAGES = new Set([
        'home',
        'tools',
        'caps',
        'centers'
      ]);

      function loadResourceViewState() {
        const saved = loadJSON(
          RESOURCE_VIEW_STATE_KEY,
          {
            gameKey: null,
            stage: 'home'
          }
        );

        const gameKey =
          saved?.gameKey &&
          RESOURCE_GAME_META[saved.gameKey]
            ? saved.gameKey
            : null;

        let stage = VALID_RESOURCE_STAGES.has(saved?.stage)
          ? saved.stage
          : 'home';

        if (!gameKey && stage !== 'home') {
          stage = 'home';
        }

        return {
          gameKey,
          stage
        };
      }

      const initialResourceViewState =
        loadResourceViewState();

      let selectedResourceGame =
        initialResourceViewState.gameKey;
      let currentResourceStage =
        initialResourceViewState.stage;

      function saveResourceViewState() {
        saveJSON(
          RESOURCE_VIEW_STATE_KEY,
          {
            gameKey: selectedResourceGame,
            stage: currentResourceStage
          }
        );
      }

      function showResourceStage(
        stage,
        {
          persist = true
        } = {}
      ) {
        const safeStage =
          VALID_RESOURCE_STAGES.has(stage)
            ? stage
            : 'home';

        if (RESOURCES_HOME) {
          RESOURCES_HOME.hidden = safeStage !== 'home';
        }
        if (RESOURCES_TOOLS) {
          RESOURCES_TOOLS.hidden = safeStage !== 'tools';
        }
        if (LEVEL_CAPS_VIEW) {
          LEVEL_CAPS_VIEW.hidden = safeStage !== 'caps';
        }
        if (POKEMON_CENTERS_VIEW) {
          POKEMON_CENTERS_VIEW.hidden =
            safeStage !== 'centers';
        }
        currentResourceStage = safeStage;

        if (persist) {
          saveResourceViewState();
        }
      }

      function selectResourceGame(gameKey) {
        const game = RESOURCE_GAME_META[gameKey];
        if (!game) return;

        selectedResourceGame = gameKey;

        if (RESOURCE_GAME_TITLE) {
          RESOURCE_GAME_TITLE.textContent =
            `${game.title} Resources`;
        }

        showResourceStage('tools');
      }

      function appendLevelCapCell(row, value, cellTag = 'td') {
        const cell = document.createElement(cellTag);
        cell.textContent = String(value);
        row.appendChild(cell);
      }

      function getPokemonCenterLog() {
        const saved = loadJSON(POKEMON_CENTER_LOG_KEY, {});
        return saved && typeof saved === 'object' ? saved : {};
      }

      function savePokemonCenterLog(log) {
        saveJSON(POKEMON_CENTER_LOG_KEY, log || {});
      }

      function getPokemonCenterEntries(gameKey) {
        const data = POKEMON_CENTER_DATA[gameKey];
        if (!data) return [];
        return data.sections.flatMap(section => section.centers || []);
      }

      function updatePokemonCenterProgress(gameKey) {
        if (!POKEMON_CENTERS_PROGRESS) return;
        const entries = getPokemonCenterEntries(gameKey);
        const log = getPokemonCenterLog();
        const gameLog = log[gameKey] || {};
        const usedCount = entries.filter(center => gameLog[center.id] === true).length;
        POKEMON_CENTERS_PROGRESS.textContent =
          `${usedCount} of ${entries.length} healing locations used`;
      }

      function setPokemonCenterUsed(gameKey, centerId, isUsed) {
        const log = getPokemonCenterLog();
        if (!log[gameKey] || typeof log[gameKey] !== 'object') {
          log[gameKey] = {};
        }
        if (isUsed) {
          log[gameKey][centerId] = true;
        } else {
          delete log[gameKey][centerId];
        }
        savePokemonCenterLog(log);
        updatePokemonCenterProgress(gameKey);
      }

      function renderPokemonCenters(gameKey = selectedResourceGame) {
        const data = POKEMON_CENTER_DATA[gameKey];
        if (
          !data ||
          !POKEMON_CENTERS_TITLE ||
          !POKEMON_CENTERS_DESCRIPTION ||
          !POKEMON_CENTERS_LIST
        ) {
          return;
        }

        POKEMON_CENTERS_TITLE.textContent = data.title;
        POKEMON_CENTERS_DESCRIPTION.textContent = data.description;
        POKEMON_CENTERS_LIST.innerHTML = '';

        const log = getPokemonCenterLog();
        const gameLog = log[gameKey] || {};

        data.sections.forEach(section => {
          const sectionEl = document.createElement('section');
          sectionEl.className = 'dl-center-log-section';

          const heading = document.createElement('h5');
          heading.className = 'dl-center-log-section-title';
          heading.textContent = section.title;

          const items = document.createElement('div');
          items.className = 'dl-center-log-items';

          section.centers.forEach(center => {
            const label = document.createElement('label');
            label.className = 'dl-center-log-item';

            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.className = 'dl-center-log-checkbox';
            checkbox.checked = gameLog[center.id] === true;
            checkbox.setAttribute('aria-label', `Mark ${center.name} healing as used`);

            const name = document.createElement('span');
            name.className = 'dl-center-log-name';
            name.textContent = center.name;

            label.classList.toggle('is-used', checkbox.checked);

            checkbox.addEventListener('change', () => {
              label.classList.toggle('is-used', checkbox.checked);
              setPokemonCenterUsed(gameKey, center.id, checkbox.checked);
            });

            label.appendChild(checkbox);
            label.appendChild(name);

            if (center.badge) {
              const badge = document.createElement('span');
              badge.className = 'dl-center-log-badge';
              badge.textContent = center.badge;
              label.appendChild(badge);
            }

            items.appendChild(label);
          });

          sectionEl.appendChild(heading);
          sectionEl.appendChild(items);
          POKEMON_CENTERS_LIST.appendChild(sectionEl);
        });

        updatePokemonCenterProgress(gameKey);
        showResourceStage('centers');
      }

      function resetPokemonCenterLog(gameKey) {
        const data = POKEMON_CENTER_DATA[gameKey];
        if (!data) return;

        showRollerDialog({
          title: 'Reset healing log?',
          message:
            `This will uncheck every healing location in ${RESOURCE_GAME_META[gameKey].title}.`,
          confirmText: 'Reset healing log',
          cancelText: 'Keep log',
          tone: 'warning',
          onConfirm: () => {
            const log = getPokemonCenterLog();
            delete log[gameKey];
            savePokemonCenterLog(log);
            renderPokemonCenters(gameKey);
          }
        });
      }

      function renderLevelCaps(gameKey = selectedResourceGame) {
        const data = LEVEL_CAP_DATA[gameKey];
        if (
          !data ||
          !LEVEL_CAPS_TITLE ||
          !LEVEL_CAPS_DESCRIPTION ||
          !LEVEL_CAPS_TABLE ||
          !LEVEL_CAPS_HEAD ||
          !LEVEL_CAPS_BODY
        ) {
          return;
        }

        LEVEL_CAPS_TITLE.textContent = data.title;
        LEVEL_CAPS_DESCRIPTION.textContent =
          data.description;

        LEVEL_CAPS_TABLE.classList.toggle(
          'dl-level-cap-table--comparison',
          data.comparison === true
        );

        LEVEL_CAPS_HEAD.innerHTML = '';
        LEVEL_CAPS_BODY.innerHTML = '';

        const headerRow = document.createElement('tr');
        data.columns.forEach(column => {
          appendLevelCapCell(headerRow, column, 'th');
        });
        LEVEL_CAPS_HEAD.appendChild(headerRow);

        data.rows.forEach(item => {
          const row = document.createElement('tr');

          if (item && !Array.isArray(item) && item.phase) {
            row.className = 'dl-level-cap-phase-row';

            const cell = document.createElement('td');
            cell.colSpan = data.columns.length;
            cell.textContent = item.phase;
            row.appendChild(cell);
          } else {
            item.forEach(value => {
              appendLevelCapCell(row, value);
            });
          }

          LEVEL_CAPS_BODY.appendChild(row);
        });

        showResourceStage('caps');
      }


      const LAST_ROLL_SHOP_MAX_PURCHASES = 3;

      const LAST_ROLL_SHOP_NORMAL_ITEMS = [
        {
          id: 'packed_lunch',
          category: 'blessing',
          cost: 3,
          name: 'Packed Lunch',
          summary: 'Gain Consumable.',
          effect: {
            kind: 'bonus',
            title: 'Consumable Item',
            text: 'You may use one consumable item.'
          }
        },
        {
          id: 'nurse_joy_coupon',
          category: 'blessing',
          cost: 5,
          name: 'Nurse Joy Coupon',
          summary: 'Gain Center Refresh.',
          effect: {
            kind: 'bonus',
            title: 'Center Refresh',
            text: 'Refresh a Pokémon Center.'
          }
        },
        {
          id: 'safari_clause',
          category: 'blessing',
          cost: 7,
          name: 'Make it Count',
          summary: 'Gain Extra Catch.',
          effect: {
            kind: 'bonus',
            title: 'Extra Catch',
            text: 'Catch an extra Pokémon on any previous route.'
          }
        },
        {
          id: 'baby_boom',
          category: 'blessing',
          cost: 15,
          name: 'Baby Boom',
          summary: 'Make an egg. Retire the living parent whose species matches the offspring.',
          effect: {
            kind: 'bonus',
            title: 'Baby Boom',
            text: 'Make an egg using any two alive Pokémon. After the egg is created, retire the living parent whose species matches the offspring. Retiring means that parent stays alive and can chill in the box with their friends, but is no longer usable.'
          }
        },
        {
          id: 'blind_cleanse',
          category: 'curse',
          cost: 3,
          name: 'Blind Cleanse',
          summary: 'Remove 1 random eligible Curse.',
          removeKind: 'random'
        },
        {
          id: 'targeted_cleanse',
          category: 'curse',
          cost: 5,
          name: 'Targeted Cleanse',
          summary: 'Remove 1 chosen eligible Curse.',
          removeKind: 'chosen'
        },
        {
          id: 'curse_exchange',
          category: 'curse',
          cost: 7,
          name: 'Curse Exchange',
          summary: 'Remove 1 chosen eligible Curse, then gain 1 random Blessing.',
          removeKind: 'chosen',
          grantsRandomBlessing: true
        },
        {
          id: 'curse_expulsion',
          category: 'curse',
          cost: 15,
          name: 'Curse Expulsion',
          summary: 'Remove all eligible Curses.',
          removeKind: 'all'
        }
      ];

      const LAST_ROLL_SHOP_CHAT_EXCLUSIVE_ITEMS = [
        {
          id: 'shady_deal',
          category: 'chat_cosmetic',
          name: 'Shady Deal',
          summary:
            'Something questionable happens to one living Pokémon.',
          cosmetic: 'sunglasses',
          emoji: '😎'
        },
        {
          id: 'top_priority',
          category: 'chat_cosmetic',
          name: 'Top Priority',
          summary:
            'One living Pokémon receives special treatment.',
          cosmetic: 'hat',
          emoji: '🎩'
        }
      ];

      const LAST_ROLL_SHOP_GAMBIT_ITEMS = [
        {
          id: 'shopping_spree',
          name: 'Shopping Spree',
          summary:
            'Randomly buy 2 items from the Blessings/Curses shop. They can be duplicates and cannot come from Gambits.'
        },
        {
          id: 'chat_decides',
          name: "Chat Decides",
          summary:
            'Reveal 3 random Chat Decides effects. If live, chat chooses 2 to apply. If not live, randomly choose 2 of the 3.'
        },
        {
          id: 'forbidden_deal',
          name: 'Forbidden Deal',
          summary:
            'Gain Curse Expulsion and Baby Boom. Both parents die.'
        }
      ];

      let lastRollShopChatChoices = [];
      let lastRollShopChatSelectedIds = [];
      let lastRollShopPreviousBodyOverflow = '';
      let lastRollShopPreviousHtmlOverflow = '';
      let lastRollShopPreviousFocus = null;

      function getLastRollShopItem(itemId) {
        return LAST_ROLL_SHOP_NORMAL_ITEMS.find(
          item => item.id === itemId
        ) || null;
      }

      function getLastRollShopGambitItem(itemId) {
        return LAST_ROLL_SHOP_GAMBIT_ITEMS.find(
          item => item.id === itemId
        ) || null;
      }

      function normalizeLastRollShopMode(mode) {
        if (mode === 'regular') return 'regular';
        if (mode === 'gambit' || mode === 'wacky') return 'gambit';
        return null;
      }

      function getLastRollShopState() {
        const saved = loadJSON(
          LAST_ROLL_SHOP_KEY,
          {
            mode: null,
            purchases: []
          }
        );

        const mode = normalizeLastRollShopMode(
          saved?.mode
        );

        return {
          mode,
          purchases: Array.isArray(saved?.purchases)
            ? saved.purchases.slice(0, 25)
            : []
        };
      }

      function saveLastRollShopState(state) {
        saveJSON(
          LAST_ROLL_SHOP_KEY,
          {
            mode: normalizeLastRollShopMode(
              state?.mode
            ),
            purchases: Array.isArray(state?.purchases)
              ? state.purchases
              : []
          }
        );
      }

      function getLastRollShopPurchaseCount() {
        return getLastRollShopState().purchases.length;
      }

      function getLastRollShopEligibleCurses() {
        return getEffects().filter(effect =>
          effect &&
          effect.kind === 'malus' &&
          !isLastRollShopProtectedCurse(effect)
        );
      }

      function isLastRollShopProtectedCurse(effect) {
        const title = String(effect?.title || '').toLowerCase();
        const text = String(effect?.text || '').toLowerCase();

        return (
          title.includes('soul link') ||
          title.includes('darkrai') ||
          text.includes('darkrai')
        );
      }

      function getLastRollShopRandomBlessingItem() {
        const blessingItems = LAST_ROLL_SHOP_NORMAL_ITEMS.filter(
          item => item.category === 'blessing'
        );

        return blessingItems[
          Math.floor(Math.random() * blessingItems.length)
        ] || null;
      }

      function createLastRollShopEffect(effectData) {
        const now = new Date();
        const effect = {
          id: `shop-${Date.now()}-${Math.random().toString(16).slice(2)}`,
          kind: effectData.kind,
          roll: null,
          title: effectData.title,
          text: effectData.text,
          timeLabel:
            `Bought from The Last Roll Shop at ${now.toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit'
            })}`,
          applyKind: effectData.applyKind || null,
          source: 'lastRollShop'
        };

        if (effect.applyKind === 'teamChoice') {
          applyGeneratedTeamChoicesToEffect(
            effect,
            generateTeamChoiceTeams()
          );
        }

        return effect;
      }

      function addLastRollShopBlessing(item) {
        if (!item?.effect) return '';

        addEffects([
          createLastRollShopEffect(item.effect)
        ]);

        return `Gained ${item.effect.title}.`;
      }

      function removeLastRollShopCurseById(effectId) {
        const effects = getEffects();
        const effect = effects.find(item => item.id === effectId);

        if (!effect || isLastRollShopProtectedCurse(effect)) {
          return null;
        }

        setEffects(
          effects.filter(item => item.id !== effectId)
        );
        renderEffects();

        return effect;
      }

      function applyLastRollShopCurseRemoval(
        item,
        {
          targetId = null,
          randomizeChosen = false
        } = {}
      ) {
        const eligibleCurses = getLastRollShopEligibleCurses();

        if (!eligibleCurses.length) {
          return 'No eligible Curses were available to remove.';
        }

        if (item.removeKind === 'all') {
          const eligibleIds = new Set(
            eligibleCurses.map(effect => effect.id)
          );

          setEffects(
            getEffects().filter(effect =>
              !eligibleIds.has(effect.id)
            )
          );
          renderEffects();

          return `Removed ${eligibleCurses.length} eligible ${eligibleCurses.length === 1 ? 'Curse' : 'Curses'}.`;
        }

        let selectedCurse = null;

        if (item.removeKind === 'random' || randomizeChosen) {
          selectedCurse =
            eligibleCurses[
              Math.floor(Math.random() * eligibleCurses.length)
            ];
        } else {
          selectedCurse =
            eligibleCurses.find(effect => effect.id === targetId) ||
            null;
        }

        if (!selectedCurse) {
          return null;
        }

        const removed = removeLastRollShopCurseById(
          selectedCurse.id
        );

        return removed
          ? `Removed ${removed.title}.`
          : null;
      }

      function applyLastRollShopNormalItem(
        item,
        {
          targetId = null,
          randomizeChosen = false
        } = {}
      ) {
        const details = [];

        if (item.category === 'blessing') {
          details.push(addLastRollShopBlessing(item));
        } else if (item.category === 'curse') {
          const removalDetail =
            applyLastRollShopCurseRemoval(
              item,
              {
                targetId,
                randomizeChosen
              }
            );

          if (removalDetail) {
            details.push(removalDetail);
          }

          if (item.grantsRandomBlessing) {
            const blessingItem =
              getLastRollShopRandomBlessingItem();

            if (blessingItem) {
              details.push(
                addLastRollShopBlessing(blessingItem)
              );
            }
          }
        }

        return details.filter(Boolean).join(' ');
      }

      function addLastRollShopPurchase({
        id,
        name,
        category,
        cost = null,
        spent = null,
        detail = ''
      }) {
        const state = getLastRollShopState();
        const nextMode =
          category === 'gambit'
            ? 'gambit'
            : 'regular';

        if (!state.mode) {
          state.mode = nextMode;
        }

        state.purchases.push({
          id,
          name,
          category,
          cost,
          spent,
          detail,
          purchasedAt: new Date().toISOString()
        });

        saveLastRollShopState(state);
      }

      function recordLastRollShopHistory({
        name,
        detail,
        spent = null
      }) {
        recordHistory({
          kind: 'shopPurchase',
          title: `Shop purchase: ${name}`,
          detail:
            spent === null
              ? detail
              : `${detail} Spent ${spent} Dice ${spent === 1 ? 'Roll' : 'Rolls'}.`
        });
      }

      function canUseLastRollShopMode(mode) {
        const state = getLastRollShopState();

        if (state.purchases.length >= LAST_ROLL_SHOP_MAX_PURCHASES) {
          return {
            ok: false,
            message: 'The Last Roll Shop is closed because the 3-purchase limit has been reached.'
          };
        }

        if (state.mode === 'gambit') {
          return {
            ok: false,
            message: 'The Last Roll Shop is closed because you chose a Gambit.'
          };
        }

        if (state.mode && state.mode !== mode) {
          return {
            ok: false,
            message:
              state.mode === 'regular'
                ? 'Gambits are locked because you already bought from Blessings/Curses.'
                : 'Blessings/Curses are locked because you already bought a Gambit.'
          };
        }

        return {
          ok: true,
          message: ''
        };
      }

      function buyLastRollShopNormalItem(itemId) {
        const item = getLastRollShopItem(itemId);
        if (!item) return;

        if (lastRollShopChatChoices.length) {
          showRollerNotice(
            "Resolve the Chat Decides choices before buying anything else.",
            "Chat Decides is pending"
          );
          return;
        }

        const modeCheck = canUseLastRollShopMode('regular');
        if (!modeCheck.ok) {
          showRollerNotice(modeCheck.message, 'Shop closed');
          return;
        }

        if (diceRolls < item.cost) {
          showRollerNotice(
            `You need ${item.cost} Dice Rolls to buy ${item.name}.`,
            'Not enough Dice Rolls'
          );
          return;
        }

        let targetId = null;

        if (
          item.removeKind === 'chosen'
        ) {
          const select = LAST_ROLL_SHOP_CONTENT?.querySelector(
            `[data-last-roll-shop-target="${item.id}"]`
          );
          targetId = select?.value || null;

          if (!targetId) {
            showRollerNotice(
              'Choose an eligible Curse before buying this item.',
              'Choose a Curse'
            );
            return;
          }
        }

        if (
          item.category === 'curse' &&
          !getLastRollShopEligibleCurses().length
        ) {
          showRollerNotice(
            'There are no eligible Curses available. Soul Links and Darkrai curses cannot be removed by the shop.',
            'No eligible Curses'
          );
          return;
        }

        setStoredRolls(diceRolls - item.cost);

        const detail = applyLastRollShopNormalItem(
          item,
          {
            targetId
          }
        ) || 'No eligible effect was available.';

        lastRollShopChatChoices = [];

        addLastRollShopPurchase({
          id: item.id,
          name: item.name,
          category: item.category,
          cost: item.cost,
          detail
        });

        recordLastRollShopHistory({
          name: item.name,
          detail
        });

        renderLastRollShop();
      }

      function chooseRandomLastRollShopNormalItem() {
        return LAST_ROLL_SHOP_NORMAL_ITEMS[
          Math.floor(
            Math.random() *
            LAST_ROLL_SHOP_NORMAL_ITEMS.length
          )
        ] || null;
      }

      function applyRandomLastRollShopNormalItem() {
        const item = chooseRandomLastRollShopNormalItem();
        if (!item) return 'No item was selected.';

        const detail = applyLastRollShopNormalItem(
          item,
          {
            randomizeChosen: true
          }
        ) || 'No eligible effect was available.';

        return `${item.name}: ${detail}`;
      }

      function buyLastRollShopShoppingSpree(spent) {
        const results = [
          applyRandomLastRollShopNormalItem(),
          applyRandomLastRollShopNormalItem()
        ];

        const detail =
          `Randomly bought 2 non-Gambit shop items: ${results.join(' ')}`;

        addLastRollShopPurchase({
          id: 'shopping_spree',
          name: 'Shopping Spree',
          category: 'gambit',
          spent,
          detail
        });

        recordLastRollShopHistory({
          name: 'Shopping Spree',
          detail,
          spent
        });
      }

      function getLastRollShopChatPool() {
        return [
          ...LAST_ROLL_SHOP_NORMAL_ITEMS,
          ...LAST_ROLL_SHOP_CHAT_EXCLUSIVE_ITEMS
        ];
      }

      function getLastRollShopLivingPokemon() {
        return pokemons.filter(pokemon =>
          pokemon &&
          (pokemon.location === 'team' || pokemon.location === 'box')
        );
      }

      function applyLastRollShopCosmeticItem(item) {
        const livingPokemon = getLastRollShopLivingPokemon();

        if (!livingPokemon.length) {
          return 'No living Pokémon was available.';
        }

        const pokemon = livingPokemon[
          Math.floor(Math.random() * livingPokemon.length)
        ];
        const originalName = getPokemonDisplayName(pokemon);
        const emoji = item.emoji || '';

        if (emoji && !String(pokemon.name || '').includes(emoji)) {
          pokemon.name = `${originalName} ${emoji}`;
        }

        savePokemons();

        if (item.cosmetic === 'sunglasses') {
          return `${originalName} became cooler. ${originalName} gained ${emoji}.`;
        }

        if (item.cosmetic === 'hat') {
          return `${originalName} received emergency headwear. ${originalName} gained ${emoji}.`;
        }

        return `${originalName} was changed by ${item.name}.`;
      }

      function applyLastRollShopChatEffect(item) {
        if (item?.category === 'chat_cosmetic') {
          return applyLastRollShopCosmeticItem(item);
        }

        return applyLastRollShopNormalItem(
          item,
          {
            randomizeChosen: true
          }
        ) || 'No eligible effect was available.';
      }

      function getLastRollShopSelectedChatItems() {
        return lastRollShopChatSelectedIds
          .map(id =>
            lastRollShopChatChoices.find(item => item.id === id)
          )
          .filter(Boolean);
      }

      function applyLastRollShopChatItems(items) {
        const selectedItems = (items || []).filter(Boolean).slice(0, 2);

        if (selectedItems.length < 2) {
          showRollerNotice(
            'Choose 2 Chat Decides effects before applying them.',
            'Choose 2 effects'
          );
          return;
        }

        const modeCheck = canUseLastRollShopMode('gambit');
        if (!modeCheck.ok) {
          showRollerNotice(modeCheck.message, 'Shop closed');
          return;
        }

        if (diceRolls < 1) {
          showRollerNotice(
            'You need at least 1 Dice Roll to buy a Gambit.',
            'Not enough Dice Rolls'
          );
          return;
        }

        const spent = diceRolls;
        setStoredRolls(0);

        const results = selectedItems.map(item =>
          `${item.name}: ${applyLastRollShopChatEffect(item)}`
        );
        const detail =
          `Applied 2 Chat Decides effects: ${results.join(' ')}`;

        addLastRollShopPurchase({
          id: 'chat_decides',
          name: "Chat Decides",
          category: 'gambit',
          spent,
          detail
        });

        recordLastRollShopHistory({
          name: "Chat Decides",
          detail,
          spent
        });

        lastRollShopChatChoices = [];
        lastRollShopChatSelectedIds = [];
        renderLastRollShop();
      }

      function revealLastRollShopChatChoices() {
        const choices = [];
        const pool = getLastRollShopChatPool();

        while (choices.length < 3 && pool.length) {
          const index = Math.floor(Math.random() * pool.length);
          choices.push(pool.splice(index, 1)[0]);
        }

        lastRollShopChatChoices = choices;
        lastRollShopChatSelectedIds = [];
        renderLastRollShop();
      }

      function buyLastRollShopChatChoice(itemId) {
        const item = lastRollShopChatChoices.find(
          choice => choice.id === itemId
        );

        if (!item) return;

        if (lastRollShopChatSelectedIds.includes(item.id)) {
          lastRollShopChatSelectedIds =
            lastRollShopChatSelectedIds.filter(id => id !== item.id);
          renderLastRollShop();
          return;
        }

        if (lastRollShopChatSelectedIds.length >= 2) {
          showRollerNotice(
            'Chat can only choose 2 effects.',
            "Chat Decides"
          );
          return;
        }

        lastRollShopChatSelectedIds.push(item.id);
        renderLastRollShop();
      }

      function applyLastRollShopSelectedChatChoices() {
        applyLastRollShopChatItems(
          getLastRollShopSelectedChatItems()
        );
      }

      function buyLastRollShopForbiddenDeal(spent) {
        const expulsionItem =
          getLastRollShopItem('curse_expulsion');
        const babyBoomItem =
          getLastRollShopItem('baby_boom');

        const details = [];

        if (expulsionItem) {
          details.push(
            applyLastRollShopNormalItem(expulsionItem)
          );
        }

        if (babyBoomItem) {
          details.push(
            addLastRollShopBlessing({
              ...babyBoomItem,
              effect: {
                ...babyBoomItem.effect,
                text:
                  'Make an egg using any two alive Pokémon. After the egg is created, retire the living parent whose species matches the offspring. Retiring means that parent stays alive and can chill in the box with their friends, but is no longer usable.'
              }
            })
          );
        }

        const detail =
          'Gained Curse Expulsion and Baby Boom. ' +
          details.filter(Boolean).join(' ') +
          ' Retire the living parent whose species matches the offspring after the egg is created.';

        addLastRollShopPurchase({
          id: 'forbidden_deal',
          name: 'Forbidden Deal',
          category: 'gambit',
          spent,
          detail
        });

        recordLastRollShopHistory({
          name: 'Forbidden Deal',
          detail,
          spent
        });
      }

      function buyLastRollShopGambitItem(itemId) {
        const item = getLastRollShopGambitItem(itemId);
        if (!item) return;

        if (lastRollShopChatChoices.length) {
          showRollerNotice(
            "Resolve Chat Decides choices before buying anything else.",
            "Chat Decides is pending"
          );
          return;
        }

        const modeCheck = canUseLastRollShopMode('gambit');
        if (!modeCheck.ok) {
          showRollerNotice(modeCheck.message, 'Shop closed');
          return;
        }

        if (diceRolls < 1) {
          showRollerNotice(
            'You need at least 1 Dice Roll to buy a Gambit.',
            'Not enough Dice Rolls'
          );
          return;
        }

        if (item.id === 'chat_decides') {
          revealLastRollShopChatChoices();
          return;
        }

        const spent = diceRolls;
        setStoredRolls(0);

        if (item.id === 'shopping_spree') {
          buyLastRollShopShoppingSpree(spent);
        } else if (item.id === 'forbidden_deal') {
          buyLastRollShopForbiddenDeal(spent);
        }

        renderLastRollShop();
      }

      function chooseRandomLastRollShopChatChoice() {
        if (!lastRollShopChatChoices.length) return;

        const randomItems = shuffleArray(lastRollShopChatChoices)
          .slice(0, 2);

        applyLastRollShopChatItems(randomItems);
      }

      function renderLastRollShopStatus() {
        if (!LAST_ROLL_SHOP_STATUS) return;

        const state = getLastRollShopState();
        const purchaseCount = state.purchases.length;
        const route =
          state.mode === 'regular'
            ? 'Blessings/Curses'
            : state.mode === 'gambit'
              ? 'Gambits'
              : 'None chosen yet';

        LAST_ROLL_SHOP_STATUS.innerHTML =
          `<span><strong>Dice Rolls:</strong> ${diceRolls}</span>` +
          `<span><strong>Purchases:</strong> ${purchaseCount} / ${LAST_ROLL_SHOP_MAX_PURCHASES}</span>` +
          `<span><strong>Shop route:</strong> ${route}</span>`;
      }

      function renderLastRollShopRules(container) {
        const rules = document.createElement('div');
        rules.className = 'dl-shop-rules';
        rules.innerHTML =
          '<h5 class="dl-shop-rules-title">Shop Rules</h5>' +
          '<ul class="dl-shop-rules-list">' +
            '<li>Use only after all Gyms are complete and before entering the Elite Four equivalent.</li>' +
            '<li>Soul Links and Darkrai curses cannot be removed by the shop.</li>' +
            '<li>You may make up to 3 purchases total.</li>' +
            '<li>Buying from Blessings/Curses locks Gambits. Buying from Gambits locks Blessings/Curses.</li>' +
            '<li>Gambits spend all remaining Dice Rolls and need at least 1 Dice Roll to buy.</li>' +
            '<li>Gambit effects cannot trigger other Gambit effects.</li>' +
          '</ul>';

        container.appendChild(rules);
      }

      function getLastRollShopClosedReason() {
        const state = getLastRollShopState();

        if (state.purchases.length >= LAST_ROLL_SHOP_MAX_PURCHASES) {
          return 'The Last Roll Shop is closed because the 3-purchase limit has been reached.';
        }

        if (state.mode === 'gambit') {
          return 'The Last Roll Shop is closed because you chose a Gambit.';
        }

        return '';
      }

      function renderLastRollShopItem(
        item,
        container,
        {
          isGambit = false
        } = {}
      ) {
        const state = getLastRollShopState();
        const purchaseCount = state.purchases.length;
        const mode = isGambit ? 'gambit' : 'regular';
        const modeCheck = canUseLastRollShopMode(mode);
        const eligibleCurses = getLastRollShopEligibleCurses();

        let disabledReason = '';

        if (lastRollShopChatChoices.length) {
          disabledReason = "Resolve Chat Decides choices first.";
        } else if (!modeCheck.ok) {
          disabledReason = modeCheck.message;
        } else if (!isGambit && diceRolls < item.cost) {
          disabledReason =
            `Need ${item.cost} Dice Rolls.`;
        } else if (
          isGambit &&
          diceRolls < 1
        ) {
          disabledReason =
            'Need at least 1 Dice Roll.';
        } else if (
          !isGambit &&
          item.category === 'curse' &&
          !eligibleCurses.length
        ) {
          disabledReason =
            'No eligible Curses available.';
        } else if (
          purchaseCount >= LAST_ROLL_SHOP_MAX_PURCHASES
        ) {
          disabledReason =
            'The 3-purchase limit has been reached.';
        }

        const card = document.createElement('article');
        card.className = 'dl-shop-item';
        card.classList.toggle('is-disabled', Boolean(disabledReason));

        const head = document.createElement('div');
        head.className = 'dl-shop-item-head';

        const name = document.createElement('div');
        name.className = 'dl-shop-item-name';
        name.textContent = item.name;

        const cost = document.createElement('div');
        cost.className = 'dl-shop-item-cost';
        cost.textContent = isGambit
          ? 'All Dice'
          : `${item.cost} Dice`;

        head.appendChild(name);
        head.appendChild(cost);

        const text = document.createElement('p');
        text.className = 'dl-shop-item-text';
        text.textContent = item.summary;

        card.appendChild(head);
        card.appendChild(text);

        if (
          !isGambit &&
          item.removeKind === 'chosen' &&
          eligibleCurses.length
        ) {
          const select = document.createElement('select');
          select.className = 'dl-shop-item-select';
          select.setAttribute(
            'data-last-roll-shop-target',
            item.id
          );

          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Choose an eligible Curse';
          select.appendChild(placeholder);

          eligibleCurses.forEach(effect => {
            const option = document.createElement('option');
            option.value = effect.id;
            option.textContent = effect.title;
            select.appendChild(option);
          });

          card.appendChild(select);
        }

        if (disabledReason) {
          const help = document.createElement('p');
          help.className = 'dl-shop-item-help';
          help.textContent = disabledReason;
          card.appendChild(help);
        }

        const actions = document.createElement('div');
        actions.className = 'dl-shop-item-actions';

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'dl-options-btn dl-shop-item-btn';
        button.disabled = Boolean(disabledReason);
        button.classList.toggle('dl-disabled', Boolean(disabledReason));

        if (isGambit) {
          button.textContent =
            item.id === 'chat_decides'
              ? 'Reveal choices'
              : 'Buy';
          button.setAttribute(
            'data-last-roll-shop-gambit',
            item.id
          );
        } else {
          button.textContent = 'Buy';
          button.setAttribute(
            'data-last-roll-shop-buy',
            item.id
          );
        }

        actions.appendChild(button);
        card.appendChild(actions);

        container.appendChild(card);
      }

      function renderLastRollShopCategory(
        container,
        {
          title,
          className,
          copy,
          items,
          isGambit = false
        }
      ) {
        const section = document.createElement('section');
        section.className =
          `dl-shop-category ${className || ''}`.trim();

        const heading = document.createElement('h5');
        heading.className = 'dl-shop-category-title';
        heading.textContent = title;
        section.appendChild(heading);

        if (copy) {
          const desc = document.createElement('p');
          desc.className = 'dl-shop-category-copy';
          desc.textContent = copy;
          section.appendChild(desc);
        }

        const grid = document.createElement('div');
        grid.className = 'dl-shop-item-grid';

        items.forEach(item => {
          renderLastRollShopItem(
            item,
            grid,
            {
              isGambit
            }
          );
        });

        section.appendChild(grid);
        container.appendChild(section);
      }

      function renderLastRollShopChatChoices(container) {
        if (!lastRollShopChatChoices.length) return;

        const wrap = document.createElement('div');
        wrap.className = 'dl-shop-chat-choices';

        const title = document.createElement('h5');
        title.className = 'dl-shop-category-title';
        title.textContent = "Chat Decides  choices";
        wrap.appendChild(title);

        const selectedCount = lastRollShopChatSelectedIds.length;
        const note = document.createElement('p');
        note.className = 'dl-shop-note';
        note.textContent =
          `Chat picks 2 effects. If you are not live, choose 2 randomly. Selected ${selectedCount} / 2.`;
        wrap.appendChild(note);

        const row = document.createElement('div');
        row.className = 'dl-shop-chat-choice-row';

        lastRollShopChatChoices.forEach(item => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'dl-shop-chat-card';
          const isSelected =
            lastRollShopChatSelectedIds.includes(item.id);
          btn.classList.toggle('is-selected', isSelected);
          btn.setAttribute(
            'data-last-roll-shop-chat-choice',
            item.id
          );

          const choiceTitle = document.createElement('span');
          choiceTitle.className = 'dl-shop-chat-card-title';
          choiceTitle.textContent = item.name;

          const choiceText = document.createElement('span');
          choiceText.className = 'dl-shop-chat-card-text';
          choiceText.textContent = item.summary;

          const choiceAction = document.createElement('span');
          choiceAction.className = 'dl-shop-chat-card-action';
          choiceAction.textContent = isSelected
            ? 'Selected'
            : 'Choose this';

          btn.appendChild(choiceTitle);
          btn.appendChild(choiceText);
          btn.appendChild(choiceAction);

          row.appendChild(btn);
        });

        wrap.appendChild(row);

        const actions = document.createElement('div');
        actions.className = 'dl-shop-chat-actions';

        const applyBtn = document.createElement('button');
        applyBtn.type = 'button';
        applyBtn.className = 'dl-options-btn dl-shop-chat-apply-btn';
        applyBtn.textContent = 'Apply selected choices';
        applyBtn.disabled = selectedCount !== 2;
        applyBtn.classList.toggle('dl-disabled', selectedCount !== 2);
        applyBtn.setAttribute(
          'data-last-roll-shop-chat-apply',
          'true'
        );
        actions.appendChild(applyBtn);

        const randomBtn = document.createElement('button');
        randomBtn.type = 'button';
        randomBtn.className = 'dl-options-btn dl-shop-random-btn';
        randomBtn.textContent = 'Choose 2 randomly';
        randomBtn.setAttribute(
          'data-last-roll-shop-chat-random',
          'true'
        );
        actions.appendChild(randomBtn);

        wrap.appendChild(actions);

        container.appendChild(wrap);
      }

      function renderLastRollShopPurchaseResults(container) {
        const state = getLastRollShopState();

        if (!state.purchases.length) return;

        const wrap = document.createElement('div');
        wrap.className = 'dl-shop-results';

        const title = document.createElement('h5');
        title.className = 'dl-shop-results-title';
        title.textContent = 'Shop Results';
        wrap.appendChild(title);

        const list = document.createElement('ul');
        list.className = 'dl-shop-results-list';

        state.purchases.forEach((purchase, index) => {
          const item = document.createElement('li');
          item.className = 'dl-shop-result-item';

          const name = document.createElement('div');
          name.className = 'dl-shop-result-name';
          name.textContent = `${index + 1}. ${purchase.name}`;

          const detail = document.createElement('div');
          detail.className = 'dl-shop-result-detail';
          detail.textContent = purchase.detail || 'No details recorded.';

          item.appendChild(name);
          item.appendChild(detail);
          list.appendChild(item);
        });

        wrap.appendChild(list);
        container.appendChild(wrap);
      }

      function renderLastRollShop() {
        if (!LAST_ROLL_SHOP_CONTENT) return;

        renderLastRollShopStatus();

        LAST_ROLL_SHOP_CONTENT.innerHTML = '';

        const content = document.createElement('div');
        content.className = 'dl-shop-categories';

        renderLastRollShopRules(content);

        const closedReason = getLastRollShopClosedReason();
        if (closedReason) {
          const closed = document.createElement('div');
          closed.className = 'dl-shop-closed';
          closed.textContent = closedReason;
          content.appendChild(closed);
        }

        renderLastRollShopPurchaseResults(content);
        renderLastRollShopChatChoices(content);

        const blessings = LAST_ROLL_SHOP_NORMAL_ITEMS.filter(
          item => item.category === 'blessing'
        );
        const curses = LAST_ROLL_SHOP_NORMAL_ITEMS.filter(
          item => item.category === 'curse'
        );

        renderLastRollShopCategory(
          content,
          {
            title: 'Blessings',
            className: 'dl-shop-category--blessing',
            copy: 'This shop has Blessings for purchase.',
            items: blessings
          }
        );

        renderLastRollShopCategory(
          content,
          {
            title: 'Curses',
            className: 'dl-shop-category--curse',
            copy: 'This shop has items that remove Curses.',
            items: curses
          }
        );

        renderLastRollShopCategory(
          content,
          {
            title: 'Gambits',
            className: 'dl-shop-category--gambit',
            copy: 'Spend every remaining Dice Roll on ONE risky final play.',
            items: LAST_ROLL_SHOP_GAMBIT_ITEMS,
            isGambit: true
          }
        );

        LAST_ROLL_SHOP_CONTENT.appendChild(content);
      }

      function isLastRollShopOverlayOpen() {
        return Boolean(
          (LAST_ROLL_SHOP_CONFIRM && !LAST_ROLL_SHOP_CONFIRM.hidden) ||
          (LAST_ROLL_SHOP_VIEW && !LAST_ROLL_SHOP_VIEW.hidden)
        );
      }

      function lockLastRollShopPage() {
        if (isLastRollShopOverlayOpen()) return;

        lastRollShopPreviousFocus = document.activeElement;
        lastRollShopPreviousBodyOverflow = document.body.style.overflow;
        lastRollShopPreviousHtmlOverflow = document.documentElement.style.overflow;

        document.documentElement.classList.add('dl-shop-modal-open');
        document.body.classList.add('dl-shop-modal-open');
      }

      function unlockLastRollShopPage() {
        document.documentElement.classList.remove('dl-shop-modal-open');
        document.body.classList.remove('dl-shop-modal-open');
        document.body.style.overflow = lastRollShopPreviousBodyOverflow;
        document.documentElement.style.overflow = lastRollShopPreviousHtmlOverflow;
        lastRollShopPreviousBodyOverflow = '';
        lastRollShopPreviousHtmlOverflow = '';
      }

      function hasPendingLastRollShopChatChoices() {
        return Boolean(
          lastRollShopChatChoices.length &&
          LAST_ROLL_SHOP_VIEW &&
          !LAST_ROLL_SHOP_VIEW.hidden
        );
      }

      function showLastRollShopPendingChatNotice() {
        showRollerNotice(
          "Resolve Chat Decides first. Choose 2 effects or use Choose 2 randomly.",
          "Chat Decides is pending"
        );
      }

      function closeLastRollShopOverlay({
        returnToHero = false,
        force = false
      } = {}) {
        if (!force && hasPendingLastRollShopChatChoices()) {
          showLastRollShopPendingChatNotice();
          return false;
        }

        if (LAST_ROLL_SHOP_CONFIRM) {
          LAST_ROLL_SHOP_CONFIRM.hidden = true;
          LAST_ROLL_SHOP_CONFIRM.setAttribute('aria-hidden', 'true');
        }

        if (LAST_ROLL_SHOP_VIEW) {
          LAST_ROLL_SHOP_VIEW.hidden = true;
          LAST_ROLL_SHOP_VIEW.setAttribute('aria-hidden', 'true');
        }

        lastRollShopChatChoices = [];
        lastRollShopChatSelectedIds = [];
        unlockLastRollShopPage();

        if (returnToHero) {
          setTopMode('hero');
          return true;
        }

        requestAnimationFrame(() => {
          if (
            lastRollShopPreviousFocus &&
            lastRollShopPreviousFocus.isConnected
          ) {
            lastRollShopPreviousFocus.focus();
          }
        });

        return true;
      }

      function showLastRollShopReady() {
        lockLastRollShopPage();

        if (LAST_ROLL_SHOP_VIEW) {
          LAST_ROLL_SHOP_VIEW.hidden = true;
          LAST_ROLL_SHOP_VIEW.setAttribute('aria-hidden', 'true');
        }

        if (LAST_ROLL_SHOP_CONFIRM) {
          LAST_ROLL_SHOP_CONFIRM.hidden = false;
          LAST_ROLL_SHOP_CONFIRM.setAttribute('aria-hidden', 'false');
        }

        requestAnimationFrame(() => {
          LAST_ROLL_SHOP_READY_YES_BTN?.focus();
        });
      }

      function showLastRollShopModal() {
        lockLastRollShopPage();

        if (LAST_ROLL_SHOP_CONFIRM) {
          LAST_ROLL_SHOP_CONFIRM.hidden = true;
          LAST_ROLL_SHOP_CONFIRM.setAttribute('aria-hidden', 'true');
        }

        if (LAST_ROLL_SHOP_VIEW) {
          LAST_ROLL_SHOP_VIEW.hidden = false;
          LAST_ROLL_SHOP_VIEW.setAttribute('aria-hidden', 'false');
        }

        renderLastRollShop();

        requestAnimationFrame(() => {
          LAST_ROLL_SHOP_TOOLS_BTN?.focus();
        });
      }

      function restoreResourceView() {
        if (
          !selectedResourceGame ||
          !RESOURCE_GAME_META[selectedResourceGame]
        ) {
          selectedResourceGame = null;
          showResourceStage(
            'home',
            {
              persist: false
            }
          );
          return;
        }

        if (RESOURCE_GAME_TITLE) {
          RESOURCE_GAME_TITLE.textContent =
            `${RESOURCE_GAME_META[selectedResourceGame].title} Resources`;
        }

        if (currentResourceStage === 'caps') {
          renderLevelCaps(selectedResourceGame);
          return;
        }

        if (currentResourceStage === 'centers') {
          renderPokemonCenters(selectedResourceGame);
          return;
        }

        showResourceStage(
          currentResourceStage === 'home'
            ? 'home'
            : 'tools',
          {
            persist: false
          }
        );
      }

      restoreResourceView();

      RESOURCE_GAME_BTNS.forEach(button => {
        button.addEventListener('click', () => {
          selectResourceGame(button.dataset.resourceGame);
        });
      });

      RESOURCE_GAMES_BTN?.addEventListener('click', () => {
        selectedResourceGame = null;
        showResourceStage('home');
      });

      LEVEL_CAPS_BTN?.addEventListener('click', () => {
        renderLevelCaps();
      });

      POKEMON_CENTERS_BTN?.addEventListener('click', () => {
        renderPokemonCenters();
      });

      LEVEL_CAPS_TOOLS_BTN?.addEventListener('click', () => {
        showResourceStage('tools');
      });

      POKEMON_CENTERS_TOOLS_BTN?.addEventListener('click', () => {
        showResourceStage('tools');
      });

      POKEMON_CENTERS_RESET_BTN?.addEventListener('click', () => {
        if (selectedResourceGame) {
          resetPokemonCenterLog(selectedResourceGame);
        }
      });

      LAST_ROLL_SHOP_BTN?.addEventListener('click', () => {
        showLastRollShopReady();
      });

      LAST_ROLL_SHOP_READY_TOOLS_BTN?.addEventListener('click', () => {
        closeLastRollShopOverlay();
      });

      LAST_ROLL_SHOP_READY_YES_BTN?.addEventListener('click', () => {
        showLastRollShopModal();
      });

      LAST_ROLL_SHOP_READY_NO_BTN?.addEventListener('click', () => {
        closeLastRollShopOverlay({ returnToHero: true });
      });

      LAST_ROLL_SHOP_TOOLS_BTN?.addEventListener('click', () => {
        closeLastRollShopOverlay();
      });

      LAST_ROLL_SHOP_CONTENT?.addEventListener('click', event => {
        const buyButton = event.target.closest(
          '[data-last-roll-shop-buy]'
        );
        if (buyButton) {
          buyLastRollShopNormalItem(
            buyButton.getAttribute('data-last-roll-shop-buy')
          );
          return;
        }

        const gambitButton = event.target.closest(
          '[data-last-roll-shop-gambit]'
        );
        if (gambitButton) {
          buyLastRollShopGambitItem(
            gambitButton.getAttribute('data-last-roll-shop-gambit')
          );
          return;
        }

        const chatChoiceButton = event.target.closest(
          '[data-last-roll-shop-chat-choice]'
        );
        if (chatChoiceButton) {
          buyLastRollShopChatChoice(
            chatChoiceButton.getAttribute(
              'data-last-roll-shop-chat-choice'
            )
          );
          return;
        }

        const applyButton = event.target.closest(
          '[data-last-roll-shop-chat-apply]'
        );
        if (applyButton) {
          applyLastRollShopSelectedChatChoices();
          return;
        }

        const randomButton = event.target.closest(
          '[data-last-roll-shop-chat-random]'
        );
        if (randomButton) {
          chooseRandomLastRollShopChatChoice();
        }
      });

      [LAST_ROLL_SHOP_CONFIRM, LAST_ROLL_SHOP_VIEW].forEach(panel => {
        panel?.addEventListener('click', event => {
          if (event.target === panel) {
            closeLastRollShopOverlay();
          }
        });
      });

      document.addEventListener('keydown', event => {
        if (
          event.key === 'Escape' &&
          isLastRollShopOverlayOpen() &&
          (!DIALOG_OVERLAY || DIALOG_OVERLAY.hidden)
        ) {
          event.preventDefault();
          closeLastRollShopOverlay();
        }
      }, true);

      // --- Top-left view state (hero / rules / party / history) ---
      let topMode = 'hero'; // 'hero' | 'rules' | 'party' | 'history' | 'whiteout'
      let partyViewMode = 'team'; // 'team' | 'box' | 'grave'

      function applyPartyViewMode() {
        if (!TEAM_PANEL || !BOX_PANEL || !GRAVE_PANEL) return;

        root.dataset.partyViewMode = partyViewMode;

        if (partyViewMode === 'team') {
          TEAM_PANEL.style.display  = '';
          BOX_PANEL.style.display   = 'none';
          GRAVE_PANEL.style.display = 'none';
        } else if (partyViewMode === 'box') {
          TEAM_PANEL.style.display  = 'none';
          BOX_PANEL.style.display   = '';
          GRAVE_PANEL.style.display = 'none';
        } else {
          TEAM_PANEL.style.display  = 'none';
          BOX_PANEL.style.display   = 'none';
          GRAVE_PANEL.style.display = '';
        }

        updateTopNavLabels();
        updateRightColumnForGraveView();
      }

      function setTopNavigationButtonState(
        button,
        isBackButton,
        defaultLabel
      ) {
        if (!button) return;

        button.textContent = isBackButton
          ? 'Back to Roller'
          : defaultLabel;
        button.classList.toggle(
          'dl-options-btn--back',
          isBackButton
        );
        button.setAttribute(
          'aria-label',
          isBackButton
            ? 'Back to Roller'
            : defaultLabel
        );
      }

      function updateTopNavLabels() {
        const isWhiteout = (topMode === 'whiteout');

        setTopNavigationButtonState(
          MANAGE_BTN,
          topMode === 'party' || isWhiteout,
          'Manage Party'
        );

        setTopNavigationButtonState(
          TOGGLE_HISTORY_BTN,
          topMode === 'history',
          'Show History'
        );

        setTopNavigationButtonState(
          TOGGLE_RULES_BTN,
          topMode === 'rules',
          'Rules & Resources'
        );
      }

      function applyTopMode() {
        if (!HERO_WRAPPER || !RULES_PANEL || !PARTY_PANEL) return;

        root.dataset.topMode = topMode;

        const isWhiteout = (topMode === 'whiteout');
        root.classList.toggle('dl-whiteout-lock', isWhiteout);

        HERO_WRAPPER.hidden  = (topMode !== 'hero');
        RULES_PANEL.hidden   = (topMode !== 'rules');
        HISTORY_PANEL.hidden = (topMode !== 'history');

        if (RESOURCES_BOX) {
          RESOURCES_BOX.hidden = (topMode !== 'rules');
        }

        if (BACKUP_BOX) {
          BACKUP_BOX.hidden = (topMode !== 'rules');
        }

        // Whiteout visibility note:
        // WHITEOUT_PANEL is nested inside PARTY_PANEL, so both modes require PARTY_PANEL.
        PARTY_PANEL.hidden = !(topMode === 'party' || isWhiteout);

        // Inside PARTY_PANEL: show either Party row/editor OR whiteout panel
        if (WHITEOUT_PANEL) WHITEOUT_PANEL.hidden = !isWhiteout;

        if (PARTY_ROW) PARTY_ROW.style.display = isWhiteout ? 'none' : '';
        if (EDITOR)    EDITOR.style.display    = 'none'; // stays hidden unless editor is explicitly opened

        if (topMode === 'party') {
          applyPartyViewMode();
        }

        // Lock navigation while choosing a whiteout option
        const locked = isWhiteout;
        [TOGGLE_RULES_BTN, MANAGE_BTN, TOGGLE_HISTORY_BTN, RESET_BTN].forEach(btn => {
          if (!btn) return;
          btn.disabled = locked;
          btn.classList.toggle('dl-disabled', locked);
        });

        if (HERO_BTN) {
          HERO_BTN.disabled = locked || diceRolls <= 0;
          HERO_BTN.classList.toggle('dl-disabled', HERO_BTN.disabled);
        }
        updateTopNavLabels();
        updateRightColumnForGraveView();
      }

      function setTopMode(mode) {
        if (!['hero','rules','party','history','whiteout'].includes(mode)) mode = 'hero';
        topMode = mode;
        applyTopMode();
      }

      function updateRightColumnForGraveView() {
        const isGraveView =
          topMode === 'party' &&
          partyViewMode === 'grave';
        const isRulesView =
          topMode === 'rules';

        if (ROLLS_BOX) {
          ROLLS_BOX.hidden =
            isGraveView ||
            isRulesView;
        }

        if (WHITEOUT_BOX) {
          WHITEOUT_BOX.hidden = !isGraveView;
        }

        // Render current status reminder (if any)
        if (isGraveView) {
          renderWhiteoutStatus();
        }
      }

      function clearAllMaluses() {
        const list = getEffects();
        const kept = list.filter(e => e.kind !== 'malus');
        setEffects(kept);
        renderEffects();
      }

      function clearWhiteoutChoice() {
        try {
          localStorage.removeItem(WHITEOUT_KEY);
          localStorage.removeItem(BIRDGOD_CHAMPION_KEY);
        } catch (_) {}
        updateWhiteoutInterventionTheme();
        renderWhiteoutStatus();
      }

      function pickRandomWhiteoutEvents(count) {
        const pool = WHITEOUT_EVENTS.slice();
        // Fisher-Yates shuffle
        for (let i = pool.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [pool[i], pool[j]] = [pool[j], pool[i]];
        }
        return pool.slice(0, Math.min(count, pool.length));
      }

      function renderWhiteoutChooser() {
        if (!WHITEOUT_CHOICES) return;

        WHITEOUT_CHOICES.innerHTML = '';

        const picks = pickRandomWhiteoutEvents(3);

        picks.forEach(ev => {
          const card = document.createElement('div');
          card.className = 'dl-effect-item dl-whiteout-card';
          card.dataset.interventionId = ev.id;
          card.style.marginBottom = '10px';

          const main = document.createElement('div');
          main.className = 'dl-effect-main';

          const title = document.createElement('div');
          title.className = 'dl-effect-title';
          title.textContent = `${ev.title} — ${ev.legend}`;

          const flavor = document.createElement('div');
          flavor.className = 'dl-effect-text';
          flavor.textContent = ev.flavor;

          const effect = document.createElement('div');
          effect.className = 'dl-effect-meta';
          effect.textContent = ev.effect;

          main.appendChild(title);
          main.appendChild(flavor);
          main.appendChild(effect);

          const actions = document.createElement('div');
          actions.className = 'dl-effect-actions';

          // Special handling: Final Wish has multiple buttons
          if (ev.id === 'final_wish' && Array.isArray(ev.choices)) {
            ev.choices.forEach(ch => {
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'dl-effect-apply';
              btn.textContent = ch.label.replace(' (TODO)', '');
              btn.addEventListener('click', () => chooseWhiteout(ev, ch.id));
              actions.appendChild(btn);
            });
          } else {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'dl-effect-apply';
            btn.textContent = 'Choose';
            btn.addEventListener('click', () => chooseWhiteout(ev, null));
            actions.appendChild(btn);
          }

          main.appendChild(actions);
          card.appendChild(main);
          WHITEOUT_CHOICES.appendChild(card);
        });
      }

      function grantDialgaComebackKidBlessing() {
        const now = new Date();
        const label =
          `Pulled from another timeline by Dialga at ${now.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
          })}`;

        addEffects([
          {
            id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
            kind: 'bonus',
            roll: 20,
            title: 'The Comeback Kid',
            text: 'Dialga pulls a hero from another timeline. Bring back a Pokémon of your choice - from the grave or a previous Dicelocke. They match the level and evolution stage of your team. NOTE: Cheat in your previous-Dicelocke mon exactly as it was.',
            timeLabel: label,
            applyKind: null
          }
        ]);
      }

      function applyWhiteoutAlternateTimeline() {
        // Keep ONLY current active party alive; everything else goes to grave
        const teamIds = new Set(
          pokemons
            .filter(p => p.location === 'team' && Number.isInteger(p.slotIndex))
            .map(p => p.id)
        );

        pokemons.forEach(p => {
          if (teamIds.has(p.id)) {
            // stay on team, keep slotIndex
            p.location = 'team';
          } else {
            p.location = 'grave';
            p.slotIndex = null;
          }
        });

        // Clean up locks so the UI doesn't trap the player after a reset-like event
        setLockedSlots([false, false, false, false, false, false]);
        lockedSlotNames = [null, null, null, null, null, null];
        saveLockedSlotNames();

        grantDialgaComebackKidBlessing();
        savePokemons();
      }

      function applyWhiteoutFinalWish(subchoiceId) {
        // Remove all blessings + curses
        setEffects([]);
        renderEffects();

        // Lose all dice rolls
        setStoredRolls(0);

        if (subchoiceId === 'revive_6_random') {
          const grave = pokemons.filter(
            p => p.location === 'grave'
          );
          const graveGroups =
            buildIndivisiblePokemonGroups(grave);
          const selectedGroups =
            chooseRandomGroupsUpToLimit(graveGroups, 6);
          const selectedIds = new Set(
            selectedGroups.flat()
          );

          pokemons.forEach(pokemon => {
            if (
              pokemon.location === 'grave' &&
              selectedIds.has(pokemon.id)
            ) {
              pokemon.location = 'box';
              pokemon.slotIndex = null;
            }
          });

          savePokemons();
        }

        if (subchoiceId === 'gain_30_rolls_2_shields') {
          setStoredRolls(30);
          setStoredShields(MAX_SHIELDS);
        }

        // revive_3 is user-controlled; no automation
      }

      function applyWhiteoutNightmareBargain() {
        // --- Convert currently active effects (blessings/curses only) ---
        const effects = getEffects();

        const TEAM_SHUFFLE_TEXT =
          'Randomize your team until the next Gym is complete. If you have multiple of this curse, only use one and apply the rest to subsequent Gyms.';

        const converted = effects.map(eff => {
          if (!eff) return eff;

          if (eff.kind === 'bonus') {
            // Keep metadata (id, createdAt, etc.) but overwrite what matters for behavior
            return {
              ...eff,
              title: 'Center Refresh',
              text: 'Refresh a Pokémon Center.',
              applyKind: null
            };
          }

          if (eff.kind === 'malus') {
            const cleaned = { ...eff };

            // Drop special payload from other curses (e.g., teamChoice state) so Team Shuffle behaves cleanly
            delete cleaned.teams;
            delete cleaned.teamLabels;
            delete cleaned.chosenTeamIndex;

            cleaned.title = 'Team Shuffle';
            cleaned.text = TEAM_SHUFFLE_TEXT;
            cleaned.applyKind = 'teamShuffle';
            return cleaned;
          }

          // Preserve any future effect kinds unchanged
          return eff;
        });

        setEffects(converted);
        renderEffects();

        // --- (1) Permanently lock one random team slot ---
        let darkraiDisplacedPokemonId = null;
        const candidates = [];
        for (let i = 0; i < 6; i++) {
          if (permaLockedSlots[i]) continue;
          candidates.push(i);
        }
        if (candidates.length) {
          const slot = candidates[Math.floor(Math.random() * candidates.length)];
          permaLockedSlots[slot] = true;
          permaLockedSlotNames[slot] = 'Darkrai';
          savePermaLocked();

          // Also ensure the normal lock array reflects it
          const merged = lockedSlots.slice();
          merged[slot] = true;
          setLockedSlots(merged);

          // If a Pokémon was occupying the newly-perma-locked slot, move it out (slot becomes unusable).
          const occ = pokemons.find(p => p.location === 'team' && p.slotIndex === slot);
          if (occ) {
            darkraiDisplacedPokemonId = occ.id;
            occ.location = 'box';
            occ.slotIndex = null;
            savePokemons();
          }
        }

        // --- (2) Triple Soul Link 3 random alive Pokémon (team/box) ---
        const usedIds = getLinkedMemberIdSet();
        const eligible = pokemons.filter(p =>
          (p.location === 'team' || p.location === 'box') &&
          !usedIds.has(p.id)
        );

        if (eligible.length >= 3) {
          const trio = shuffleArray(eligible).slice(0, 3);

          const nextLinks = (soulLinks || []).slice();
          nextLinks.push({
            type: 'triple',
            memberIds: trio.map(p => p.id)
          });
          setSoulLinks(nextLinks);
        }

        // Ensure UI reflects the new lock/link state immediately
        renderPartyUI();
        renderSoulLinksSummary();

        if (darkraiDisplacedPokemonId) {
          const displacedPokemon =
            getPokemonById(darkraiDisplacedPokemonId);

          showSoulLinkMoveReminder(
            displacedPokemon,
            'Darkrai moved this Pokémon to the box when its slot was permanently locked. Manually box any linked partners that are still on the active team.'
          );
        }
      }

      function applyWhiteoutInversionWorld() {
        // Graveyard becomes the survivors (moved to box),
        // everything else (team + box) gets sent to grave
        const graveIds = new Set(
          pokemons.filter(p => p.location === 'grave').map(p => p.id)
        );

        pokemons.forEach(p => {
          if (graveIds.has(p.id)) {
            p.location = 'box';
            p.slotIndex = null;
          } else {
            p.location = 'grave';
            p.slotIndex = null;
          }
        });

        // Giratina: invert active effects — Blessings become random Curses, and Curses become random Blessings.
        const effects = getEffects();
        const pools = getRollEffectPools();

        const converted = (effects || []).map(eff => {
          if (!eff) return eff;

          if (eff.kind === 'bonus') {
            const c = pickRandomFromPool(pools.cursePool);
            if (!c) return eff;

            const convertedCurse = {
              ...eff,
              kind: 'malus',
              title: c.title,
              text: c.text,
              applyKind: c.applyKind || null
            };

            delete convertedCurse.teams;
            delete convertedCurse.teamLabels;
            delete convertedCurse.chosenTeamIndex;

            if (convertedCurse.applyKind === 'teamChoice') {
              applyGeneratedTeamChoicesToEffect(
                convertedCurse,
                generateTeamChoiceTeams()
              );
            }

            return convertedCurse;
          }

          if (eff.kind === 'malus') {
            const b = pickRandomFromPool(pools.blessingPool);
            if (!b) return eff;

            const convertedBlessing = {
              ...eff,
              kind: 'bonus',
              title: b.title,
              text: b.text,
              applyKind: b.applyKind || null
            };

            delete convertedBlessing.teams;
            delete convertedBlessing.teamLabels;
            delete convertedBlessing.chosenTeamIndex;

            return convertedBlessing;
          }

          return eff;
        });

        setEffects(converted);
        renderEffects();

        setLockedSlots([false, false, false, false, false, false]);
        lockedSlotNames = [null, null, null, null, null, null];
        saveLockedSlotNames();

        savePokemons();
      }

      function applyWhiteoutSacredRebirth() {
        // Ho-Oh: revive everything
        pokemons.forEach(p => {
          if (p.location === 'grave') {
            p.location = 'box';
            p.slotIndex = null;
          }
        });

        // Clear ordinary locks so the revived roster is usable.
        setLockedSlots([false, false, false, false, false, false]);
        lockedSlotNames = [null, null, null, null, null, null];
        saveLockedSlotNames();

        savePokemons();

        // Persistent rule change:
        // - The interface informs the player that no additional Pokémon may be caught.
        // - Pokémon may still be manually added for trades, gifts, or story encounters.
        // - Each manually recorded faint grants +1 Dice Roll.
        // - All panel heading banners use Ho-Oh's red/orange treatment.
        setSacredRebirthActive(true);
      }


      function clearBirdGodTargetedCurses() {
        const effects = getEffects();

        const shouldClearEffect = effect => {
          if (!effect || effect.kind !== 'malus') return false;

          return (
            effect.applyKind === 'teamShuffle' ||
            effect.applyKind === 'boxRandom' ||
            effect.title === 'Team Shuffle' ||
            effect.title === 'Lock & Box'
          );
        };

        const clearedEffects = effects.filter(shouldClearEffect);
        const clearedIds = new Set(
          clearedEffects.map(effect => effect.id)
        );

        if (clearedIds.size) {
          setEffects(
            effects.filter(effect => !clearedIds.has(effect.id))
          );
        }

        const clearedLockedSlots = lockedSlots.filter(
          (isLocked, index) =>
            isLocked && !permaLockedSlots[index]
        ).length;

        if (clearedLockedSlots) {
          lockedSlotNames = [null, null, null, null, null, null];
          saveLockedSlotNames();
          setLockedSlots([false, false, false, false, false, false]);
        }

        if (clearedIds.size || clearedLockedSlots) {
          renderEffects();
          renderPartyUI();
        }

        return {
          effectCount: clearedEffects.length,
          lockedSlotCount: clearedLockedSlots,
          names: clearedEffects.map(effect => effect.title || 'Curse')
        };
      }

      function applyWhiteoutBirdGodChampion(pokemonId) {
        const chosenPokemon = getPokemonById(pokemonId);

        if (!chosenPokemon || chosenPokemon.location !== 'grave') {
          showRollerNotice(
            'Choose a fallen Pokémon from the Graveyard for BirdGOD.',
            'BirdGOD needs a fallen Pokémon'
          );
          return null;
        }

        chosenPokemon.location = 'box';
        chosenPokemon.slotIndex = null;

        const championName = getPokemonDisplayName(chosenPokemon);
        saveBirdGodChampionState({
          pokemonId: chosenPokemon.id,
          pokemonName: championName,
          chosenAt: new Date().toISOString()
        });

        savePokemons();

        const curseResult = clearBirdGodTargetedCurses();
        const clearedParts = [];

        if (curseResult.effectCount) {
          clearedParts.push(
            `${curseResult.effectCount} active ` +
            `${curseResult.effectCount === 1 ? 'curse' : 'curses'}`
          );
        }

        if (curseResult.lockedSlotCount) {
          clearedParts.push(
            `${curseResult.lockedSlotCount} locked ` +
            `${curseResult.lockedSlotCount === 1 ? 'slot' : 'slots'}`
          );
        }

        const curseDetail = clearedParts.length
          ? `BirdGOD cleared all Team Shuffle and Lock & Box curses he found: ${clearedParts.join(' and ')}.`
          : 'BirdGOD looked for Team Shuffle and Lock & Box curses to clear, found none, and pretended that was the plan.';

        return {
          championName,
          curseDetail
        };
      }

    function grantOneOfEachDiceRollBlessing() {
      const pools = getRollEffectPools();
      const blessings = (pools.blessingPool || []).filter(
        blessing => blessing.title !== 'The Comeback Kid'
      );

      if (!blessings.length) {
        return 0;
      }

      const now = new Date();
      const label =
        `Granted by Arceus at ${now.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })}`;

      const effectsToAdd = blessings.map(blessing => ({
        id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
        kind: 'bonus',
        roll: null,
        title: blessing.title,
        text: blessing.text,
        timeLabel: label,
        applyKind: blessing.applyKind || null
      }));

      addEffects(effectsToAdd);

      // Match the Roll 1 blessing behavior so Blessing Rolls is actually granted.
      if (blessings.some(blessing => blessing.title === 'Blessing Rolls')) {
        setStoredRolls(diceRolls + 2);
      }

      return effectsToAdd.length;
    }

    function applyWhiteoutJudgment() {
      // Arceus: choose the worthy, erase all others, and cleanse every curse.
      // Soul Links are intentionally preserved.

      function clearJudgmentCurseState() {
        // Remove every active curse card.
        clearAllMaluses();

        // Remove ordinary Lock & Box slot locks.
        lockedSlotNames = [null, null, null, null, null, null];
        saveLockedSlotNames();

        // Remove Darkrai's permanent locked-slot curse before resetting the
        // normal lock array, since permanent locks otherwise override it.
        permaLockedSlots = [false, false, false, false, false, false];
        permaLockedSlotNames = [null, null, null, null, null, null];
        savePermaLocked();

        setLockedSlots([false, false, false, false, false, false]);

        // Do not clear soulLinks. Judgment cleanses curses but leaves
        // established Soul Links intact.
        renderSoulLinksSummary();
      }

      clearJudgmentCurseState();
      const blessingCount = grantOneOfEachDiceRollBlessing();

      if (!Array.isArray(pokemons) || pokemons.length === 0) {
        savePokemons();
        return {
          survivorCount: 0,
          blessingCount
        };
      }

      // Treat every Soul Link as an indivisible group. Arceus may
      // select or erase a complete pair/triple, but never split one.
      const selectionGroups =
        buildIndivisiblePokemonGroups(pokemons);
      const chosenGroups =
        chooseRandomGroupsUpToLimit(selectionGroups, 6);
      const chosenIds = new Set(chosenGroups.flat());

      // Permanently erase the unworthy.
      pokemons = pokemons.filter(
        p => chosenIds.has(p.id)
      );

      // Keep every Soul Link whose complete membership survived.
      // Links belonging to fully erased groups are removed as stale data.
      setSoulLinks(
        (soulLinks || []).filter(link => {
          const memberIds = getSoulLinkMemberIds(link);
          return (
            memberIds.length >= 2 &&
            memberIds.every(id => chosenIds.has(id))
          );
        })
      );

      // Place the worthy Pokémon into the now-unlocked active team.
      pokemons.forEach((p, idx) => {
        p.location = 'team';
        p.slotIndex = idx;
      });

      savePokemons();
      return {
        survivorCount: pokemons.length,
        blessingCount
      };
    }

      function renderBirdGodChampionSelector(container, chosen) {
        const champion = getBirdGodChampionState();
        const championName = getBirdGodChampionName(champion);

        if (championName) {
          const championStatus = document.createElement('div');
          championStatus.style.marginTop = '8px';
          championStatus.style.fontWeight = '800';
          championStatus.textContent = `BirdGOD's Champion: ${championName}.`;
          container.appendChild(championStatus);
          return;
        }

        const panel = document.createElement('div');
        panel.className = 'dl-birdgod-selector-panel';

        const warning = document.createElement('p');
        warning.className = 'dl-birdgod-warning';
        warning.textContent =
          'Before choosing, make sure any whited-out active team members you want eligible have been moved to the Graveyard.';
        panel.appendChild(warning);

        const graveMons = pokemons.filter(
          pokemon => pokemon.location === 'grave'
        );

        if (!graveMons.length) {
          const none = document.createElement('div');
          none.className = 'dl-effect-meta';
          none.textContent =
            'No fallen Pokémon are currently in the Graveyard.';
          panel.appendChild(none);
          container.appendChild(panel);
          return;
        }

        const row = document.createElement('div');
        row.className = 'dl-birdgod-selector-row';

        const select = document.createElement('select');
        select.className = 'dl-birdgod-select';
        select.setAttribute("aria-label", "Choose BirdGOD\'s Champion");

        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Select a fallen Pokémon';
        select.appendChild(placeholder);

        graveMons.forEach(pokemon => {
          const option = document.createElement('option');
          option.value = pokemon.id;
          option.textContent = getPokemonDisplayName(pokemon);
          select.appendChild(option);
        });

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'dl-options-btn dl-birdgod-choose-btn';
        button.textContent = 'Choose Champion';
        button.addEventListener('click', () => {
          const pokemonId = select.value;
          if (!pokemonId) {
            showRollerNotice(
              'Select a fallen Pokémon from the Graveyard first.',
              'BirdGOD needs a champion'
            );
            select.focus();
            return;
          }

          const result = applyWhiteoutBirdGodChampion(pokemonId);
          if (!result) return;

          saveWhiteoutChoice({
            ...chosen,
            subchoiceId: pokemonId,
            championChosenAt: new Date().toISOString()
          });

          recordHistory({
            kind: 'event',
            title: 'Whiteout resolved - Champion of the Flock',
            detail:
              `${result.championName} was revived as BirdGOD's Champion. ` +
              `${result.championName} cannot die. If they faint, box them until the next Pokemon Center is used. ` +
              result.curseDetail
          });

          renderWhiteoutStatus();
          renderPartyUI();
          updateRightColumnForGraveView();
        });

        row.appendChild(select);
        row.appendChild(button);
        panel.appendChild(row);
        container.appendChild(panel);
      }

      function chooseWhiteout(ev, subchoiceId) {
        // Save selection
        saveWhiteoutChoice({
          id: ev.id,
          title: ev.title,
          legend: ev.legend,
          flavor: ev.flavor,
          effect: ev.effect,
          subchoiceId: subchoiceId || null,
          chosenAt: new Date().toISOString()
        });

        // Apply implemented effects
        if (ev.id === 'alternate_timeline') {
          applyWhiteoutAlternateTimeline();
          recordHistory({
            kind: 'event',
            title: 'Whiteout resolved - The Alternate Timeline',
            detail: 'Dialga preserved your active party, sent everything else to the Graveyard, and pulled one hero from another timeline as The Comeback Kid.'
          });
        } else if (ev.id === 'inversion_world') {
          applyWhiteoutInversionWorld();
          recordHistory({
            kind: 'event',
            title: 'Whiteout resolved - The Inversion World',
            detail: 'Giratina inverted life and death: the Graveyard rose into the Box; everything else fell.'
          });
        } else if (ev.id === 'sacred_rebirth') {
          applyWhiteoutSacredRebirth();
          recordHistory({
            kind: 'event',
            title: 'Whiteout resolved - Sacred Rebirth',
            detail: 'Ho-Oh revived every fallen Pokémon. Sacred Rebirth is now active: Pokémon faints grant +1 Dice Roll, and no new Pokémon may be caught.'
          });
        } else if (ev.id === 'birdgod_champion') {
          recordHistory({
            kind: 'event',
            title: 'Whiteout selected - Champion of the Flock',
            detail:
              "BirdGOD has chosen to intervene. Move any eligible fallen Pokémon into the Graveyard, then choose BirdGOD's Champion from the Whiteout box."
          });
        } else if (ev.id === 'judgment') {
          const judgmentResult = applyWhiteoutJudgment();
          const survivorCount =
            judgmentResult?.survivorCount ?? 0;
          const blessingCount =
            judgmentResult?.blessingCount ?? 0;
          const survivorText = survivorCount === 1
            ? '1 Pokémon'
            : `${survivorCount} Pokémon`;

          recordHistory({
            kind: 'event',
            title: 'Whiteout resolved - Judgment',
            detail:
              `Arceus deemed ${survivorText} worthy. ` +
              'The worthy were restored to your active team, all others were erased, and every active or locked-slot curse was cleared. Soul Links remain. ' +
              `Arceus also granted ${blessingCount} Dice Roll blessings, excluding The Comeback Kid.`
          });
        } else if (ev.id === 'final_wish') {
          applyWhiteoutFinalWish(subchoiceId);

          const finalWishLabel =
            getFinalWishChoiceLabel(subchoiceId) || 'Unknown wish';

          recordHistory({
            kind: 'event',
            title: 'Whiteout resolved - The Final Wish',
            detail: `Jirachi removed all effects and your dice rolls. Wish chosen: ${finalWishLabel}.`
          });
        } else if (ev.id === 'nightmare_bargain') {
          applyWhiteoutNightmareBargain();

          recordHistory({
            kind: 'event',
            title: 'Whiteout resolved - Nightmare Bargain',
            detail: 'Darkrai restored your pre-whiteout party state, then cursed you with a permanent locked slot and a triple soul link.'
          });
        } else {
          // TODO: Implement the remaining Whiteout outcome behavior.
          recordHistory({
            kind: 'event',
            title: 'Whiteout choice made',
            detail: `${ev.title}${subchoiceId ? ` (${subchoiceId})` : ''} (Effect not implemented yet)`
          });
        }

        // Return to graveyard view
        setTopMode('party');
        partyViewMode = 'grave';
        applyPartyViewMode();
      }

      function renderWhiteoutStatus() {
        if (!WHITEOUT_STATUS || !WHITEOUT_BTN) return;

        const chosen = loadWhiteoutChoice();
        if (WHITEOUT_INTRO) WHITEOUT_INTRO.hidden = !!chosen;

        WHITEOUT_STATUS.innerHTML = '';

        if (!chosen) {
          // No choice yet
          WHITEOUT_BTN.hidden = false;
          if (WHITEOUT_CLEAR_BTN) WHITEOUT_CLEAR_BTN.hidden = true;
          return;
        }

        WHITEOUT_BTN.hidden = true;
        if (WHITEOUT_CLEAR_BTN) WHITEOUT_CLEAR_BTN.hidden = false;

        const wrap = document.createElement('div');
        wrap.className = 'dl-effects-empty dl-whiteout-status-card';
        wrap.dataset.interventionId = chosen.id;
        wrap.style.opacity = '1';
        wrap.style.padding = '10px';
        wrap.style.borderRadius = '12px';

        const title = document.createElement('div');
        title.style.fontWeight = '800';
        title.style.marginBottom = '6px';
        title.textContent = `Chosen: ${chosen.title} — ${chosen.legend}`;

        const flavor = document.createElement('div');
        flavor.style.marginBottom = '6px';
        flavor.textContent = chosen.flavor;

        const eff = document.createElement('div');
        eff.style.opacity = '0.9';
        eff.textContent = chosen.effect;

        wrap.appendChild(title);
        wrap.appendChild(flavor);
        wrap.appendChild(eff);

        const oneUseReminder = document.createElement('div');
        oneUseReminder.style.marginTop = '8px';
        oneUseReminder.style.fontWeight = '800';
        oneUseReminder.textContent =
          'Your one Legendary Intervention has been used. The next whiteout is game over.';
        wrap.appendChild(oneUseReminder);

        if (chosen.id === 'final_wish') {
          const wishLabel = getFinalWishChoiceLabel(chosen.subchoiceId);

          if (wishLabel) {
            const chosenWish = document.createElement('div');
            chosenWish.style.marginTop = '8px';
            chosenWish.style.fontWeight = '800';
            chosenWish.textContent = `Wish chosen: ${wishLabel}.`;
            wrap.appendChild(chosenWish);
          }
        }


        if (chosen.id === 'birdgod_champion') {
          renderBirdGodChampionSelector(wrap, chosen);
        }

        WHITEOUT_STATUS.appendChild(wrap);
      }

      // --- Roll feedback ---
      let isRolling = false;
      let rollFeedbackTimer = null;

      function replayFeedbackClass(element, className) {
        if (!element) return;

        element.classList.remove(className);

        // Force a reflow so repeated results replay the same animation.
        void element.offsetWidth;

        element.classList.add(className);
      }

      function createRollParticleBurst(tone) {
        if (
          prefersRM ||
          !HERO_WRAPPER ||
          (tone !== 'nat1' && tone !== 'nat20')
        ) {
          return;
        }

        const stage =
          HERO_WRAPPER.querySelector('.dl-hero--standalone');

        if (!stage) return;

        stage
          .querySelectorAll('.dl-roll-particle-burst')
          .forEach(element => element.remove());

        const burst = document.createElement('div');
        burst.className =
          `dl-roll-particle-burst dl-roll-particle-burst--${tone}`;
        burst.setAttribute('aria-hidden', 'true');

        const isNat20 = tone === 'nat20';
        const colors = isNat20
          ? ['#facc15', '#fde68a', '#ffffff', '#fb923c']
          : ['#ef4444', '#fca5a5', '#7f1d1d', '#111827'];
        const count = isNat20 ? 20 : 12;

        for (let index = 0; index < count; index++) {
          const particle = document.createElement('span');
          particle.className = 'dl-roll-particle';

          const angle =
            ((Math.PI * 2) / count) * index +
            ((index % 3) * 0.08);
          const distance =
            (isNat20 ? 86 : 64) +
            ((index % 5) * 7);
          const x = Math.cos(angle) * distance;
          const y = Math.sin(angle) * distance;

          particle.style.setProperty(
            '--dl-particle-x',
            `${x.toFixed(1)}px`
          );
          particle.style.setProperty(
            '--dl-particle-y',
            `${y.toFixed(1)}px`
          );
          particle.style.setProperty(
            '--dl-particle-rotation',
            `${180 + (index * 47)}deg`
          );
          particle.style.setProperty(
            '--dl-particle-delay',
            `${(index % 4) * 18}ms`
          );
          particle.style.setProperty(
            '--dl-particle-size',
            `${isNat20 ? 6 + (index % 4) : 5 + (index % 3)}px`
          );
          particle.style.setProperty(
            '--dl-particle-radius',
            isNat20 && index % 3 === 0
              ? '999px'
              : '2px'
          );
          particle.style.setProperty(
            '--dl-particle-color',
            colors[index % colors.length]
          );

          burst.appendChild(particle);
        }

        stage.appendChild(burst);

        window.setTimeout(() => {
          burst.remove();
        }, 1150);
      }

      function triggerRollFeedback(
        value,
        {
          hasBlessing = false,
          hasCurse = false,
          shieldUsed = false
        } = {}
      ) {
        const tone =
          value === 20
            ? 'nat20'
            : value === 1
              ? 'nat1'
              : 'normal';
        const stage =
          HERO_WRAPPER?.querySelector('.dl-hero--standalone');

        if (rollFeedbackTimer) {
          window.clearTimeout(rollFeedbackTimer);
        }

        if (HERO_FACE) {
          [
            'dl-roll-feedback--normal',
            'dl-roll-feedback--nat1',
            'dl-roll-feedback--nat20'
          ].forEach(className =>
            HERO_FACE.classList.remove(className)
          );

          replayFeedbackClass(
            HERO_FACE,
            `dl-roll-feedback--${tone}`
          );
        }

        if (stage) {
          stage
            .querySelectorAll('.dl-roll-feedback-badge')
            .forEach(element => element.remove());

          const badge = document.createElement('div');
          badge.className =
            `dl-roll-feedback-badge ` +
            `dl-roll-feedback-badge--${tone}`;
          badge.setAttribute('role', 'status');
          badge.setAttribute('aria-live', 'polite');
          badge.textContent =
            value === 20
              ? 'Natural 20!'
              : value === 1
                ? 'Natural 1!'
                : `Rolled ${value}`;

          stage.appendChild(badge);

          requestAnimationFrame(() => {
            badge.classList.add('is-visible');
          });
        }

        const blessingBox =
          EFFECTS_BONUS?.closest('.dl-box-effects');
        const curseBox =
          EFFECTS_MALUS?.closest('.dl-box-effects');

        if (hasBlessing) {
          replayFeedbackClass(
            blessingBox,
            'dl-effect-flash--bonus'
          );
        }

        if (hasCurse) {
          replayFeedbackClass(
            curseBox,
            'dl-effect-flash--curse'
          );
        }

        if (shieldUsed) {
          replayFeedbackClass(
            SHIELDS_CONTAINER,
            'dl-shield-feedback'
          );
        }

        createRollParticleBurst(tone);

        if ('vibrate' in navigator) {
          try {
            if (value === 20) {
              navigator.vibrate([20, 35, 35]);
            } else if (value === 1) {
              navigator.vibrate([55, 30, 55]);
            }
          } catch (_) {}
        }

        rollFeedbackTimer = window.setTimeout(() => {
          if (HERO_FACE) {
            HERO_FACE.classList.remove(
              'dl-roll-feedback--normal',
              'dl-roll-feedback--nat1',
              'dl-roll-feedback--nat20'
            );
          }

          EFFECTS_BONUS
            ?.closest('.dl-box-effects')
            ?.classList.remove('dl-effect-flash--bonus');
          EFFECTS_MALUS
            ?.closest('.dl-box-effects')
            ?.classList.remove('dl-effect-flash--curse');
          SHIELDS_CONTAINER
            ?.classList.remove('dl-shield-feedback');

          stage
            ?.querySelectorAll('.dl-roll-feedback-badge')
            .forEach(element => element.remove());
        }, prefersRM ? 850 : 1250);
      }

      // --- Roll logic ---
      function performRoll() {
        if (isRolling) {
          return;
        }

        if (diceRolls <= 0) {
          if (HERO_BTN) {
            HERO_BTN.classList.add('dl-no-rolls');
            setTimeout(() => HERO_BTN.classList.remove('dl-no-rolls'), 300);
          }
          return;
        }

        isRolling = true;

        // Spend 1 Dicelocke roll
        setStoredRolls(diceRolls - 1);

        const value = randD20();

        if (HERO_BTN) {
          HERO_BTN.classList.add('rolling');
          HERO_BTN.classList.remove('dl-floating');
          HERO_BTN.setAttribute('aria-busy', 'true');

          if ('vibrate' in navigator) {
            try { navigator.vibrate(15); } catch (_) {}
          }
        }

        const finish = () => {
          renderHeroFace(value);

          const mapping = mapRollToEffects(value);
          let feedbackHasBlessing = false;
          let feedbackHasCurse = false;
          let feedbackShieldUsed = false;

          if (mapping) {
            if (mapping.extraRolls && mapping.extraRolls > 0) {
              setStoredRolls(diceRolls + mapping.extraRolls);
            }

            // Start with full mapping
            let blessings = mapping.blessing || [];
            let curses = mapping.curse || [];
            let shieldUsed = false;

            // When a shield is available, block all Curses from the roll
            if (shieldCount > 0 && curses.length > 0) {
              shieldUsed = true;
              setStoredShields(shieldCount - 1); // this also rerenders the HUD
              curses = [];                      // curses eaten by the shield
            }

            const now = new Date();
            const label = `Gained at ${now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

            const effectsToAdd = [];

            // Blessings
            blessings.forEach(b => {
              const eff = {
                id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
                kind: 'bonus',
                roll: value,
                title: b.title,
                text: b.text,
                timeLabel: label,
                applyKind: b.applyKind || null
              };
              effectsToAdd.push(eff);
            });

            // Curses (only if not shielded)
            curses.forEach(m => {
              const eff = {
                id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
                kind: 'malus',
                roll: value,
                title: m.title,
                text: m.text,
                timeLabel: label,
                applyKind: m.applyKind || null
              };

              if (m.applyKind === 'teamChoice') {
                applyGeneratedTeamChoicesToEffect(
                  eff,
                  generateTeamChoiceTeams()
                );
              }

              effectsToAdd.push(eff);
            });

            addEffects(effectsToAdd);

            feedbackHasBlessing = blessings.length > 0;
            feedbackHasCurse = curses.length > 0;
            feedbackShieldUsed = shieldUsed;

            const bonusTitles = blessings.map(b => b.title).join(', ');
            const malusTitles = curses.map(m => m.title).join(', ');

            const parts = [];
            if (bonusTitles) parts.push('Blessings: ' + bonusTitles);
            if (malusTitles) parts.push('Curses: ' + malusTitles);
            if (mapping.extraRolls) parts.push(`Extra rolls: +${mapping.extraRolls}`);
            if (shieldUsed) parts.push('Shield: blocked curse');

            const detail = parts.length ? parts.join(' | ') : 'No additional effects.';

            recordHistory({
              kind: 'roll',
              roll: value,
              title: `Rolled a ${value}`,
              detail: detail
            });
          }

          triggerRollFeedback(
            value,
            {
              hasBlessing: feedbackHasBlessing,
              hasCurse: feedbackHasCurse,
              shieldUsed: feedbackShieldUsed
            }
          );

          isRolling = false;

          if (HERO_BTN) {
            HERO_BTN.classList.remove('rolling');
            HERO_BTN.classList.add('dl-floating');
            HERO_BTN.removeAttribute('aria-busy');

            const hint = HERO_BTN.querySelector('.dl-hero-hint');
            if (hint && hint.firstChild) {
              hint.firstChild.textContent = 'Tap to roll ';
            }
          }
        };

        setTimeout(finish, prefersRM ? 0 : 550);
      }

      // --- Events ---
      if (HERO_BTN) {
        HERO_BTN.addEventListener('click', performRoll);
        HERO_BTN.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            performRoll();
          }
        });
      }

      if (CINEMATIC_MODE_BTN) {
        CINEMATIC_MODE_BTN.addEventListener(
          'click',
          enterCinematicMode
        );
      }

      if (CINEMATIC_EXIT_BTN) {
        CINEMATIC_EXIT_BTN.addEventListener(
          'click',
          () => {
            exitCinematicMode();
          }
        );
      }

      if (ROLLS_INC) {
        ROLLS_INC.addEventListener('click', () => {
          setStoredRolls(diceRolls + 1);
        });
      }
      if (ROLLS_DEC) {
        ROLLS_DEC.addEventListener('click', () => {
          setStoredRolls(diceRolls - 1);
        });
      }

      if (RESET_BTN) {
        RESET_BTN.addEventListener('click', () => {
          showRollerDialog({
            title: 'Reset the Dicelocke roller?',
            message:
              'This clears your dice rolls, shields, active effects, party, boxed Pokémon, graveyard, locked slots, Soul Links, Whiteout result, and history.',
            confirmText: 'Reset everything',
            cancelText: 'Keep my run',
            tone: 'danger',
            onConfirm: resetAll
          });
        });
      }

      if (TOGGLE_RULES_BTN) {
        TOGGLE_RULES_BTN.addEventListener('click', () => {
          if (topMode === 'rules') {
            setTopMode('hero');
          } else {
            setTopMode('rules');
          }
        });
      }

      if (MANAGE_BTN) {
        MANAGE_BTN.addEventListener('click', () => {
          if (topMode === 'party') {
            setTopMode('hero');
          } else {
            setTopMode('party');
          }
        });
      }

      if (UNLOCK_SLOTS_BTN) {
        UNLOCK_SLOTS_BTN.addEventListener('click', () => {
          const hasUnlockableLock = lockedSlots.some(
            (isLocked, index) =>
              isLocked && !permaLockedSlots[index]
          );
          if (!hasUnlockableLock) return;

          // Clear ONLY non-permanent locks
          const cleared = lockedSlots.map((_, i) => !!permaLockedSlots[i]); // keep perma true
          lockedSlotNames = lockedSlotNames.map((_, i) => (permaLockedSlots[i] ? lockedSlotNames[i] : null));
          saveLockedSlotNames();
          setLockedSlots(cleared);

          recordHistory({
            kind: 'event',
            title: 'Unlocked team slots',
            detail: 'All boxed team slots were unlocked after completing a gym.'
          });
        });
      }

      if (VIEW_BOX_BTN) {
        VIEW_BOX_BTN.addEventListener('click', () => {
          partyViewMode = 'box';
          applyPartyViewMode();
        });
      }

      if (VIEW_TEAM_BTN) {
        VIEW_TEAM_BTN.addEventListener('click', () => {
          partyViewMode = 'team';
          applyPartyViewMode();
        });
      }

      if (TOGGLE_HISTORY_BTN) {
        TOGGLE_HISTORY_BTN.addEventListener('click', () => {
          if (topMode === 'history') {
            setTopMode('hero');
          } else {
            setTopMode('history');
          }
        });
      }

      if (WHITEOUT_BTN) {
        WHITEOUT_BTN.addEventListener('click', () => {
          setTopMode('whiteout');
          renderWhiteoutChooser();
        });
      }

      // Dormant while the test-only Whiteout clear button is commented out.
      if (WHITEOUT_CLEAR_BTN) {
        WHITEOUT_CLEAR_BTN.addEventListener('click', () => {
          clearWhiteoutChoice();
          // Remain in grave view after clearing the test state
          setTopMode('party');
          partyViewMode = 'grave';
          applyPartyViewMode();
        });
      }

      // --- Init ---
      initSwatches();
      renderHeroFace(20);
      updateSacredRebirthUI();
      updateWhiteoutInterventionTheme();
      loadPokemons();
      renderEffects();
      renderHistory();
      renderWhiteoutStatus();
      setStoredRolls(getStoredRolls());
      setStoredShields(getStoredShields());
      setTopMode('hero');
      loadLockedSlots();
      loadSoulLinks();
      updateUnlockButtonState();
    })();
